import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: { input: Date; output: Date; }
  /** A datetime and timezone string in ISO 8601 format `Y-m-dTH:i:sO`, e.g. `2020-04-20T13:53:12+02:00`. */
  DateTimeTz: { input: any; output: any; }
  /** A hashed ID. */
  Hashid: { input: string; output: string; }
  /** A JSON object. */
  JSON: { input: any; output: any; }
};

export type Activity = {
  __typename: 'Activity';
  content?: Maybe<ActivityContentType>;
  createdAt: Scalars['DateTimeTz']['output'];
  id: Scalars['ID']['output'];
  model: ActivityModel;
  previousContent?: Maybe<ActivityContentType>;
  previousValue?: Maybe<Scalars['String']['output']>;
  task: Task;
  tempId?: Maybe<Scalars['String']['output']>;
  type: ActivityType;
  user?: Maybe<User>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityContentType = Comment | Product | Status | Update;

export type ActivityModel = Idea | Task;

export const ActivityType = {
  commentAdded: 'commentAdded',
  created: 'created',
  updateAdded: 'updateAdded',
  updatedEffort: 'updatedEffort',
  updatedName: 'updatedName',
  updatedProduct: 'updatedProduct',
  updatedStatus: 'updatedStatus',
  updatedTimeFrame: 'updatedTimeFrame',
  updatedValue: 'updatedValue'
} as const;

export type ActivityType = typeof ActivityType[keyof typeof ActivityType];
export type AddDeliveryItemInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  taskId: Scalars['Hashid']['input'];
  url: Scalars['String']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type AddDependencyInput = {
  fromFeatureId: Scalars['Hashid']['input'];
  toFeatureId: Scalars['Hashid']['input'];
  type?: InputMaybe<DependencyType>;
  workspaceId: Scalars['Hashid']['input'];
};

export type AddFeatureCommentInput = {
  body: Scalars['JSON']['input'];
  featureId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type AddFeatureUpdateInput = {
  body: Scalars['JSON']['input'];
  end?: InputMaybe<Scalars['Date']['input']>;
  featureId: Scalars['Hashid']['input'];
  granularity?: InputMaybe<DateGranularity>;
  start?: InputMaybe<Scalars['Date']['input']>;
  statusId?: InputMaybe<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type AddIdeaCommentInput = {
  body: Scalars['JSON']['input'];
  ideaId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type AddObjectiveFeatureInput = {
  featureId: Scalars['Hashid']['input'];
  objectiveId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type AddObjectiveUpdateInput = {
  body: Scalars['JSON']['input'];
  end?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<DateGranularity>;
  objectiveId: Scalars['Hashid']['input'];
  start?: InputMaybe<Scalars['Date']['input']>;
  statusId?: InputMaybe<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type AddTeamFeatureInput = {
  featureId: Scalars['Hashid']['input'];
  teamId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type AuthPayload = {
  __typename: 'AuthPayload';
  token: Scalars['String']['output'];
  user: User;
};

export type BillingSubscription = {
  __typename: 'BillingSubscription';
  active: Scalars['Boolean']['output'];
  cancelled?: Maybe<Scalars['Boolean']['output']>;
  monthlySpend?: Maybe<Scalars['Int']['output']>;
  onGenericTrial: Scalars['Boolean']['output'];
  onGracePeriod?: Maybe<Scalars['Boolean']['output']>;
  onTrial: Scalars['Boolean']['output'];
  pastDue?: Maybe<Scalars['Boolean']['output']>;
  planId?: Maybe<Scalars['String']['output']>;
  subscribed: Scalars['Boolean']['output'];
  subscriptionEnded?: Maybe<Scalars['Boolean']['output']>;
  subscriptionEndsAt?: Maybe<Scalars['DateTimeTz']['output']>;
  trialEndsAt?: Maybe<Scalars['DateTimeTz']['output']>;
};

export type BulkCreateFeaturesInput = {
  features: Array<BulkFeature>;
  workspaceId: Scalars['Hashid']['input'];
};

export type BulkFeature = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CancelWorkspaceSubscriptionInput = {
  workspaceId: Scalars['Hashid']['input'];
};

export type Comment = {
  __typename: 'Comment';
  body: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeTz']['output'];
  id: Scalars['Hashid']['output'];
  target: Task;
  updatedAt: Scalars['DateTimeTz']['output'];
  user: User;
};

export type ConnectJiraProjectInput = {
  jiraProjectId: Scalars['String']['input'];
  jiraResourceId: Scalars['Hashid']['input'];
  statusSyncConfig?: InputMaybe<Scalars['JSON']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type ConnectedJiraProject = {
  __typename: 'ConnectedJiraProject';
  allStatuses: Array<JiraStatus>;
  id: Scalars['Hashid']['output'];
  jiraId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  statusSyncConfig?: Maybe<Array<Maybe<JiraStatusSyncConfig>>>;
};

export type ConnectedJiraResource = {
  __typename: 'ConnectedJiraResource';
  allProjects: Array<JiraProject>;
  connectedProjects: Array<ConnectedJiraProject>;
  id: Scalars['Hashid']['output'];
  url: Scalars['String']['output'];
};

export type Contact = {
  __typename: 'Contact';
  domain?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Hashid']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Contact>;
  segment?: Maybe<Segment>;
  type: ContactType;
};

export const ContactType = {
  company: 'company',
  person: 'person'
} as const;

export type ContactType = typeof ContactType[keyof typeof ContactType];
export type CreateContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateFeatureInput = {
  name: Scalars['String']['input'];
  product: UpsertProductInput;
  statusId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateFeedbackInsightForIdeaInput = {
  contact?: InputMaybe<UpsertContactInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  ideaId: Scalars['Hashid']['input'];
  importanceId: Scalars['Hashid']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateIdeaInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  fields?: InputMaybe<Array<IdeaFieldInput>>;
  name: Scalars['String']['input'];
  product?: InputMaybe<UpsertProductInput>;
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateKeyResultInput = {
  name: Scalars['String']['input'];
  objectiveId: Scalars['Hashid']['input'];
  startValue?: InputMaybe<Scalars['Float']['input']>;
  targetValue: Scalars['Float']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateMilestoneInput = {
  date: Scalars['Date']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateObjectiveInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type CreatePlatformInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateProductBelongsTo = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateProductInput>;
};

export type CreateProductInput = {
  name: Scalars['String']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateStatusInput = {
  color: Scalars['String']['input'];
  name: Scalars['String']['input'];
  stage: StatusStage;
  type: StatusType;
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateTaskInput = {
  name: Scalars['String']['input'];
  product?: InputMaybe<CreateProductBelongsTo>;
  status: Scalars['String']['input'];
};

export type CreateTeamInput = {
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['JSON']['input']>;
  memberIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  name: Scalars['String']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type CreateWorkspaceInput = {
  domains?: InputMaybe<Array<WorkspaceDomainInput>>;
  name: Scalars['String']['input'];
};

export const DateGranularity = {
  day: 'day',
  month: 'month',
  quarter: 'quarter',
  week: 'week',
  year: 'year'
} as const;

export type DateGranularity = typeof DateGranularity[keyof typeof DateGranularity];
export type DeleteConnectedJiraProjectInput = {
  jiraProjectId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteConnectedJiraResourceInput = {
  jiraResourceId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteDeliveryItemInput = {
  deliveryItemId: Scalars['Hashid']['input'];
  taskId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteFeaturesInput = {
  featureIds: Array<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteFeaturesPayload = {
  __typename: 'DeleteFeaturesPayload';
  deletedIds?: Maybe<Array<Scalars['Hashid']['output']>>;
};

export type DeleteIdeaInsightInput = {
  ideaId: Scalars['Hashid']['input'];
  insightId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteIdeasInput = {
  ideaIds: Array<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteIdeasPayload = {
  __typename: 'DeleteIdeasPayload';
  deletedIds?: Maybe<Array<Scalars['Hashid']['output']>>;
};

export type DeleteInvitationInput = {
  email: Scalars['String']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteKeyResultInput = {
  keyResultId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteKeyResultPayload = {
  __typename: 'DeleteKeyResultPayload';
  objective: Objective;
};

export type DeleteKeyResultValueInput = {
  keyResultId: Scalars['Hashid']['input'];
  keyResultValueId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteMemberInput = {
  userId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteMilestoneInput = {
  milestoneId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteObjectiveInput = {
  objectiveId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeletePlatformInput = {
  platformId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteProductInput = {
  productId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteStatusInput = {
  newStatusId?: InputMaybe<Scalars['Hashid']['input']>;
  statusId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeleteTeamInput = {
  teamId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type DeletedPayload = {
  __typename: 'DeletedPayload';
  ok: Scalars['Boolean']['output'];
};

export type DeliveryItem = {
  __typename: 'DeliveryItem';
  id: Scalars['Hashid']['output'];
  jiraAttributes?: Maybe<JiraIssue>;
  name?: Maybe<Scalars['String']['output']>;
  service?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export const DependencyType = {
  blockedBy: 'blockedBy',
  blocks: 'blocks'
} as const;

export type DependencyType = typeof DependencyType[keyof typeof DependencyType];
export type DummyTask = {
  __typename: 'DummyTask';
  id: Scalars['Hashid']['output'];
  updates: UpdateConnection;
};


export type DummyTaskUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
};

export type FeedbackNote = {
  __typename: 'FeedbackNote';
  contact?: Maybe<Contact>;
  createdAt: Scalars['DateTimeTz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Hashid']['output'];
  reporter: User;
  subject?: Maybe<Scalars['String']['output']>;
};

export type Field = {
  __typename: 'Field';
  contentType: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Hashid']['output'];
  name: Scalars['String']['output'];
  options: Array<FieldOption>;
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  type: FieldType;
};

export type FieldOption = {
  __typename: 'FieldOption';
  id: Scalars['Hashid']['output'];
  value: Scalars['String']['output'];
};

export const FieldType = {
  editor: 'editor',
  select: 'select',
  text: 'text'
} as const;

export type FieldType = typeof FieldType[keyof typeof FieldType];
export type ForgotPasswordInput = {
  email: Scalars['String']['input'];
};

export type ForgotPasswordPayload = {
  __typename: 'ForgotPasswordPayload';
  success: Scalars['Boolean']['output'];
};

export type Formula = {
  __typename: 'Formula';
  description?: Maybe<Scalars['JSON']['output']>;
  expression?: Maybe<Scalars['String']['output']>;
  fields: Array<FormulaField>;
  id: Scalars['Hashid']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FormulaField = {
  __typename: 'FormulaField';
  id: Scalars['Hashid']['output'];
  key: Scalars['String']['output'];
  meta?: Maybe<FormulaFieldMeta>;
  name: Scalars['String']['output'];
  type: FormulaFieldType;
};

export type FormulaFieldMeta = {
  __typename: 'FormulaFieldMeta';
  influence?: Maybe<RatingInfluence>;
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  values?: Maybe<Array<FormulaFieldValue>>;
};

export const FormulaFieldType = {
  number: 'number',
  percentage: 'percentage',
  rating: 'rating'
} as const;

export type FormulaFieldType = typeof FormulaFieldType[keyof typeof FormulaFieldType];
export type FormulaFieldValue = {
  __typename: 'FormulaFieldValue';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type FormulaValueInput = {
  fieldKey: Scalars['String']['input'];
  fieldValue: Scalars['Float']['input'];
  formulaKey: Scalars['String']['input'];
};

export type Idea = {
  __typename: 'Idea';
  activity: Array<Activity>;
  dependencies: Array<Task>;
  description?: Maybe<Scalars['JSON']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  endorsementsCount: Scalars['Int']['output'];
  endorsers: Array<User>;
  fields?: Maybe<Array<IdeaField>>;
  followers: Array<User>;
  formulaValues?: Maybe<Scalars['JSON']['output']>;
  granularity?: Maybe<DateGranularity>;
  id: Scalars['Hashid']['output'];
  insights: InsightConnection;
  insightsScore: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  objectives: Array<Objective>;
  platforms: Array<Platform>;
  position: Scalars['Int']['output'];
  product?: Maybe<Product>;
  reporter?: Maybe<User>;
  score?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  status: Status;
  teams: Array<Team>;
  updates: UpdateConnection;
  veEffort?: Maybe<Scalars['Int']['output']>;
  veScore?: Maybe<Scalars['Int']['output']>;
  veValue?: Maybe<Scalars['Int']['output']>;
  workspace: Workspace;
};


export type IdeaInsightsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type IdeaField = {
  __typename: 'IdeaField';
  field: Field;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type IdeaFieldInput = {
  fieldId: Scalars['Hashid']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Importance = {
  __typename: 'Importance';
  color?: Maybe<Scalars['String']['output']>;
  default: Scalars['Boolean']['output'];
  id: Scalars['Hashid']['output'];
  score: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type Insight = {
  __typename: 'Insight';
  feedbackNote: FeedbackNote;
  id: Scalars['Hashid']['output'];
  importance?: Maybe<Importance>;
};

/** A paginated list of Insight edges. */
export type InsightConnection = {
  __typename: 'InsightConnection';
  /** A list of Insight edges. */
  edges: Array<InsightEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Insight and a cursor. */
export type InsightEdge = {
  __typename: 'InsightEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Insight node. */
  node: Insight;
};

export type Invitation = {
  __typename: 'Invitation';
  createdAt: Scalars['DateTimeTz']['output'];
  email: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeTz']['output'];
};

export type InviteMembersInput = {
  emails: Array<Scalars['String']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type InviteMembersPayload = {
  __typename: 'InviteMembersPayload';
  invites: Array<Invitation>;
};

export type JiraIssue = {
  __typename: 'JiraIssue';
  key?: Maybe<Scalars['String']['output']>;
  status: JiraStatus;
  summary?: Maybe<Scalars['String']['output']>;
};

export type JiraProject = {
  __typename: 'JiraProject';
  allStatuses: Array<JiraStatus>;
  id?: Maybe<Scalars['String']['output']>;
  isPrivate?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectTypeKey?: Maybe<Scalars['String']['output']>;
  simplified?: Maybe<Scalars['Boolean']['output']>;
  style?: Maybe<Scalars['String']['output']>;
};

export type JiraStatus = {
  __typename: 'JiraStatus';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  statusCategory?: Maybe<JiraStatusCategory>;
};

export type JiraStatusCategory = {
  __typename: 'JiraStatusCategory';
  key?: Maybe<JiraStatusCategoryKey>;
};

export const JiraStatusCategoryKey = {
  done: 'done',
  indeterminate: 'indeterminate',
  new: 'new'
} as const;

export type JiraStatusCategoryKey = typeof JiraStatusCategoryKey[keyof typeof JiraStatusCategoryKey];
export type JiraStatusSyncConfig = {
  __typename: 'JiraStatusSyncConfig';
  jiraIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  wayplanId?: Maybe<Scalars['String']['output']>;
};

export type KeyResult = {
  __typename: 'KeyResult';
  allValues: Array<KeyResultValue>;
  currentValue?: Maybe<KeyResultValue>;
  id: Scalars['Hashid']['output'];
  metricGoal: MetricGoal;
  metricType: MetricType;
  name: Scalars['String']['output'];
  objective: Objective;
  startValue: Scalars['Float']['output'];
  status?: Maybe<Status>;
  targetValue: Scalars['Float']['output'];
  values: Array<KeyResultValue>;
};

export type KeyResultValue = {
  __typename: 'KeyResultValue';
  date: Scalars['Date']['output'];
  id: Scalars['Hashid']['output'];
  keyResult: KeyResult;
  value: Scalars['Float']['output'];
};

export type MarkNotificationsReadInput = {
  featureId?: InputMaybe<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type MarkNotificationsSeenInput = {
  workspaceId: Scalars['Hashid']['input'];
};

export const MemberRole = {
  admin: 'ADMIN',
  editor: 'EDITOR',
  viewer: 'VIEWER'
} as const;

export type MemberRole = typeof MemberRole[keyof typeof MemberRole];
export const MetricGoal = {
  decrease: 'decrease',
  increase: 'increase',
  reach: 'reach'
} as const;

export type MetricGoal = typeof MetricGoal[keyof typeof MetricGoal];
export const MetricType = {
  number: 'number',
  percentage: 'percentage'
} as const;

export type MetricType = typeof MetricType[keyof typeof MetricType];
export type Milestone = {
  __typename: 'Milestone';
  date?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Hashid']['output'];
  name: Scalars['String']['output'];
  workspace: Workspace;
};

export type Mutation = {
  __typename: 'Mutation';
  addDeliveryItem: Task;
  addDependency: Task;
  addFeatureComment: Activity;
  addFeatureUpdate: Task;
  addIdeaComment: Activity;
  addObjectiveFeature: Objective;
  addObjectiveUpdate: Objective;
  addTeamFeature: Team;
  bulkCreateFeatures: Array<Task>;
  cancelWorkspaceSubscription: Workspace;
  connectJiraProject: Workspace;
  createContact: Contact;
  createFeature: Task;
  createFeedbackInsightForIdea: Idea;
  createIdea: Idea;
  createKeyResult: Objective;
  createMilestone: Milestone;
  createObjective: Objective;
  createPlatform: Workspace;
  createProduct: Product;
  createStatus: Workspace;
  createTask?: Maybe<Task>;
  createTeam: Team;
  createWorkspace: Workspace;
  deleteConnectedJiraProject: Workspace;
  deleteConnectedJiraResource: Workspace;
  deleteDeliveryItem: Task;
  deleteFeatures?: Maybe<DeleteFeaturesPayload>;
  deleteIdeaInsight: Idea;
  deleteIdeas?: Maybe<DeleteIdeasPayload>;
  deleteInvitation: Workspace;
  deleteKeyResult?: Maybe<DeleteKeyResultPayload>;
  deleteKeyResultValue: KeyResult;
  deleteMember: Workspace;
  deleteMilestone: Workspace;
  deleteObjective: Workspace;
  deletePlatform: Workspace;
  deleteProduct: Workspace;
  deleteStatus: Workspace;
  deleteTeam: Workspace;
  forgotPassword: ForgotPasswordPayload;
  inviteMembers: Workspace;
  login: AuthPayload;
  markNotificationsRead: Workspace;
  markNotificationsSeen: Workspace;
  removeDependency: Task;
  removeObjectiveFeature: Objective;
  removeTeamFeature: Team;
  resetPassword: AuthPayload;
  setFeatureFollowing: Task;
  setFeaturesStatus?: Maybe<SetFeaturesStatusPayload>;
  setFeaturesTimeFrame?: Maybe<SetFeaturesTimeFramePayload>;
  setIdeaEndorsing: Idea;
  setIdeaFollowing: Idea;
  setIdeasStatus?: Maybe<SetIdeasStatusPayload>;
  setKeyResultsStatus?: Maybe<SetKeyResultsStatusPayload>;
  setObjectivesStatus?: Maybe<SetObjectivesStatusPayload>;
  setObjectivesTimeFrame?: Maybe<SetObjectivesTimeFramePayload>;
  signup: SignupPayload;
  updateAccount: User;
  updateFeature: Task;
  updateIdea: Idea;
  updateIdeaInsight: Insight;
  updateJiraProject: Workspace;
  updateKeyResult: UpdateKeyResultPayload;
  updateKeyResultValue: UpdateKeyResultValuePayload;
  updateKeyResultValueById: KeyResult;
  updateMemberEmailNotifications: User;
  updateMemberRole: Workspace;
  updateMilestone: Milestone;
  updateObjective: Objective;
  updatePlatform: Array<Platform>;
  updateProduct: Product;
  updateStatus: Array<Status>;
  updateStatusPositions: Array<Status>;
  updateTeam: Team;
  updateWorkspace: Workspace;
  verifyEmail: SignupPayload;
};


export type MutationAddDeliveryItemArgs = {
  input: AddDeliveryItemInput;
};


export type MutationAddDependencyArgs = {
  input: AddDependencyInput;
};


export type MutationAddFeatureCommentArgs = {
  input: AddFeatureCommentInput;
};


export type MutationAddFeatureUpdateArgs = {
  input: AddFeatureUpdateInput;
};


export type MutationAddIdeaCommentArgs = {
  input: AddIdeaCommentInput;
};


export type MutationAddObjectiveFeatureArgs = {
  input: AddObjectiveFeatureInput;
};


export type MutationAddObjectiveUpdateArgs = {
  input: AddObjectiveUpdateInput;
};


export type MutationAddTeamFeatureArgs = {
  input: AddTeamFeatureInput;
};


export type MutationBulkCreateFeaturesArgs = {
  input: BulkCreateFeaturesInput;
};


export type MutationCancelWorkspaceSubscriptionArgs = {
  input: CancelWorkspaceSubscriptionInput;
};


export type MutationConnectJiraProjectArgs = {
  input: ConnectJiraProjectInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateFeatureArgs = {
  input: CreateFeatureInput;
};


export type MutationCreateFeedbackInsightForIdeaArgs = {
  input: CreateFeedbackInsightForIdeaInput;
};


export type MutationCreateIdeaArgs = {
  input: CreateIdeaInput;
};


export type MutationCreateKeyResultArgs = {
  input: CreateKeyResultInput;
};


export type MutationCreateMilestoneArgs = {
  input: CreateMilestoneInput;
};


export type MutationCreateObjectiveArgs = {
  input: CreateObjectiveInput;
};


export type MutationCreatePlatformArgs = {
  input: CreatePlatformInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateStatusArgs = {
  input: CreateStatusInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationDeleteConnectedJiraProjectArgs = {
  input: DeleteConnectedJiraProjectInput;
};


export type MutationDeleteConnectedJiraResourceArgs = {
  input: DeleteConnectedJiraResourceInput;
};


export type MutationDeleteDeliveryItemArgs = {
  input: DeleteDeliveryItemInput;
};


export type MutationDeleteFeaturesArgs = {
  input: DeleteFeaturesInput;
};


export type MutationDeleteIdeaInsightArgs = {
  input: DeleteIdeaInsightInput;
};


export type MutationDeleteIdeasArgs = {
  input: DeleteIdeasInput;
};


export type MutationDeleteInvitationArgs = {
  input: DeleteInvitationInput;
};


export type MutationDeleteKeyResultArgs = {
  input: DeleteKeyResultInput;
};


export type MutationDeleteKeyResultValueArgs = {
  input: DeleteKeyResultValueInput;
};


export type MutationDeleteMemberArgs = {
  input: DeleteMemberInput;
};


export type MutationDeleteMilestoneArgs = {
  input: DeleteMilestoneInput;
};


export type MutationDeleteObjectiveArgs = {
  input: DeleteObjectiveInput;
};


export type MutationDeletePlatformArgs = {
  input: DeletePlatformInput;
};


export type MutationDeleteProductArgs = {
  input: DeleteProductInput;
};


export type MutationDeleteStatusArgs = {
  input: DeleteStatusInput;
};


export type MutationDeleteTeamArgs = {
  input: DeleteTeamInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationInviteMembersArgs = {
  input: InviteMembersInput;
};


export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationMarkNotificationsReadArgs = {
  input: MarkNotificationsReadInput;
};


export type MutationMarkNotificationsSeenArgs = {
  input: MarkNotificationsSeenInput;
};


export type MutationRemoveDependencyArgs = {
  input: RemoveDependencyInput;
};


export type MutationRemoveObjectiveFeatureArgs = {
  input: RemoveObjectiveFeatureInput;
};


export type MutationRemoveTeamFeatureArgs = {
  input: RemoveTeamFeatureInput;
};


export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};


export type MutationSetFeatureFollowingArgs = {
  input: SetFeatureFollowingInput;
};


export type MutationSetFeaturesStatusArgs = {
  input: SetFeaturesStatusInput;
};


export type MutationSetFeaturesTimeFrameArgs = {
  input: SetFeaturesTimeFrameInput;
};


export type MutationSetIdeaEndorsingArgs = {
  input: SetIdeaEndorsingInput;
};


export type MutationSetIdeaFollowingArgs = {
  input: SetIdeaFollowingInput;
};


export type MutationSetIdeasStatusArgs = {
  input: SetIdeasStatusInput;
};


export type MutationSetKeyResultsStatusArgs = {
  input: SetKeyResultsStatusInput;
};


export type MutationSetObjectivesStatusArgs = {
  input: SetObjectivesStatusInput;
};


export type MutationSetObjectivesTimeFrameArgs = {
  input: SetObjectivesTimeFrameInput;
};


export type MutationSignupArgs = {
  input: SignupInput;
};


export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};


export type MutationUpdateFeatureArgs = {
  input: UpdateFeatureInput;
};


export type MutationUpdateIdeaArgs = {
  input: UpdateIdeaInput;
};


export type MutationUpdateIdeaInsightArgs = {
  input: UpdateIdeaInsightInput;
};


export type MutationUpdateJiraProjectArgs = {
  input: UpdateJiraProjectInput;
};


export type MutationUpdateKeyResultArgs = {
  input: UpdateKeyResultInput;
};


export type MutationUpdateKeyResultValueArgs = {
  input: UpdateKeyResultValueInput;
};


export type MutationUpdateKeyResultValueByIdArgs = {
  input?: InputMaybe<UpdateKeyResultValueByIdInput>;
};


export type MutationUpdateMemberEmailNotificationsArgs = {
  input: UpdateMemberEmailNotificationsInput;
};


export type MutationUpdateMemberRoleArgs = {
  input: UpdateMemberRoleInput;
};


export type MutationUpdateMilestoneArgs = {
  input: UpdateMilestoneInput;
};


export type MutationUpdateObjectiveArgs = {
  input: UpdateObjectiveInput;
};


export type MutationUpdatePlatformArgs = {
  input: UpdatePlatformInput;
};


export type MutationUpdateProductArgs = {
  input: UpdateProductInput;
};


export type MutationUpdateStatusArgs = {
  input: UpdateStatusInput;
};


export type MutationUpdateStatusPositionsArgs = {
  input: UpdateStatusPositionsInput;
};


export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
};


export type MutationUpdateWorkspaceArgs = {
  input: UpdateWorkspaceInput;
};


export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};

export type Notification = {
  __typename: 'Notification';
  author: User;
  content: Activity;
  createdAt: Scalars['DateTimeTz']['output'];
  id: Scalars['Hashid']['output'];
  readAt?: Maybe<Scalars['DateTimeTz']['output']>;
  seenAt?: Maybe<Scalars['DateTimeTz']['output']>;
  subject: Task;
  type: ActivityType;
  updatedAt: Scalars['DateTimeTz']['output'];
};

export type Objective = {
  __typename: 'Objective';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['JSON']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  granularity?: Maybe<DateGranularity>;
  id: Scalars['Hashid']['output'];
  keyResults: Array<KeyResult>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Hashid']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Status>;
  tasks: Array<Task>;
  teams: Array<Team>;
  updates: UpdateConnection;
};


export type ObjectiveUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export const OrderByRelationAggregateFunction = {
  /** Amount of items. */
  count: 'COUNT'
} as const;

export type OrderByRelationAggregateFunction = typeof OrderByRelationAggregateFunction[keyof typeof OrderByRelationAggregateFunction];
/** Aggregate functions when ordering by a relation that may specify a column. */
export const OrderByRelationWithColumnAggregateFunction = {
  /** Average. */
  avg: 'AVG',
  /** Amount of items. */
  count: 'COUNT',
  /** Maximum. */
  max: 'MAX',
  /** Minimum. */
  min: 'MIN',
  /** Sum. */
  sum: 'SUM'
} as const;

export type OrderByRelationWithColumnAggregateFunction = typeof OrderByRelationWithColumnAggregateFunction[keyof typeof OrderByRelationWithColumnAggregateFunction];
/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** Number of nodes in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int']['output'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int']['output'];
  /** Index of the current page. */
  currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  total: Scalars['Int']['output'];
};

export type Platform = {
  __typename: 'Platform';
  color: Scalars['String']['output'];
  id: Scalars['Hashid']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type Product = {
  __typename: 'Product';
  description?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Hashid']['output'];
  name: Scalars['String']['output'];
  tasks: Array<Task>;
};

export type Query = {
  __typename: 'Query';
  me?: Maybe<User>;
  user?: Maybe<User>;
  users: UserPaginator;
  workspace?: Maybe<Workspace>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type QueryUsersArgs = {
  first?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkspaceArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
  slug?: InputMaybe<Scalars['ID']['input']>;
};

export const RatingInfluence = {
  negative: 'negative',
  positive: 'positive'
} as const;

export type RatingInfluence = typeof RatingInfluence[keyof typeof RatingInfluence];
export type RemoveDependencyInput = {
  fromFeatureId: Scalars['Hashid']['input'];
  toFeatureId: Scalars['Hashid']['input'];
  type?: InputMaybe<DependencyType>;
  workspaceId: Scalars['Hashid']['input'];
};

export type RemoveObjectiveFeatureInput = {
  featureId: Scalars['Hashid']['input'];
  objectiveId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type RemoveTeamFeatureInput = {
  featureId: Scalars['Hashid']['input'];
  teamId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type Segment = {
  __typename: 'Segment';
  id: Scalars['Hashid']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  score: Scalars['Int']['output'];
};

export type SetFeatureFollowingInput = {
  enabled: Scalars['Boolean']['input'];
  featureId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type SetFeaturesStatusInput = {
  featureIds: Array<Scalars['Hashid']['input']>;
  statusId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type SetFeaturesStatusPayload = {
  __typename: 'SetFeaturesStatusPayload';
  features: Array<Task>;
};

export type SetFeaturesTimeFrameInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  featureIds: Array<Scalars['Hashid']['input']>;
  granularity?: InputMaybe<DateGranularity>;
  start?: InputMaybe<Scalars['Date']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type SetFeaturesTimeFramePayload = {
  __typename: 'SetFeaturesTimeFramePayload';
  features: Array<Task>;
};

export type SetIdeaEndorsingInput = {
  enabled: Scalars['Boolean']['input'];
  ideaId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type SetIdeaFollowingInput = {
  enabled: Scalars['Boolean']['input'];
  ideaId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type SetIdeasStatusInput = {
  ideaIds: Array<Scalars['Hashid']['input']>;
  statusId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type SetIdeasStatusPayload = {
  __typename: 'SetIdeasStatusPayload';
  ideas: Array<Idea>;
};

export type SetKeyResultsStatusInput = {
  keyResultIds: Array<Scalars['Hashid']['input']>;
  statusId?: InputMaybe<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type SetKeyResultsStatusPayload = {
  __typename: 'SetKeyResultsStatusPayload';
  keyResults: Array<KeyResult>;
};

export type SetObjectivesStatusInput = {
  objectiveIds: Array<Scalars['Hashid']['input']>;
  statusId?: InputMaybe<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type SetObjectivesStatusPayload = {
  __typename: 'SetObjectivesStatusPayload';
  objectives: Array<Objective>;
};

export type SetObjectivesTimeFrameInput = {
  end?: InputMaybe<Scalars['Date']['input']>;
  granularity?: InputMaybe<DateGranularity>;
  objectiveIds: Array<Scalars['Hashid']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type SetObjectivesTimeFramePayload = {
  __typename: 'SetObjectivesTimeFramePayload';
  objectives: Array<Objective>;
};

export type SignupInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type SignupPayload = {
  __typename: 'SignupPayload';
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  verification: UserVerificationStatus;
};

/** Directions for ordering a list of records. */
export const SortOrder = {
  /** Sort records in ascending order. */
  asc: 'ASC',
  /** Sort records in descending order. */
  desc: 'DESC'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type Status = {
  __typename: 'Status';
  color: Scalars['String']['output'];
  id: Scalars['Hashid']['output'];
  isDone: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  stage: StatusStage;
  type: StatusType;
};

export const StatusStage = {
  active: 'active',
  archived: 'archived',
  backlog: 'backlog',
  done: 'done'
} as const;

export type StatusStage = typeof StatusStage[keyof typeof StatusStage];
export const StatusType = {
  idea: 'idea',
  objective: 'objective',
  task: 'task'
} as const;

export type StatusType = typeof StatusType[keyof typeof StatusType];
export type Subscription = {
  __typename: 'Subscription';
  workspaceFeatureUpdated?: Maybe<Task>;
  workspaceIdeaUpdated?: Maybe<Idea>;
  workspaceUpdated?: Maybe<Workspace>;
};


export type SubscriptionWorkspaceFeatureUpdatedArgs = {
  workspaceId: Scalars['Hashid']['input'];
};


export type SubscriptionWorkspaceIdeaUpdatedArgs = {
  workspaceId: Scalars['Hashid']['input'];
};


export type SubscriptionWorkspaceUpdatedArgs = {
  workspaceId: Scalars['Hashid']['input'];
};

export type Task = {
  __typename: 'Task';
  activity: Array<Activity>;
  color?: Maybe<Scalars['String']['output']>;
  deliveryItems: Array<DeliveryItem>;
  dependencies: Array<Task>;
  dependentOn: Array<Task>;
  description?: Maybe<Scalars['JSON']['output']>;
  dragEnd?: Maybe<Scalars['Date']['output']>;
  dragStart?: Maybe<Scalars['Date']['output']>;
  dragVertical?: Maybe<Scalars['Int']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  endorsers: Array<User>;
  followers: Array<User>;
  formulaValues?: Maybe<Scalars['JSON']['output']>;
  granularity?: Maybe<DateGranularity>;
  id: Scalars['Hashid']['output'];
  name: Scalars['String']['output'];
  objectives: Array<Objective>;
  platforms: Array<Platform>;
  position: Scalars['Int']['output'];
  product?: Maybe<Product>;
  score?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Date']['output']>;
  status: Status;
  teams: Array<Team>;
  updates: UpdateConnection;
  veEffort?: Maybe<Scalars['Int']['output']>;
  veScore?: Maybe<Scalars['Int']['output']>;
  veValue?: Maybe<Scalars['Int']['output']>;
  workspace: Workspace;
};


export type TaskUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Team = {
  __typename: 'Team';
  color: Scalars['String']['output'];
  description?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Hashid']['output'];
  members: Array<User>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  tasks: Array<Task>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export const Trashed = {
  /** Only return trashed results. */
  only: 'ONLY',
  /** Return both trashed and non-trashed results. */
  with: 'WITH',
  /** Only return non-trashed results. */
  without: 'WITHOUT'
} as const;

export type Trashed = typeof Trashed[keyof typeof Trashed];
export type Update = {
  __typename: 'Update';
  body: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeTz']['output'];
  end?: Maybe<Scalars['Date']['output']>;
  granularity?: Maybe<DateGranularity>;
  id: Scalars['Hashid']['output'];
  start?: Maybe<Scalars['Date']['output']>;
  status?: Maybe<Status>;
  target?: Maybe<UpdateTargetModel>;
  updatedAt: Scalars['DateTimeTz']['output'];
  user: User;
};

export type UpdateAccountInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A paginated list of Update edges. */
export type UpdateConnection = {
  __typename: 'UpdateConnection';
  /** A list of Update edges. */
  edges: Array<UpdateEdge>;
  /** Pagination information about the list of edges. */
  pageInfo: PageInfo;
};

/** An edge that contains a node of type Update and a cursor. */
export type UpdateEdge = {
  __typename: 'UpdateEdge';
  /** A unique cursor that can be used for pagination. */
  cursor: Scalars['String']['output'];
  /** The Update node. */
  node: Update;
};

export type UpdateFeatureInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  featureId: Scalars['Hashid']['input'];
  formulaValues?: InputMaybe<Array<FormulaValueInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectiveIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  statusId?: InputMaybe<Scalars['Hashid']['input']>;
  teamIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  veEffort?: InputMaybe<Scalars['Int']['input']>;
  veValue?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateIdeaInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  formulaValues?: InputMaybe<Array<FormulaValueInput>>;
  ideaId: Scalars['Hashid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  objectiveIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Hashid']['input']>;
  statusId?: InputMaybe<Scalars['Hashid']['input']>;
  teamIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  veEffort?: InputMaybe<Scalars['Int']['input']>;
  veValue?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateIdeaInsightInput = {
  contact?: InputMaybe<UpsertContactInput>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  ideaId: Scalars['Hashid']['input'];
  importanceId: Scalars['Hashid']['input'];
  insightId: Scalars['Hashid']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateJiraProjectInput = {
  jiraProjectId: Scalars['String']['input'];
  jiraResourceId: Scalars['Hashid']['input'];
  statusSyncConfig?: InputMaybe<Scalars['JSON']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateKeyResultInput = {
  keyResultId: Scalars['Hashid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  startValue?: InputMaybe<Scalars['Float']['input']>;
  targetValue?: InputMaybe<Scalars['Float']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateKeyResultPayload = {
  __typename: 'UpdateKeyResultPayload';
  keyResult: KeyResult;
};

export type UpdateKeyResultValueByIdInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  keyResultId: Scalars['Hashid']['input'];
  keyResultValueId: Scalars['Hashid']['input'];
  value: Scalars['Float']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateKeyResultValueInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  keyResultId: Scalars['Hashid']['input'];
  value: Scalars['Float']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateKeyResultValuePayload = {
  __typename: 'UpdateKeyResultValuePayload';
  keyResult: KeyResult;
};

export type UpdateMemberEmailNotificationsInput = {
  enabled: Scalars['Boolean']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateMemberRoleInput = {
  role: MemberRole;
  userId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateMilestoneInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  milestoneId: Scalars['Hashid']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateObjectiveInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectiveId: Scalars['Hashid']['input'];
  parentId?: InputMaybe<Scalars['Hashid']['input']>;
  teamIds?: InputMaybe<Array<Scalars['Hashid']['input']>>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdatePlatformInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platformId: Scalars['Hashid']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateProductInput = {
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateStatusInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<StatusStage>;
  statusId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateStatusPositionsInput = {
  statusIds: Array<Scalars['Hashid']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateTargetModel = Objective | Task;

export type UpdateTeamInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  teamId: Scalars['Hashid']['input'];
  workspaceId: Scalars['Hashid']['input'];
};

export type UpdateWorkspaceInput = {
  activeFormulaKey?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceId: Scalars['Hashid']['input'];
};

export type UpsertContactCompanyInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Hashid']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<UpsertSegmentInput>;
};

export type UpsertContactInput = {
  company?: InputMaybe<UpsertContactCompanyInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Hashid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertProductInput = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSegmentInput = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename: 'User';
  analyticsId: Scalars['Int']['output'];
  autoJoinDomain?: Maybe<Scalars['String']['output']>;
  avatarUploadUrl: Scalars['String']['output'];
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeTz']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Hashid']['output'];
  intercomIdentity: Scalars['String']['output'];
  isVerified: Scalars['Boolean']['output'];
  membership?: Maybe<UserMembership>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeTz']['output'];
  workspace: Workspace;
  workspaces: Array<Workspace>;
};


export type UserWorkspaceArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};

export type UserMembership = {
  __typename: 'UserMembership';
  emailNotificationsEnabled: Scalars['Boolean']['output'];
  role: MemberRole;
};

/** A paginated list of User items. */
export type UserPaginator = {
  __typename: 'UserPaginator';
  /** A list of User items. */
  data: Array<User>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export const UserVerificationStatus = {
  pending: 'PENDING',
  success: 'SUCCESS'
} as const;

export type UserVerificationStatus = typeof UserVerificationStatus[keyof typeof UserVerificationStatus];
export type VerifyEmailInput = {
  code: Scalars['String']['input'];
};

export type Workspace = {
  __typename: 'Workspace';
  activeFormula?: Maybe<Formula>;
  analyticsId: Scalars['Int']['output'];
  connectedJiraResources: Array<ConnectedJiraResource>;
  contacts: Array<Contact>;
  domains: Array<WorkspaceDomain>;
  feed: Array<Update>;
  formulas: Array<Formula>;
  id: Scalars['Hashid']['output'];
  idea: Idea;
  ideaFields: Array<Field>;
  ideas: Array<Idea>;
  importances: Array<Importance>;
  invitations: Array<Invitation>;
  keyResult: KeyResult;
  members: Array<User>;
  membership?: Maybe<UserMembership>;
  milestone: Milestone;
  milestones: Array<Milestone>;
  name: Scalars['String']['output'];
  notifications: Array<Notification>;
  objective: Objective;
  objectives: Array<Objective>;
  platforms: Array<Platform>;
  product: Product;
  products: Array<Product>;
  searchKey: Scalars['String']['output'];
  segments: Array<Segment>;
  slug: Scalars['String']['output'];
  statuses: Array<Status>;
  subscribeLink: Scalars['String']['output'];
  subscription: BillingSubscription;
  task: Task;
  tasks: Array<Task>;
  team: Team;
  teams: Array<Team>;
  updateSubscriptionLink?: Maybe<Scalars['String']['output']>;
};


export type WorkspaceIdeaArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type WorkspaceIdeasArgs = {
  hasDate?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<WorkspaceIdeasOrderByOrderByClause>>;
};


export type WorkspaceKeyResultArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type WorkspaceMilestoneArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type WorkspaceObjectiveArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type WorkspaceProductArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type WorkspaceTaskArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};


export type WorkspaceTasksArgs = {
  hasDate?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Array<WorkspaceTasksOrderByOrderByClause>>;
};


export type WorkspaceTeamArgs = {
  id?: InputMaybe<Scalars['Hashid']['input']>;
};

export type WorkspaceDomain = {
  __typename: 'WorkspaceDomain';
  domain: Scalars['String']['output'];
};

export type WorkspaceDomainInput = {
  domain: Scalars['String']['input'];
};

/** Allowed column names for Workspace.ideas.orderBy. */
export const WorkspaceIdeasOrderByColumn = {
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT'
} as const;

export type WorkspaceIdeasOrderByColumn = typeof WorkspaceIdeasOrderByColumn[keyof typeof WorkspaceIdeasOrderByColumn];
/** Order by clause for Workspace.ideas.orderBy. */
export type WorkspaceIdeasOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: WorkspaceIdeasOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for Workspace.tasks.orderBy. */
export const WorkspaceTasksOrderByColumn = {
  createdAt: 'CREATED_AT',
  updatedAt: 'UPDATED_AT'
} as const;

export type WorkspaceTasksOrderByColumn = typeof WorkspaceTasksOrderByColumn[keyof typeof WorkspaceTasksOrderByColumn];
/** Order by clause for Workspace.tasks.orderBy. */
export type WorkspaceTasksOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: WorkspaceTasksOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

export type ActivityDataFragment = { __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } };

export type ActivityLocalDataFragment = { __typename: 'Activity', tempId?: string | null | undefined };

export type BillingSubscriptionDataFragment = { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined };

export type CommentDataFragment = { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } };

export type ContactDataFragment = { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined };

export type DeliveryItemDataFragment = { __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined, jiraAttributes?: { __typename: 'JiraIssue', summary?: string | null | undefined, key?: string | null | undefined, status: { __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined } } | null | undefined };

export type DeliveryItemJiraAttributesFragment = { __typename: 'DeliveryItem', jiraAttributes?: { __typename: 'JiraIssue', summary?: string | null | undefined, key?: string | null | undefined, status: { __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined } } | null | undefined };

export type FeedbackNoteDataFragment = { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined };

export type FieldDataFragment = { __typename: 'Field', id: string, type: FieldType, name: string, description?: string | null | undefined, required: boolean, position: number, options: Array<{ __typename: 'FieldOption', id: string, value: string }> };

export type FormulaDataFragment = { __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> };

export type FormulaFieldDataFragment = { __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined };

export type IdeaDetailFragment = { __typename: 'Idea', description?: any | null | undefined, id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, fields?: Array<{ __typename: 'IdeaField', value?: any | null | undefined, field: { __typename: 'Field', id: string, type: FieldType, name: string, description?: string | null | undefined, required: boolean, position: number, options: Array<{ __typename: 'FieldOption', id: string, value: string }> } }> | null | undefined, endorsers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> };

export type IdeaListingFragment = { __typename: 'Idea', id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> };

export type IdeaWithActivityFragment = { __typename: 'Idea', id: string, activity: Array<{ __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } }> };

export type IdeaWithInsightsFragment = { __typename: 'Idea', id: string, insightsScore: number, insights: { __typename: 'InsightConnection', edges: Array<{ __typename: 'InsightEdge', node: { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } };

export type ImportanceDataFragment = { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined };

export type InsightDataFragment = { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined };

export type InsightsConnectionDataFragment = { __typename: 'InsightConnection', edges: Array<{ __typename: 'InsightEdge', node: { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } };

export type KeyResultDataAllValuesFragment = { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, objective: { __typename: 'Objective', id: string, start?: Date | null | undefined, end?: Date | null | undefined, status?: { __typename: 'Status', color: string } | null | undefined }, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, values: Array<{ __typename: 'KeyResultValue', id: string, date: Date, value: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type KeyResultListingFragment = { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type KeyResultValueListingFragment = { __typename: 'KeyResultValue', id: string, date: Date, value: number };

export type MeDataFragment = { __typename: 'User', id: string, analyticsId: number, intercomIdentity: string, avatarUrl?: string | null | undefined, name: string, email: string, isVerified: boolean, autoJoinDomain?: string | null | undefined, workspaces: Array<{ __typename: 'Workspace', id: string, slug: string, name: string, membership?: { __typename: 'UserMembership', role: MemberRole, emailNotificationsEnabled: boolean } | null | undefined }> };

export type MilestoneListingFragment = { __typename: 'Milestone', id: string, name: string, date?: Date | null | undefined };

export type MilestoneListingWithDescriptionFragment = { __typename: 'Milestone', description?: any | null | undefined, id: string, name: string, date?: Date | null | undefined };

export type MyWorkspacesDataFragment = { __typename: 'Workspace', id: string, slug: string, name: string, membership?: { __typename: 'UserMembership', role: MemberRole, emailNotificationsEnabled: boolean } | null | undefined };

export type NotificationDataFragment = { __typename: 'Notification', id: string, type: ActivityType, createdAt: any, updatedAt: any, readAt?: any | null | undefined, seenAt?: any | null | undefined, author: { __typename: 'User', id: string, name: string }, subject: { __typename: 'Task', id: string, name: string }, content: { __typename: 'Activity', id: string, task: { __typename: 'Task', id: string, name: string } } };

export type ObjectiveDataFragment = { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type ObjectiveDataFullFragment = { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type ObjectiveDataWithKeyResultsFragment = { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type ObjectiveDataWithTasksFragment = { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type ObjectiveDataWithUpdatesFragment = { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type PlatformDataFragment = { __typename: 'Platform', id: string, name: string, color: string, position: number };

export type ProductDataFragment = { __typename: 'Product', id: string, name: string };

export type ProductListingFragment = { __typename: 'Product', id: string, name: string };

export type ProductListingWithDescriptionFragment = { __typename: 'Product', description?: any | null | undefined, id: string, name: string };

export type ProductListingWithTasksFragment = { __typename: 'Product', id: string, name: string, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> };

export type SegmentDataFragment = { __typename: 'Segment', id: string, name: string, score: number, position: number };

export type StatusLabelFragment = { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage };

export type TaskListingFragment = { __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> };

export type TaskListingWithDescriptionFragment = { __typename: 'Task', description?: any | null | undefined, id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, dependencies: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined }>, dependentOn: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> };

export type TaskObjectivesFragment = { __typename: 'Task', id: string, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string }> };

export type TaskStatusFragment = { __typename: 'Task', status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage } };

export type TaskTimelineDatesFragment = { __typename: 'Task', id: string, granularity?: DateGranularity | null | undefined, dragStart?: Date | null | undefined, dragEnd?: Date | null | undefined, dragVertical?: number | null | undefined };

export type TaskWithActivityFragment = { __typename: 'Task', id: string, activity: Array<{ __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } }> };

export type TaskWithUpdatesDataFragment = { __typename: 'Task', id: string, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } };

export type TeamDataFragment = { __typename: 'Team', id: string, name: string, color: string, position: number };

export type TeamDataWithDescriptionFragment = { __typename: 'Team', description?: any | null | undefined, id: string, name: string, color: string, position: number };

export type TeamDataWithTasksFragment = { __typename: 'Team', description?: any | null | undefined, id: string, name: string, color: string, position: number, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> };

export type UpdateDataFragment = { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type UpdateDataWithTargetFragment = { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, target?: { __typename: 'Objective' } | { __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> } | null | undefined, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined };

export type UpdatesConnectionDataFragment = { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } };

export type UserDataFragment = { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string };

export type WorkspaceListingFragment = { __typename: 'Workspace', id: string, analyticsId: number, slug: string, name: string, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined }, domains: Array<{ __typename: 'WorkspaceDomain', domain: string }>, formulas: Array<{ __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> }>, activeFormula?: { __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> } | null | undefined, importances: Array<{ __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined }>, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string }> };

export type WorkspaceMemberFragment = { __typename: 'User', id: string, name: string, email: string, membership?: { __typename: 'UserMembership', role: MemberRole } | null | undefined };

export type WorkspaceSubscriptionDataFragment = { __typename: 'Workspace', id: string, slug: string, subscribeLink: string, updateSubscriptionLink?: string | null | undefined, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined } };

export type WorkspaceWithContactsFragment = { __typename: 'Workspace', id: string, slug: string, contacts: Array<{ __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined }> };

export type WorkspaceWithIntegrationsFragment = { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined }> }> };

export type WorkspaceWithIntegrationsStatusesFragment = { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }> }> };

export type WorkspaceWithSegmentsFragment = { __typename: 'Workspace', id: string, slug: string, segments: Array<{ __typename: 'Segment', id: string, name: string, score: number, position: number }> };

export type AddDeliveryItemMutationVariables = Exact<{
  input: AddDeliveryItemInput;
}>;


export type AddDeliveryItemMutation = { __typename: 'Mutation', addDeliveryItem: { __typename: 'Task', id: string, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined, jiraAttributes?: { __typename: 'JiraIssue', summary?: string | null | undefined, key?: string | null | undefined, status: { __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined } } | null | undefined }> } };

export type AddDependencyMutationVariables = Exact<{
  input: AddDependencyInput;
}>;


export type AddDependencyMutation = { __typename: 'Mutation', addDependency: { __typename: 'Task', description?: any | null | undefined, id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, dependencies: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined }>, dependentOn: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } };

export type AddFeatureCommentMutationVariables = Exact<{
  input: AddFeatureCommentInput;
}>;


export type AddFeatureCommentMutation = { __typename: 'Mutation', addFeatureComment: { __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } } };

export type AddFeatureUpdateMutationVariables = Exact<{
  input: AddFeatureUpdateInput;
  updatesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddFeatureUpdateMutation = { __typename: 'Mutation', addFeatureUpdate: { __typename: 'Task', id: string, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } };

export type AddIdeaCommentMutationVariables = Exact<{
  input: AddIdeaCommentInput;
}>;


export type AddIdeaCommentMutation = { __typename: 'Mutation', addIdeaComment: { __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } } };

export type AddKeyResultValueMutationVariables = Exact<{
  input: UpdateKeyResultValueInput;
}>;


export type AddKeyResultValueMutation = { __typename: 'Mutation', updateKeyResultValue: { __typename: 'UpdateKeyResultValuePayload', keyResult: { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, objective: { __typename: 'Objective', id: string, start?: Date | null | undefined, end?: Date | null | undefined, status?: { __typename: 'Status', color: string } | null | undefined }, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, values: Array<{ __typename: 'KeyResultValue', id: string, date: Date, value: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } } };

export type AddObjectiveFeatureMutationVariables = Exact<{
  input: AddObjectiveFeatureInput;
}>;


export type AddObjectiveFeatureMutation = { __typename: 'Mutation', addObjectiveFeature: { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type AddObjectiveUpdateMutationVariables = Exact<{
  input: AddObjectiveUpdateInput;
  updatesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddObjectiveUpdateMutation = { __typename: 'Mutation', addObjectiveUpdate: { __typename: 'Objective', id: string, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } };

export type AddTeamFeatureMutationVariables = Exact<{
  input: AddTeamFeatureInput;
}>;


export type AddTeamFeatureMutation = { __typename: 'Mutation', addTeamFeature: { __typename: 'Team', description?: any | null | undefined, id: string, name: string, color: string, position: number, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> } };

export type CancelWorkspaceSubscriptionMutationVariables = Exact<{
  input: CancelWorkspaceSubscriptionInput;
}>;


export type CancelWorkspaceSubscriptionMutation = { __typename: 'Mutation', cancelWorkspaceSubscription: { __typename: 'Workspace', id: string, slug: string, subscribeLink: string, updateSubscriptionLink?: string | null | undefined, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined } } };

export type BulkCreateFeaturesMutationVariables = Exact<{
  input: BulkCreateFeaturesInput;
}>;


export type BulkCreateFeaturesMutation = { __typename: 'Mutation', bulkCreateFeatures: Array<{ __typename: 'Task', id: string }> };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename: 'Mutation', createContact: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } };

export type CreateFeatureMutationVariables = Exact<{
  input: CreateFeatureInput;
}>;


export type CreateFeatureMutation = { __typename: 'Mutation', createFeature: { __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> } };

export type CreateFeedbackInsightForIdeaMutationVariables = Exact<{
  input: CreateFeedbackInsightForIdeaInput;
  insightsCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFeedbackInsightForIdeaMutation = { __typename: 'Mutation', createFeedbackInsightForIdea: { __typename: 'Idea', id: string, insightsScore: number, insights: { __typename: 'InsightConnection', edges: Array<{ __typename: 'InsightEdge', node: { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } };

export type CreateIdeaMutationVariables = Exact<{
  input: CreateIdeaInput;
}>;


export type CreateIdeaMutation = { __typename: 'Mutation', createIdea: { __typename: 'Idea', id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } };

export type CreateKeyResultMutationVariables = Exact<{
  input: CreateKeyResultInput;
}>;


export type CreateKeyResultMutation = { __typename: 'Mutation', createKeyResult: { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type CreateMilestoneMutationVariables = Exact<{
  input: CreateMilestoneInput;
}>;


export type CreateMilestoneMutation = { __typename: 'Mutation', createMilestone: { __typename: 'Milestone', id: string, name: string, date?: Date | null | undefined } };

export type CreateObjectiveMutationVariables = Exact<{
  input: CreateObjectiveInput;
}>;


export type CreateObjectiveMutation = { __typename: 'Mutation', createObjective: { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type CreatePlatformMutationVariables = Exact<{
  input: CreatePlatformInput;
}>;


export type CreatePlatformMutation = { __typename: 'Mutation', createPlatform: { __typename: 'Workspace', id: string, slug: string, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }> } };

export type CreateProductMutationVariables = Exact<{
  input: CreateProductInput;
}>;


export type CreateProductMutation = { __typename: 'Mutation', createProduct: { __typename: 'Product', id: string, name: string } };

export type CreateStatusMutationVariables = Exact<{
  input: CreateStatusInput;
}>;


export type CreateStatusMutation = { __typename: 'Mutation', createStatus: { __typename: 'Workspace', id: string, slug: string, statuses: Array<{ __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }> } };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { __typename: 'Mutation', createTeam: { __typename: 'Team', id: string, name: string, color: string, position: number } };

export type CreateWorkspaceMutationVariables = Exact<{
  input: CreateWorkspaceInput;
}>;


export type CreateWorkspaceMutation = { __typename: 'Mutation', createWorkspace: { __typename: 'Workspace', id: string, name: string, slug: string } };

export type DeleteConnectedJiraResourceMutationVariables = Exact<{
  input: DeleteConnectedJiraResourceInput;
}>;


export type DeleteConnectedJiraResourceMutation = { __typename: 'Mutation', deleteConnectedJiraResource: { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined }> }> } };

export type DeleteDeliveryItemMutationVariables = Exact<{
  input: DeleteDeliveryItemInput;
}>;


export type DeleteDeliveryItemMutation = { __typename: 'Mutation', deleteDeliveryItem: { __typename: 'Task', id: string, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined, jiraAttributes?: { __typename: 'JiraIssue', summary?: string | null | undefined, key?: string | null | undefined, status: { __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined } } | null | undefined }> } };

export type DeleteFeaturesMutationVariables = Exact<{
  input: DeleteFeaturesInput;
}>;


export type DeleteFeaturesMutation = { __typename: 'Mutation', deleteFeatures?: { __typename: 'DeleteFeaturesPayload', deletedIds?: Array<string> | null | undefined } | null | undefined };

export type DeleteIdeaInsightMutationVariables = Exact<{
  input: DeleteIdeaInsightInput;
  insightsCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteIdeaInsightMutation = { __typename: 'Mutation', deleteIdeaInsight: { __typename: 'Idea', id: string, insightsScore: number, insights: { __typename: 'InsightConnection', edges: Array<{ __typename: 'InsightEdge', node: { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } };

export type DeleteIdeasMutationVariables = Exact<{
  input: DeleteIdeasInput;
}>;


export type DeleteIdeasMutation = { __typename: 'Mutation', deleteIdeas?: { __typename: 'DeleteIdeasPayload', deletedIds?: Array<string> | null | undefined } | null | undefined };

export type DeleteInvitationMutationVariables = Exact<{
  input: DeleteInvitationInput;
}>;


export type DeleteInvitationMutation = { __typename: 'Mutation', deleteInvitation: { __typename: 'Workspace', id: string, name: string, slug: string, invitations: Array<{ __typename: 'Invitation', email: string, updatedAt: any }> } };

export type DeleteKeyResultMutationVariables = Exact<{
  input: DeleteKeyResultInput;
}>;


export type DeleteKeyResultMutation = { __typename: 'Mutation', deleteKeyResult?: { __typename: 'DeleteKeyResultPayload', objective: { __typename: 'Objective', id: string, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }> } } | null | undefined };

export type DeleteKeyResultValueMutationVariables = Exact<{
  input: DeleteKeyResultValueInput;
}>;


export type DeleteKeyResultValueMutation = { __typename: 'Mutation', deleteKeyResultValue: { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, objective: { __typename: 'Objective', id: string, start?: Date | null | undefined, end?: Date | null | undefined, status?: { __typename: 'Status', color: string } | null | undefined }, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, values: Array<{ __typename: 'KeyResultValue', id: string, date: Date, value: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type DeleteMemberMutationVariables = Exact<{
  input: DeleteMemberInput;
}>;


export type DeleteMemberMutation = { __typename: 'Mutation', deleteMember: { __typename: 'Workspace', id: string, name: string, slug: string, members: Array<{ __typename: 'User', id: string, name: string, email: string, membership?: { __typename: 'UserMembership', role: MemberRole } | null | undefined }> } };

export type DeleteMilestoneMutationVariables = Exact<{
  input: DeleteMilestoneInput;
}>;


export type DeleteMilestoneMutation = { __typename: 'Mutation', deleteMilestone: { __typename: 'Workspace', id: string, slug: string, milestones: Array<{ __typename: 'Milestone', id: string, name: string, date?: Date | null | undefined }> } };

export type DeleteObjectiveMutationVariables = Exact<{
  input: DeleteObjectiveInput;
}>;


export type DeleteObjectiveMutation = { __typename: 'Mutation', deleteObjective: { __typename: 'Workspace', id: string, name: string, slug: string, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }> } };

export type DeletePlatformMutationVariables = Exact<{
  input: DeletePlatformInput;
}>;


export type DeletePlatformMutation = { __typename: 'Mutation', deletePlatform: { __typename: 'Workspace', id: string, name: string, slug: string, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }> } };

export type DeleteProductMutationVariables = Exact<{
  input: DeleteProductInput;
}>;


export type DeleteProductMutation = { __typename: 'Mutation', deleteProduct: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }> } };

export type DeleteStatusMutationVariables = Exact<{
  input: DeleteStatusInput;
}>;


export type DeleteStatusMutation = { __typename: 'Mutation', deleteStatus: { __typename: 'Workspace', id: string, slug: string, statuses: Array<{ __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }> } };

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeamInput;
}>;


export type DeleteTeamMutation = { __typename: 'Mutation', deleteTeam: { __typename: 'Workspace', id: string, name: string, slug: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } };

export type ForgotPasswordMutationVariables = Exact<{
  input: ForgotPasswordInput;
}>;


export type ForgotPasswordMutation = { __typename: 'Mutation', forgotPassword: { __typename: 'ForgotPasswordPayload', success: boolean } };

export type InviteMembersMutationVariables = Exact<{
  input: InviteMembersInput;
}>;


export type InviteMembersMutation = { __typename: 'Mutation', inviteMembers: { __typename: 'Workspace', id: string, name: string, slug: string, members: Array<{ __typename: 'User', id: string, name: string, email: string, membership?: { __typename: 'UserMembership', role: MemberRole } | null | undefined }> } };

export type LinkJiraProjectMutationVariables = Exact<{
  input: ConnectJiraProjectInput;
}>;


export type LinkJiraProjectMutation = { __typename: 'Mutation', connectJiraProject: { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined }> }> } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename: 'Mutation', login: { __typename: 'AuthPayload', token: string, user: { __typename: 'User', id: string, name: string, workspaces: Array<{ __typename: 'Workspace', slug: string, name: string }> } } };

export type MarkNotificationsReadMutationVariables = Exact<{
  input: MarkNotificationsReadInput;
}>;


export type MarkNotificationsReadMutation = { __typename: 'Mutation', markNotificationsRead: { __typename: 'Workspace', id: string, slug: string, notifications: Array<{ __typename: 'Notification', id: string, type: ActivityType, createdAt: any, updatedAt: any, readAt?: any | null | undefined, seenAt?: any | null | undefined, author: { __typename: 'User', id: string, name: string }, subject: { __typename: 'Task', id: string, name: string }, content: { __typename: 'Activity', id: string, task: { __typename: 'Task', id: string, name: string } } }> } };

export type MarkNotificationsSeenMutationVariables = Exact<{
  input: MarkNotificationsSeenInput;
}>;


export type MarkNotificationsSeenMutation = { __typename: 'Mutation', markNotificationsSeen: { __typename: 'Workspace', id: string, slug: string, notifications: Array<{ __typename: 'Notification', id: string, type: ActivityType, createdAt: any, updatedAt: any, readAt?: any | null | undefined, seenAt?: any | null | undefined, author: { __typename: 'User', id: string, name: string }, subject: { __typename: 'Task', id: string, name: string }, content: { __typename: 'Activity', id: string, task: { __typename: 'Task', id: string, name: string } } }> } };

export type RemoveDependencyMutationVariables = Exact<{
  input: RemoveDependencyInput;
}>;


export type RemoveDependencyMutation = { __typename: 'Mutation', removeDependency: { __typename: 'Task', description?: any | null | undefined, id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, dependencies: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined }>, dependentOn: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } };

export type RemoveObjectiveFeatureMutationVariables = Exact<{
  input: RemoveObjectiveFeatureInput;
}>;


export type RemoveObjectiveFeatureMutation = { __typename: 'Mutation', removeObjectiveFeature: { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type RemoveTeamFeatureMutationVariables = Exact<{
  input: RemoveTeamFeatureInput;
}>;


export type RemoveTeamFeatureMutation = { __typename: 'Mutation', removeTeamFeature: { __typename: 'Team', description?: any | null | undefined, id: string, name: string, color: string, position: number, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword: { __typename: 'AuthPayload', token: string, user: { __typename: 'User', id: string, name: string, workspaces: Array<{ __typename: 'Workspace', slug: string, name: string }> } } };

export type SetFeatureFollowingMutationVariables = Exact<{
  input: SetFeatureFollowingInput;
}>;


export type SetFeatureFollowingMutation = { __typename: 'Mutation', setFeatureFollowing: { __typename: 'Task', id: string, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }> } };

export type SetFeaturesStatusMutationVariables = Exact<{
  input: SetFeaturesStatusInput;
}>;


export type SetFeaturesStatusMutation = { __typename: 'Mutation', setFeaturesStatus?: { __typename: 'SetFeaturesStatusPayload', features: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, stage: StatusStage } }> } | null | undefined };

export type SetFeaturesTimeFrameMutationVariables = Exact<{
  input: SetFeaturesTimeFrameInput;
}>;


export type SetFeaturesTimeFrameMutation = { __typename: 'Mutation', setFeaturesTimeFrame?: { __typename: 'SetFeaturesTimeFramePayload', features: Array<{ __typename: 'Task', id: string, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined }> } | null | undefined };

export type SetIdeaEndorsingMutationVariables = Exact<{
  input: SetIdeaEndorsingInput;
}>;


export type SetIdeaEndorsingMutation = { __typename: 'Mutation', setIdeaEndorsing: { __typename: 'Idea', id: string, endorsers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }> } };

export type SetIdeaFollowingMutationVariables = Exact<{
  input: SetIdeaFollowingInput;
}>;


export type SetIdeaFollowingMutation = { __typename: 'Mutation', setIdeaFollowing: { __typename: 'Idea', id: string, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }> } };

export type SetIdeasStatusMutationVariables = Exact<{
  input: SetIdeasStatusInput;
}>;


export type SetIdeasStatusMutation = { __typename: 'Mutation', setIdeasStatus?: { __typename: 'SetIdeasStatusPayload', ideas: Array<{ __typename: 'Idea', id: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }> } | null | undefined };

export type SetKeyResultsStatusMutationVariables = Exact<{
  input: SetKeyResultsStatusInput;
}>;


export type SetKeyResultsStatusMutation = { __typename: 'Mutation', setKeyResultsStatus?: { __typename: 'SetKeyResultsStatusPayload', keyResults: Array<{ __typename: 'KeyResult', id: string, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }> } | null | undefined };

export type SetObjectivesStatusMutationVariables = Exact<{
  input: SetObjectivesStatusInput;
}>;


export type SetObjectivesStatusMutation = { __typename: 'Mutation', setObjectivesStatus?: { __typename: 'SetObjectivesStatusPayload', objectives: Array<{ __typename: 'Objective', id: string, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }> } | null | undefined };

export type SetObjectivesTimeFrameMutationVariables = Exact<{
  input: SetObjectivesTimeFrameInput;
}>;


export type SetObjectivesTimeFrameMutation = { __typename: 'Mutation', setObjectivesTimeFrame?: { __typename: 'SetObjectivesTimeFramePayload', objectives: Array<{ __typename: 'Objective', id: string, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined }> } | null | undefined };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename: 'Mutation', signup: { __typename: 'SignupPayload', verification: UserVerificationStatus, token?: string | null | undefined, user?: { __typename: 'User', id: string, name: string, workspaces: Array<{ __typename: 'Workspace', slug: string, name: string }> } | null | undefined } };

export type UnlinkJiraProjectMutationVariables = Exact<{
  input: DeleteConnectedJiraProjectInput;
}>;


export type UnlinkJiraProjectMutation = { __typename: 'Mutation', deleteConnectedJiraProject: { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined }> }> } };

export type UpdateAccountMutationVariables = Exact<{
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename: 'Mutation', updateAccount: { __typename: 'User', id: string, avatarUrl?: string | null | undefined } };

export type UpdateFeatureMutationVariables = Exact<{
  input: UpdateFeatureInput;
}>;


export type UpdateFeatureMutation = { __typename: 'Mutation', updateFeature: { __typename: 'Task', id: string, name: string, description?: any | null | undefined, formulaValues?: any | null | undefined, position: number, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } };

export type UpdateIdeaMutationVariables = Exact<{
  input: UpdateIdeaInput;
}>;


export type UpdateIdeaMutation = { __typename: 'Mutation', updateIdea: { __typename: 'Idea', id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } };

export type UpdateIdeaInsightMutationVariables = Exact<{
  input: UpdateIdeaInsightInput;
}>;


export type UpdateIdeaInsightMutation = { __typename: 'Mutation', updateIdeaInsight: { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined } };

export type UpdateJiraProjectMutationVariables = Exact<{
  input: UpdateJiraProjectInput;
}>;


export type UpdateJiraProjectMutation = { __typename: 'Mutation', updateJiraProject: { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined }> }> } };

export type UpdateKeyResultMutationVariables = Exact<{
  input: UpdateKeyResultInput;
}>;


export type UpdateKeyResultMutation = { __typename: 'Mutation', updateKeyResult: { __typename: 'UpdateKeyResultPayload', keyResult: { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } } };

export type UpdateKeyResultValueMutationVariables = Exact<{
  input: UpdateKeyResultValueInput;
}>;


export type UpdateKeyResultValueMutation = { __typename: 'Mutation', updateKeyResultValue: { __typename: 'UpdateKeyResultValuePayload', keyResult: { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } } };

export type UpdateKeyResultValueByIdMutationVariables = Exact<{
  input: UpdateKeyResultValueByIdInput;
}>;


export type UpdateKeyResultValueByIdMutation = { __typename: 'Mutation', updateKeyResultValueById: { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, objective: { __typename: 'Objective', id: string, start?: Date | null | undefined, end?: Date | null | undefined, status?: { __typename: 'Status', color: string } | null | undefined }, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, values: Array<{ __typename: 'KeyResultValue', id: string, date: Date, value: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type UpdateMemberEmailNotificationsMutationVariables = Exact<{
  input: UpdateMemberEmailNotificationsInput;
}>;


export type UpdateMemberEmailNotificationsMutation = { __typename: 'Mutation', updateMemberEmailNotifications: { __typename: 'User', id: string, analyticsId: number, intercomIdentity: string, avatarUrl?: string | null | undefined, name: string, email: string, isVerified: boolean, autoJoinDomain?: string | null | undefined, workspaces: Array<{ __typename: 'Workspace', id: string, slug: string, name: string, membership?: { __typename: 'UserMembership', role: MemberRole, emailNotificationsEnabled: boolean } | null | undefined }> } };

export type UpdateMemberRoleMutationVariables = Exact<{
  input: UpdateMemberRoleInput;
}>;


export type UpdateMemberRoleMutation = { __typename: 'Mutation', updateMemberRole: { __typename: 'Workspace', id: string, name: string, slug: string, members: Array<{ __typename: 'User', id: string, name: string, email: string, membership?: { __typename: 'UserMembership', role: MemberRole } | null | undefined }> } };

export type UpdateMilestoneMutationVariables = Exact<{
  input: UpdateMilestoneInput;
}>;


export type UpdateMilestoneMutation = { __typename: 'Mutation', updateMilestone: { __typename: 'Milestone', description?: any | null | undefined, id: string, name: string, date?: Date | null | undefined } };

export type UpdateObjectiveMutationVariables = Exact<{
  input: UpdateObjectiveInput;
}>;


export type UpdateObjectiveMutation = { __typename: 'Mutation', updateObjective: { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } };

export type UpdatePlatformMutationVariables = Exact<{
  input: UpdatePlatformInput;
}>;


export type UpdatePlatformMutation = { __typename: 'Mutation', updatePlatform: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }> };

export type UpdateProductMutationVariables = Exact<{
  input: UpdateProductInput;
}>;


export type UpdateProductMutation = { __typename: 'Mutation', updateProduct: { __typename: 'Product', description?: any | null | undefined, id: string, name: string } };

export type UpdateStatusMutationVariables = Exact<{
  input: UpdateStatusInput;
}>;


export type UpdateStatusMutation = { __typename: 'Mutation', updateStatus: Array<{ __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }> };

export type UpdateStatusPositionsMutationVariables = Exact<{
  input: UpdateStatusPositionsInput;
}>;


export type UpdateStatusPositionsMutation = { __typename: 'Mutation', updateStatusPositions: Array<{ __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }> };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename: 'Mutation', updateTeam: { __typename: 'Team', description?: any | null | undefined, id: string, name: string, color: string, position: number } };

export type UpdateWorkspaceMutationVariables = Exact<{
  input: UpdateWorkspaceInput;
}>;


export type UpdateWorkspaceMutation = { __typename: 'Mutation', updateWorkspace: { __typename: 'Workspace', id: string, analyticsId: number, slug: string, name: string, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined }, domains: Array<{ __typename: 'WorkspaceDomain', domain: string }>, formulas: Array<{ __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> }>, activeFormula?: { __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> } | null | undefined, importances: Array<{ __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined }>, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string }> } };

export type VerifyEmailMutationVariables = Exact<{
  input: VerifyEmailInput;
}>;


export type VerifyEmailMutation = { __typename: 'Mutation', verifyEmail: { __typename: 'SignupPayload', verification: UserVerificationStatus, token?: string | null | undefined, user?: { __typename: 'User', id: string, analyticsId: number, intercomIdentity: string, avatarUrl?: string | null | undefined, name: string, email: string, isVerified: boolean, autoJoinDomain?: string | null | undefined, workspaces: Array<{ __typename: 'Workspace', id: string, slug: string, name: string, membership?: { __typename: 'UserMembership', role: MemberRole, emailNotificationsEnabled: boolean } | null | undefined }> } | null | undefined } };

export type GetAddFeatureOptionsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetAddFeatureOptionsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }>, statuses: Array<{ __typename: 'Status', id: string, position: number, name: string, color: string, type: StatusType, stage: StatusStage }> } | null | undefined };

export type GetAllFeaturesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  orderBy?: InputMaybe<Array<WorkspaceTasksOrderByOrderByClause> | WorkspaceTasksOrderByOrderByClause>;
  hasDate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllFeaturesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }>, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> } | null | undefined };

export type GetAllFeaturesAndMilestonesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  orderBy?: InputMaybe<Array<WorkspaceTasksOrderByOrderByClause> | WorkspaceTasksOrderByOrderByClause>;
  hasDate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllFeaturesAndMilestonesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, tasks: Array<{ __typename: 'Task', dragStart?: Date | null | undefined, dragEnd?: Date | null | undefined, dragVertical?: number | null | undefined, id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, milestones: Array<{ __typename: 'Milestone', id: string, name: string, date?: Date | null | undefined }> } | null | undefined };

export type GetAllIdeasQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  orderBy?: InputMaybe<Array<WorkspaceIdeasOrderByOrderByClause> | WorkspaceIdeasOrderByOrderByClause>;
  hasDate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllIdeasQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }>, ideas: Array<{ __typename: 'Idea', id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }> } | null | undefined };

export type GetAllMilestonesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetAllMilestonesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, milestones: Array<{ __typename: 'Milestone', id: string, name: string, date?: Date | null | undefined }> } | null | undefined };

export type GetAllProductsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetAllProductsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }> } | null | undefined };

export type GetFeatureQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  featureId: Scalars['Hashid']['input'];
}>;


export type GetFeatureQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, task: { __typename: 'Task', description?: any | null | undefined, id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, dependencies: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined }>, dependentOn: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } } | null | undefined };

export type GetFeatureActivityQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  featureId: Scalars['Hashid']['input'];
}>;


export type GetFeatureActivityQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, task: { __typename: 'Task', id: string, activity: Array<{ __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } }> } } | null | undefined };

export type GetFeatureDeliveryItemsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  featureId: Scalars['Hashid']['input'];
}>;


export type GetFeatureDeliveryItemsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, task: { __typename: 'Task', id: string, deliveryItems: Array<{ __typename: 'DeliveryItem', id: string, url: string, name?: string | null | undefined, service?: string | null | undefined, jiraAttributes?: { __typename: 'JiraIssue', summary?: string | null | undefined, key?: string | null | undefined, status: { __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined } } | null | undefined }> } } | null | undefined };

export type GetFeatureFilterOptionsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetFeatureFilterOptionsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }>, statuses: Array<{ __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }>, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } | null | undefined };

export type GetFeatureUpdatesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  featureId: Scalars['Hashid']['input'];
  updatesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetFeatureUpdatesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, task: { __typename: 'Task', id: string, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } } | null | undefined };

export type GetFeaturesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetFeaturesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> }> } | null | undefined };

export type GetIdeaQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  ideaId: Scalars['Hashid']['input'];
}>;


export type GetIdeaQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, idea: { __typename: 'Idea', description?: any | null | undefined, id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, fields?: Array<{ __typename: 'IdeaField', value?: any | null | undefined, field: { __typename: 'Field', id: string, type: FieldType, name: string, description?: string | null | undefined, required: boolean, position: number, options: Array<{ __typename: 'FieldOption', id: string, value: string }> } }> | null | undefined, endorsers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } } | null | undefined };

export type GetIdeaActivityQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  ideaId: Scalars['Hashid']['input'];
}>;


export type GetIdeaActivityQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, idea: { __typename: 'Idea', id: string, activity: Array<{ __typename: 'Activity', id: string, tempId?: string | null | undefined, type: ActivityType, createdAt: any, value?: string | null | undefined, previousValue?: string | null | undefined, user?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, content?: { __typename: 'Comment', id: string, body: any, createdAt: any, updatedAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } | null | undefined, previousContent?: { __typename: 'Comment' } | { __typename: 'Product', id: string, name: string } | { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | { __typename: 'Update' } | null | undefined, model: { __typename: 'Idea', id: string } | { __typename: 'Task', id: string } }> } } | null | undefined };

export type GetIdeaInsightsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  ideaId: Scalars['Hashid']['input'];
  insightsCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetIdeaInsightsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, idea: { __typename: 'Idea', id: string, insightsScore: number, insights: { __typename: 'InsightConnection', edges: Array<{ __typename: 'InsightEdge', node: { __typename: 'Insight', id: string, feedbackNote: { __typename: 'FeedbackNote', id: string, subject?: string | null | undefined, description?: string | null | undefined, externalUrl?: string | null | undefined, createdAt: any, reporter: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, contact?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined } | null | undefined }, importance?: { __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } } | null | undefined };

export type GetKeyResultQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  keyResultId: Scalars['Hashid']['input'];
}>;


export type GetKeyResultQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, keyResult: { __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, objective: { __typename: 'Objective', id: string, start?: Date | null | undefined, end?: Date | null | undefined, status?: { __typename: 'Status', color: string } | null | undefined }, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, values: Array<{ __typename: 'KeyResultValue', id: string, date: Date, value: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } } | null | undefined };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename: 'Query', me?: { __typename: 'User', id: string, analyticsId: number, intercomIdentity: string, avatarUrl?: string | null | undefined, name: string, email: string, isVerified: boolean, autoJoinDomain?: string | null | undefined, workspaces: Array<{ __typename: 'Workspace', id: string, slug: string, name: string, membership?: { __typename: 'UserMembership', role: MemberRole, emailNotificationsEnabled: boolean } | null | undefined }> } | null | undefined };

export type GetMeAvatarUploadUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeAvatarUploadUrlQuery = { __typename: 'Query', me?: { __typename: 'User', id: string, avatarUploadUrl: string } | null | undefined };

export type GetMilestoneQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  milestoneId: Scalars['Hashid']['input'];
}>;


export type GetMilestoneQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, milestone: { __typename: 'Milestone', description?: any | null | undefined, id: string, name: string, date?: Date | null | undefined } } | null | undefined };

export type GetNotificationsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetNotificationsQuery = { __typename: 'Query', me?: { __typename: 'User', id: string, workspace: { __typename: 'Workspace', id: string, slug: string, notifications: Array<{ __typename: 'Notification', id: string, type: ActivityType, createdAt: any, updatedAt: any, readAt?: any | null | undefined, seenAt?: any | null | undefined, author: { __typename: 'User', id: string, name: string }, subject: { __typename: 'Task', id: string, name: string }, content: { __typename: 'Activity', id: string, task: { __typename: 'Task', id: string, name: string } } }> } } | null | undefined };

export type GetObjectiveQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  objectiveId: Scalars['Hashid']['input'];
  updatesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetObjectiveQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, objective: { __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }>, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } }, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } } | null | undefined };

export type GetObjectiveUpdatesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  objectiveId: Scalars['Hashid']['input'];
  updatesCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetObjectiveUpdatesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, objective: { __typename: 'Objective', id: string, updates: { __typename: 'UpdateConnection', edges: Array<{ __typename: 'UpdateEdge', node: { __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined } }>, pageInfo: { __typename: 'PageInfo', endCursor?: string | null | undefined, hasNextPage: boolean } } } } | null | undefined };

export type GetProductQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  productId: Scalars['Hashid']['input'];
}>;


export type GetProductQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, product: { __typename: 'Product', description?: any | null | undefined, id: string, name: string } } | null | undefined };

export type GetTeamQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
  teamId: Scalars['Hashid']['input'];
}>;


export type GetTeamQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, team: { __typename: 'Team', description?: any | null | undefined, id: string, name: string, color: string, position: number, tasks: Array<{ __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> }> } } | null | undefined };

export type GetWorkspaceQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetWorkspaceQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, analyticsId: number, slug: string, name: string, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined }, domains: Array<{ __typename: 'WorkspaceDomain', domain: string }>, formulas: Array<{ __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> }>, activeFormula?: { __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> } | null | undefined, importances: Array<{ __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined }>, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string }> } | null | undefined };

export type GetWorkspaceContactsQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetWorkspaceContactsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, contacts: Array<{ __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined, parent?: { __typename: 'Contact', id: string, type: ContactType, name: string, email?: string | null | undefined, domain?: string | null | undefined, logo?: string | null | undefined } | null | undefined, segment?: { __typename: 'Segment', id: string, name: string, score: number, position: number } | null | undefined }> } | null | undefined };

export type GetWorkspaceIdeaFieldsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceIdeaFieldsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, ideaFields: Array<{ __typename: 'Field', id: string, type: FieldType, name: string, description?: string | null | undefined, required: boolean, position: number, options: Array<{ __typename: 'FieldOption', id: string, value: string }> }> } | null | undefined };

export type GetWorkspaceIntegrationsQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetWorkspaceIntegrationsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined }> }> } | null | undefined };

export type GetWorkspaceIntegrationsWithStatusesQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetWorkspaceIntegrationsWithStatusesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, name: string, slug: string, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string, url: string, connectedProjects: Array<{ __typename: 'ConnectedJiraProject', id: string, jiraId: string, name: string, key: string, statusSyncConfig?: Array<{ __typename: 'JiraStatusSyncConfig', jiraIds?: Array<string | null | undefined> | null | undefined, wayplanId?: string | null | undefined } | null | undefined> | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }>, allProjects: Array<{ __typename: 'JiraProject', id?: string | null | undefined, key?: string | null | undefined, name?: string | null | undefined, projectTypeKey?: string | null | undefined, simplified?: boolean | null | undefined, style?: string | null | undefined, isPrivate?: boolean | null | undefined, allStatuses: Array<{ __typename: 'JiraStatus', id?: string | null | undefined, name?: string | null | undefined, description?: string | null | undefined, statusCategory?: { __typename: 'JiraStatusCategory', key?: JiraStatusCategoryKey | null | undefined } | null | undefined }> }> }> } | null | undefined };

export type GetWorkspaceMembersQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceMembersQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, members: Array<{ __typename: 'User', id: string, name: string, email: string, membership?: { __typename: 'UserMembership', role: MemberRole } | null | undefined }>, invitations: Array<{ __typename: 'Invitation', email: string, updatedAt: any }> } | null | undefined };

export type GetWorkspaceObjectivesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceObjectivesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, description?: any | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, parentId?: string | null | undefined, keyResults: Array<{ __typename: 'KeyResult', id: string, name: string, metricType: MetricType, metricGoal: MetricGoal, startValue: number, targetValue: number, currentValue?: { __typename: 'KeyResultValue', id: string, date: Date, value: number } | null | undefined, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }> } | null | undefined };

export type GetWorkspacePlatformsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspacePlatformsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }> } | null | undefined };

export type GetWorkspaceProductsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceProductsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, products: Array<{ __typename: 'Product', id: string, name: string }> } | null | undefined };

export type GetWorkspaceSearchKeyQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceSearchKeyQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, searchKey: string } | null | undefined };

export type GetWorkspaceSegmentsQueryVariables = Exact<{
  slug: Scalars['ID']['input'];
}>;


export type GetWorkspaceSegmentsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, segments: Array<{ __typename: 'Segment', id: string, name: string, score: number, position: number }> } | null | undefined };

export type GetWorkspaceStatusesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceStatusesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, statuses: Array<{ __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage }> } | null | undefined };

export type GetWorkspaceSubscriptionQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceSubscriptionQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, subscribeLink: string, updateSubscriptionLink?: string | null | undefined, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined } } | null | undefined };

export type GetWorkspaceTeamsQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceTeamsQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } | null | undefined };

export type GetWorkspaceUpdatesQueryVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type GetWorkspaceUpdatesQuery = { __typename: 'Query', workspace?: { __typename: 'Workspace', id: string, slug: string, feed: Array<{ __typename: 'Update', id: string, body: any, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, createdAt: any, target?: { __typename: 'Objective' } | { __typename: 'Task', id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }>, dependencies: Array<{ __typename: 'Task', id: string }> } | null | undefined, user: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }, status?: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } | null | undefined }> } | null | undefined };

export type WorkspaceFeatureUpdatedSubscriptionVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type WorkspaceFeatureUpdatedSubscription = { __typename: 'Subscription', workspaceFeatureUpdated?: { __typename: 'Task', description?: any | null | undefined, id: string, name: string, color?: string | null | undefined, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, dependencies: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, dependentOn: Array<{ __typename: 'Task', id: string, name: string, status: { __typename: 'Status', id: string, name: string, color: string, position: number, type: StatusType, stage: StatusStage } }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } | null | undefined };

export type WorkspaceIdeaUpdatedSubscriptionVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type WorkspaceIdeaUpdatedSubscription = { __typename: 'Subscription', workspaceIdeaUpdated?: { __typename: 'Idea', description?: any | null | undefined, id: string, name: string, insightsScore: number, endorsementsCount: number, start?: Date | null | undefined, end?: Date | null | undefined, granularity?: DateGranularity | null | undefined, formulaValues?: any | null | undefined, score?: number | null | undefined, position: number, fields?: Array<{ __typename: 'IdeaField', value?: any | null | undefined, field: { __typename: 'Field', id: string, type: FieldType, name: string, description?: string | null | undefined, required: boolean, position: number, options: Array<{ __typename: 'FieldOption', id: string, value: string }> } }> | null | undefined, endorsers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, followers: Array<{ __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string }>, status: { __typename: 'Status', id: string, position: number, name: string, color: string, stage: StatusStage, type: StatusType }, workspace: { __typename: 'Workspace', id: string, slug: string }, reporter?: { __typename: 'User', id: string, avatarUrl?: string | null | undefined, name: string, email: string } | null | undefined, product?: { __typename: 'Product', id: string, name: string } | null | undefined, platforms: Array<{ __typename: 'Platform', id: string, name: string, color: string, position: number }>, objectives: Array<{ __typename: 'Objective', id: string, name: string, color: string, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> }>, teams: Array<{ __typename: 'Team', id: string, name: string, color: string, position: number }> } | null | undefined };

export type WorkspaceUpdatedSubscriptionVariables = Exact<{
  workspaceId: Scalars['Hashid']['input'];
}>;


export type WorkspaceUpdatedSubscription = { __typename: 'Subscription', workspaceUpdated?: { __typename: 'Workspace', id: string, analyticsId: number, slug: string, name: string, subscription: { __typename: 'BillingSubscription', active: boolean, subscribed: boolean, cancelled?: boolean | null | undefined, onGracePeriod?: boolean | null | undefined, subscriptionEnded?: boolean | null | undefined, pastDue?: boolean | null | undefined, onTrial: boolean, onGenericTrial: boolean, trialEndsAt?: any | null | undefined, subscriptionEndsAt?: any | null | undefined, planId?: string | null | undefined, monthlySpend?: number | null | undefined }, domains: Array<{ __typename: 'WorkspaceDomain', domain: string }>, formulas: Array<{ __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> }>, activeFormula?: { __typename: 'Formula', id: string, key: string, name: string, description?: any | null | undefined, expression?: string | null | undefined, fields: Array<{ __typename: 'FormulaField', id: string, key: string, name: string, type: FormulaFieldType, meta?: { __typename: 'FormulaFieldMeta', min?: number | null | undefined, max?: number | null | undefined, influence?: RatingInfluence | null | undefined, values?: Array<{ __typename: 'FormulaFieldValue', name?: string | null | undefined, value?: number | null | undefined }> | null | undefined } | null | undefined }> } | null | undefined, importances: Array<{ __typename: 'Importance', id: string, title: string, score: number, default: boolean, color?: string | null | undefined }>, connectedJiraResources: Array<{ __typename: 'ConnectedJiraResource', id: string }> } | null | undefined };

export const ActivityLocalDataFragmentDoc = gql`
    fragment ActivityLocalData on Activity {
  tempId @client
}
    `;
export const DeliveryItemJiraAttributesFragmentDoc = gql`
    fragment DeliveryItemJiraAttributes on DeliveryItem {
  jiraAttributes {
    summary
    key
    status {
      id
      name
      description
      statusCategory {
        key
      }
    }
  }
}
    `;
export const DeliveryItemDataFragmentDoc = gql`
    fragment DeliveryItemData on DeliveryItem {
  id
  url
  name
  service
  ...DeliveryItemJiraAttributes
}
    ${DeliveryItemJiraAttributesFragmentDoc}`;
export const UserDataFragmentDoc = gql`
    fragment UserData on User {
  id
  avatarUrl
  name
  email
}
    `;
export const PlatformDataFragmentDoc = gql`
    fragment PlatformData on Platform {
  id
  name
  color
  position
}
    `;
export const TeamDataFragmentDoc = gql`
    fragment TeamData on Team {
  id
  name
  color
  position
}
    `;
export const IdeaListingFragmentDoc = gql`
    fragment IdeaListing on Idea {
  id
  name
  status {
    id
    position
    name
    color
    stage
    type
  }
  workspace {
    id
    slug
  }
  reporter {
    ...UserData
  }
  insightsScore
  endorsementsCount
  start
  end
  granularity
  formulaValues
  score @client
  position
  product {
    id
    name
  }
  platforms {
    ...PlatformData
  }
  objectives {
    id
    name
    color
    teams {
      ...TeamData
    }
  }
  teams {
    ...TeamData
  }
}
    ${UserDataFragmentDoc}
${PlatformDataFragmentDoc}
${TeamDataFragmentDoc}`;
export const FieldDataFragmentDoc = gql`
    fragment FieldData on Field {
  id
  type
  name
  description
  required
  position
  options {
    id
    value
  }
}
    `;
export const IdeaDetailFragmentDoc = gql`
    fragment IdeaDetail on Idea {
  ...IdeaListing
  description
  fields {
    field {
      ...FieldData
    }
    value
  }
  endorsers {
    ...UserData
  }
  followers {
    ...UserData
  }
}
    ${IdeaListingFragmentDoc}
${FieldDataFragmentDoc}
${UserDataFragmentDoc}`;
export const StatusLabelFragmentDoc = gql`
    fragment StatusLabel on Status {
  id
  name
  color
  position
  type
  stage
}
    `;
export const ProductListingFragmentDoc = gql`
    fragment ProductListing on Product {
  id
  name
}
    `;
export const CommentDataFragmentDoc = gql`
    fragment CommentData on Comment {
  id
  user {
    ...UserData
  }
  body
  createdAt
  updatedAt
}
    ${UserDataFragmentDoc}`;
export const UpdateDataFragmentDoc = gql`
    fragment UpdateData on Update {
  id
  body
  user {
    ...UserData
  }
  status {
    ...StatusLabel
  }
  start
  end
  granularity
  createdAt
}
    ${UserDataFragmentDoc}
${StatusLabelFragmentDoc}`;
export const ActivityDataFragmentDoc = gql`
    fragment ActivityData on Activity {
  id
  tempId @client
  type
  createdAt
  user {
    ...UserData
  }
  content {
    ... on Status {
      ...StatusLabel
    }
    ... on Product {
      ...ProductListing
    }
    ... on Comment {
      ...CommentData
    }
    ... on Update {
      ...UpdateData
    }
  }
  previousContent {
    ... on Status {
      ...StatusLabel
    }
    ... on Product {
      ...ProductListing
    }
  }
  value
  previousValue
  model {
    ... on Task {
      id
    }
    ... on Idea {
      id
    }
  }
}
    ${UserDataFragmentDoc}
${StatusLabelFragmentDoc}
${ProductListingFragmentDoc}
${CommentDataFragmentDoc}
${UpdateDataFragmentDoc}`;
export const IdeaWithActivityFragmentDoc = gql`
    fragment IdeaWithActivity on Idea {
  id
  activity {
    ...ActivityData
  }
}
    ${ActivityDataFragmentDoc}`;
export const ContactDataFragmentDoc = gql`
    fragment ContactData on Contact {
  id
  parent {
    id
    type
    name
    email
    domain
    logo
  }
  segment {
    id
    name
    score
    position
  }
  type
  name
  email
  domain
  logo
}
    `;
export const FeedbackNoteDataFragmentDoc = gql`
    fragment FeedbackNoteData on FeedbackNote {
  id
  reporter {
    ...UserData
  }
  contact {
    ...ContactData
  }
  subject
  description
  externalUrl
  createdAt
}
    ${UserDataFragmentDoc}
${ContactDataFragmentDoc}`;
export const ImportanceDataFragmentDoc = gql`
    fragment ImportanceData on Importance {
  id
  title
  score
  default
  color
}
    `;
export const InsightDataFragmentDoc = gql`
    fragment InsightData on Insight {
  id
  feedbackNote {
    ...FeedbackNoteData
  }
  importance {
    ...ImportanceData
  }
}
    ${FeedbackNoteDataFragmentDoc}
${ImportanceDataFragmentDoc}`;
export const InsightsConnectionDataFragmentDoc = gql`
    fragment InsightsConnectionData on InsightConnection {
  edges {
    node {
      ...InsightData
    }
  }
  pageInfo {
    endCursor
    hasNextPage
  }
}
    ${InsightDataFragmentDoc}`;
export const IdeaWithInsightsFragmentDoc = gql`
    fragment IdeaWithInsights on Idea {
  id
  insightsScore
  insights(first: 3, after: $insightsCursor) {
    ...InsightsConnectionData
  }
}
    ${InsightsConnectionDataFragmentDoc}`;
export const KeyResultValueListingFragmentDoc = gql`
    fragment KeyResultValueListing on KeyResultValue {
  id
  date
  value
}
    `;
export const KeyResultDataAllValuesFragmentDoc = gql`
    fragment KeyResultDataAllValues on KeyResult {
  id
  name
  metricType
  metricGoal
  startValue
  targetValue
  objective {
    id
    start
    end
    status {
      color
    }
  }
  currentValue {
    ...KeyResultValueListing
  }
  values {
    ...KeyResultValueListing
  }
  status {
    ...StatusLabel
  }
}
    ${KeyResultValueListingFragmentDoc}
${StatusLabelFragmentDoc}`;
export const MyWorkspacesDataFragmentDoc = gql`
    fragment MyWorkspacesData on Workspace {
  id
  slug
  name
  membership {
    role
    emailNotificationsEnabled
  }
}
    `;
export const MeDataFragmentDoc = gql`
    fragment MeData on User {
  id
  analyticsId
  intercomIdentity
  avatarUrl
  name
  email
  isVerified
  autoJoinDomain
  workspaces {
    ...MyWorkspacesData
  }
}
    ${MyWorkspacesDataFragmentDoc}`;
export const MilestoneListingFragmentDoc = gql`
    fragment MilestoneListing on Milestone {
  id
  name
  date
}
    `;
export const MilestoneListingWithDescriptionFragmentDoc = gql`
    fragment MilestoneListingWithDescription on Milestone {
  ...MilestoneListing
  description
}
    ${MilestoneListingFragmentDoc}`;
export const NotificationDataFragmentDoc = gql`
    fragment NotificationData on Notification {
  id
  type
  author {
    id
    name
  }
  subject {
    id
    name
  }
  content {
    id
    task {
      id
      name
    }
  }
  createdAt
  updatedAt
  readAt
  seenAt
}
    `;
export const ObjectiveDataFragmentDoc = gql`
    fragment ObjectiveData on Objective {
  id
  name
  color
  description
  start
  end
  granularity
  parentId
  teams {
    ...TeamData
  }
  status {
    ...StatusLabel
  }
}
    ${TeamDataFragmentDoc}
${StatusLabelFragmentDoc}`;
export const TaskListingFragmentDoc = gql`
    fragment TaskListing on Task {
  id
  name
  status {
    id
    position
    name
    color
    stage
    type
  }
  workspace {
    id
    slug
  }
  color
  start
  end
  granularity
  formulaValues
  score @client
  position
  product {
    id
    name
  }
  platforms {
    ...PlatformData
  }
  objectives {
    id
    name
    color
    teams {
      ...TeamData
    }
  }
  teams {
    ...TeamData
  }
  dependencies {
    id
  }
}
    ${PlatformDataFragmentDoc}
${TeamDataFragmentDoc}`;
export const KeyResultListingFragmentDoc = gql`
    fragment KeyResultListing on KeyResult {
  id
  name
  metricType
  metricGoal
  startValue
  targetValue
  currentValue {
    ...KeyResultValueListing
  }
  status {
    ...StatusLabel
  }
}
    ${KeyResultValueListingFragmentDoc}
${StatusLabelFragmentDoc}`;
export const UpdatesConnectionDataFragmentDoc = gql`
    fragment UpdatesConnectionData on UpdateConnection {
  edges {
    node {
      ...UpdateData
    }
  }
  pageInfo {
    endCursor
    hasNextPage
  }
}
    ${UpdateDataFragmentDoc}`;
export const ObjectiveDataFullFragmentDoc = gql`
    fragment ObjectiveDataFull on Objective {
  ...ObjectiveData
  tasks {
    ...TaskListing
  }
  keyResults {
    ...KeyResultListing
  }
  updates(first: 3, after: $updatesCursor) {
    ...UpdatesConnectionData
  }
}
    ${ObjectiveDataFragmentDoc}
${TaskListingFragmentDoc}
${KeyResultListingFragmentDoc}
${UpdatesConnectionDataFragmentDoc}`;
export const ObjectiveDataWithKeyResultsFragmentDoc = gql`
    fragment ObjectiveDataWithKeyResults on Objective {
  ...ObjectiveData
  keyResults {
    ...KeyResultListing
  }
}
    ${ObjectiveDataFragmentDoc}
${KeyResultListingFragmentDoc}`;
export const ObjectiveDataWithTasksFragmentDoc = gql`
    fragment ObjectiveDataWithTasks on Objective {
  ...ObjectiveData
  tasks {
    ...TaskListing
  }
  keyResults {
    ...KeyResultListing
  }
}
    ${ObjectiveDataFragmentDoc}
${TaskListingFragmentDoc}
${KeyResultListingFragmentDoc}`;
export const ObjectiveDataWithUpdatesFragmentDoc = gql`
    fragment ObjectiveDataWithUpdates on Objective {
  ...ObjectiveData
  updates(first: 3, after: $updatesCursor) {
    ...UpdatesConnectionData
  }
}
    ${ObjectiveDataFragmentDoc}
${UpdatesConnectionDataFragmentDoc}`;
export const ProductDataFragmentDoc = gql`
    fragment ProductData on Product {
  id
  name
}
    `;
export const ProductListingWithDescriptionFragmentDoc = gql`
    fragment ProductListingWithDescription on Product {
  ...ProductListing
  description
}
    ${ProductListingFragmentDoc}`;
export const ProductListingWithTasksFragmentDoc = gql`
    fragment ProductListingWithTasks on Product {
  id
  name
  tasks {
    ...TaskListing
  }
}
    ${TaskListingFragmentDoc}`;
export const TaskListingWithDescriptionFragmentDoc = gql`
    fragment TaskListingWithDescription on Task {
  ...TaskListing
  description
  dependencies {
    id
    name
    status {
      ...StatusLabel
    }
  }
  updates(first: 3) {
    ...UpdatesConnectionData
  }
  deliveryItems {
    id
    url
    name
    service
  }
  dependentOn {
    id
    name
    status {
      ...StatusLabel
    }
  }
  followers {
    ...UserData
  }
}
    ${TaskListingFragmentDoc}
${StatusLabelFragmentDoc}
${UpdatesConnectionDataFragmentDoc}
${UserDataFragmentDoc}`;
export const TaskObjectivesFragmentDoc = gql`
    fragment TaskObjectives on Task {
  id
  objectives {
    id
    name
    color
  }
}
    `;
export const TaskStatusFragmentDoc = gql`
    fragment TaskStatus on Task {
  status {
    id
    position
    name
    color
    stage
  }
}
    `;
export const TaskTimelineDatesFragmentDoc = gql`
    fragment TaskTimelineDates on Task {
  id
  granularity
  dragStart @client
  dragEnd @client
  dragVertical @client
}
    `;
export const TaskWithActivityFragmentDoc = gql`
    fragment TaskWithActivity on Task {
  id
  activity {
    ...ActivityData
  }
}
    ${ActivityDataFragmentDoc}`;
export const TaskWithUpdatesDataFragmentDoc = gql`
    fragment TaskWithUpdatesData on Task {
  id
  updates(first: 3, after: $updatesCursor) {
    ...UpdatesConnectionData
  }
}
    ${UpdatesConnectionDataFragmentDoc}`;
export const TeamDataWithDescriptionFragmentDoc = gql`
    fragment TeamDataWithDescription on Team {
  ...TeamData
  description
}
    ${TeamDataFragmentDoc}`;
export const TeamDataWithTasksFragmentDoc = gql`
    fragment TeamDataWithTasks on Team {
  ...TeamDataWithDescription
  tasks {
    ...TaskListing
  }
}
    ${TeamDataWithDescriptionFragmentDoc}
${TaskListingFragmentDoc}`;
export const UpdateDataWithTargetFragmentDoc = gql`
    fragment UpdateDataWithTarget on Update {
  ...UpdateData
  target {
    ... on Task {
      ...TaskListing
    }
  }
}
    ${UpdateDataFragmentDoc}
${TaskListingFragmentDoc}`;
export const BillingSubscriptionDataFragmentDoc = gql`
    fragment BillingSubscriptionData on BillingSubscription {
  active
  subscribed
  cancelled
  onGracePeriod
  subscriptionEnded
  pastDue
  onTrial
  onGenericTrial
  trialEndsAt
  subscriptionEndsAt
  planId
  monthlySpend
}
    `;
export const FormulaFieldDataFragmentDoc = gql`
    fragment FormulaFieldData on FormulaField {
  id
  key
  name
  type
  meta {
    min
    max
    influence
    values {
      name
      value
    }
  }
}
    `;
export const FormulaDataFragmentDoc = gql`
    fragment FormulaData on Formula {
  id
  key
  name
  description
  expression
  fields {
    ...FormulaFieldData
  }
}
    ${FormulaFieldDataFragmentDoc}`;
export const WorkspaceListingFragmentDoc = gql`
    fragment WorkspaceListing on Workspace {
  id
  analyticsId
  slug
  name
  subscription {
    ...BillingSubscriptionData
  }
  domains {
    domain
  }
  formulas {
    ...FormulaData
  }
  activeFormula {
    ...FormulaData
  }
  importances {
    ...ImportanceData
  }
  connectedJiraResources {
    id
  }
}
    ${BillingSubscriptionDataFragmentDoc}
${FormulaDataFragmentDoc}
${ImportanceDataFragmentDoc}`;
export const WorkspaceMemberFragmentDoc = gql`
    fragment WorkspaceMember on User {
  id
  name
  email
  membership {
    role
  }
}
    `;
export const WorkspaceSubscriptionDataFragmentDoc = gql`
    fragment WorkspaceSubscriptionData on Workspace {
  id
  slug
  subscription {
    ...BillingSubscriptionData
  }
  subscribeLink
  updateSubscriptionLink
}
    ${BillingSubscriptionDataFragmentDoc}`;
export const WorkspaceWithContactsFragmentDoc = gql`
    fragment WorkspaceWithContacts on Workspace {
  id
  slug
  contacts {
    ...ContactData
  }
}
    ${ContactDataFragmentDoc}`;
export const WorkspaceWithIntegrationsFragmentDoc = gql`
    fragment WorkspaceWithIntegrations on Workspace {
  id
  name
  slug
  connectedJiraResources {
    id
    url
    connectedProjects {
      id
      jiraId
      name
      key
      statusSyncConfig {
        jiraIds
        wayplanId
      }
      allStatuses {
        id
        name
        description
        statusCategory {
          key
        }
      }
    }
    allProjects {
      id
      key
      name
      projectTypeKey
      simplified
      style
      isPrivate
    }
  }
}
    `;
export const WorkspaceWithIntegrationsStatusesFragmentDoc = gql`
    fragment WorkspaceWithIntegrationsStatuses on Workspace {
  id
  name
  slug
  connectedJiraResources {
    id
    url
    connectedProjects {
      id
      jiraId
      name
      key
      statusSyncConfig {
        jiraIds
        wayplanId
      }
      allStatuses {
        id
        name
        description
        statusCategory {
          key
        }
      }
    }
    allProjects {
      id
      key
      name
      projectTypeKey
      simplified
      style
      isPrivate
      allStatuses {
        id
        name
        description
        statusCategory {
          key
        }
      }
    }
  }
}
    `;
export const SegmentDataFragmentDoc = gql`
    fragment SegmentData on Segment {
  id
  name
  score
  position
}
    `;
export const WorkspaceWithSegmentsFragmentDoc = gql`
    fragment WorkspaceWithSegments on Workspace {
  id
  slug
  segments {
    ...SegmentData
  }
}
    ${SegmentDataFragmentDoc}`;
export const AddDeliveryItemDocument = gql`
    mutation addDeliveryItem($input: AddDeliveryItemInput!) {
  addDeliveryItem(input: $input) {
    id
    deliveryItems {
      ...DeliveryItemData
    }
  }
}
    ${DeliveryItemDataFragmentDoc}`;
export type AddDeliveryItemMutationFn = Apollo.MutationFunction<AddDeliveryItemMutation, AddDeliveryItemMutationVariables>;

/**
 * __useAddDeliveryItemMutation__
 *
 * To run a mutation, you first call `useAddDeliveryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDeliveryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDeliveryItemMutation, { data, loading, error }] = useAddDeliveryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDeliveryItemMutation(baseOptions?: Apollo.MutationHookOptions<AddDeliveryItemMutation, AddDeliveryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDeliveryItemMutation, AddDeliveryItemMutationVariables>(AddDeliveryItemDocument, options);
      }
export type AddDeliveryItemMutationHookResult = ReturnType<typeof useAddDeliveryItemMutation>;
export type AddDeliveryItemMutationResult = Apollo.MutationResult<AddDeliveryItemMutation>;
export type AddDeliveryItemMutationOptions = Apollo.BaseMutationOptions<AddDeliveryItemMutation, AddDeliveryItemMutationVariables>;
export const AddDependencyDocument = gql`
    mutation addDependency($input: AddDependencyInput!) {
  addDependency(input: $input) {
    ...TaskListingWithDescription
  }
}
    ${TaskListingWithDescriptionFragmentDoc}`;
export type AddDependencyMutationFn = Apollo.MutationFunction<AddDependencyMutation, AddDependencyMutationVariables>;

/**
 * __useAddDependencyMutation__
 *
 * To run a mutation, you first call `useAddDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDependencyMutation, { data, loading, error }] = useAddDependencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDependencyMutation(baseOptions?: Apollo.MutationHookOptions<AddDependencyMutation, AddDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddDependencyMutation, AddDependencyMutationVariables>(AddDependencyDocument, options);
      }
export type AddDependencyMutationHookResult = ReturnType<typeof useAddDependencyMutation>;
export type AddDependencyMutationResult = Apollo.MutationResult<AddDependencyMutation>;
export type AddDependencyMutationOptions = Apollo.BaseMutationOptions<AddDependencyMutation, AddDependencyMutationVariables>;
export const AddFeatureCommentDocument = gql`
    mutation addFeatureComment($input: AddFeatureCommentInput!) {
  addFeatureComment(input: $input) {
    ...ActivityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddFeatureCommentMutationFn = Apollo.MutationFunction<AddFeatureCommentMutation, AddFeatureCommentMutationVariables>;

/**
 * __useAddFeatureCommentMutation__
 *
 * To run a mutation, you first call `useAddFeatureCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeatureCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeatureCommentMutation, { data, loading, error }] = useAddFeatureCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFeatureCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddFeatureCommentMutation, AddFeatureCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeatureCommentMutation, AddFeatureCommentMutationVariables>(AddFeatureCommentDocument, options);
      }
export type AddFeatureCommentMutationHookResult = ReturnType<typeof useAddFeatureCommentMutation>;
export type AddFeatureCommentMutationResult = Apollo.MutationResult<AddFeatureCommentMutation>;
export type AddFeatureCommentMutationOptions = Apollo.BaseMutationOptions<AddFeatureCommentMutation, AddFeatureCommentMutationVariables>;
export const AddFeatureUpdateDocument = gql`
    mutation addFeatureUpdate($input: AddFeatureUpdateInput!, $updatesCursor: String) {
  addFeatureUpdate(input: $input) {
    ...TaskWithUpdatesData
  }
}
    ${TaskWithUpdatesDataFragmentDoc}`;
export type AddFeatureUpdateMutationFn = Apollo.MutationFunction<AddFeatureUpdateMutation, AddFeatureUpdateMutationVariables>;

/**
 * __useAddFeatureUpdateMutation__
 *
 * To run a mutation, you first call `useAddFeatureUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFeatureUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFeatureUpdateMutation, { data, loading, error }] = useAddFeatureUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updatesCursor: // value for 'updatesCursor'
 *   },
 * });
 */
export function useAddFeatureUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AddFeatureUpdateMutation, AddFeatureUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFeatureUpdateMutation, AddFeatureUpdateMutationVariables>(AddFeatureUpdateDocument, options);
      }
export type AddFeatureUpdateMutationHookResult = ReturnType<typeof useAddFeatureUpdateMutation>;
export type AddFeatureUpdateMutationResult = Apollo.MutationResult<AddFeatureUpdateMutation>;
export type AddFeatureUpdateMutationOptions = Apollo.BaseMutationOptions<AddFeatureUpdateMutation, AddFeatureUpdateMutationVariables>;
export const AddIdeaCommentDocument = gql`
    mutation addIdeaComment($input: AddIdeaCommentInput!) {
  addIdeaComment(input: $input) {
    ...ActivityData
  }
}
    ${ActivityDataFragmentDoc}`;
export type AddIdeaCommentMutationFn = Apollo.MutationFunction<AddIdeaCommentMutation, AddIdeaCommentMutationVariables>;

/**
 * __useAddIdeaCommentMutation__
 *
 * To run a mutation, you first call `useAddIdeaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddIdeaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addIdeaCommentMutation, { data, loading, error }] = useAddIdeaCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddIdeaCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddIdeaCommentMutation, AddIdeaCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddIdeaCommentMutation, AddIdeaCommentMutationVariables>(AddIdeaCommentDocument, options);
      }
export type AddIdeaCommentMutationHookResult = ReturnType<typeof useAddIdeaCommentMutation>;
export type AddIdeaCommentMutationResult = Apollo.MutationResult<AddIdeaCommentMutation>;
export type AddIdeaCommentMutationOptions = Apollo.BaseMutationOptions<AddIdeaCommentMutation, AddIdeaCommentMutationVariables>;
export const AddKeyResultValueDocument = gql`
    mutation addKeyResultValue($input: UpdateKeyResultValueInput!) {
  updateKeyResultValue(input: $input) {
    keyResult {
      ...KeyResultDataAllValues
    }
  }
}
    ${KeyResultDataAllValuesFragmentDoc}`;
export type AddKeyResultValueMutationFn = Apollo.MutationFunction<AddKeyResultValueMutation, AddKeyResultValueMutationVariables>;

/**
 * __useAddKeyResultValueMutation__
 *
 * To run a mutation, you first call `useAddKeyResultValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddKeyResultValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addKeyResultValueMutation, { data, loading, error }] = useAddKeyResultValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddKeyResultValueMutation(baseOptions?: Apollo.MutationHookOptions<AddKeyResultValueMutation, AddKeyResultValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddKeyResultValueMutation, AddKeyResultValueMutationVariables>(AddKeyResultValueDocument, options);
      }
export type AddKeyResultValueMutationHookResult = ReturnType<typeof useAddKeyResultValueMutation>;
export type AddKeyResultValueMutationResult = Apollo.MutationResult<AddKeyResultValueMutation>;
export type AddKeyResultValueMutationOptions = Apollo.BaseMutationOptions<AddKeyResultValueMutation, AddKeyResultValueMutationVariables>;
export const AddObjectiveFeatureDocument = gql`
    mutation addObjectiveFeature($input: AddObjectiveFeatureInput!) {
  addObjectiveFeature(input: $input) {
    ...ObjectiveDataWithTasks
  }
}
    ${ObjectiveDataWithTasksFragmentDoc}`;
export type AddObjectiveFeatureMutationFn = Apollo.MutationFunction<AddObjectiveFeatureMutation, AddObjectiveFeatureMutationVariables>;

/**
 * __useAddObjectiveFeatureMutation__
 *
 * To run a mutation, you first call `useAddObjectiveFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddObjectiveFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addObjectiveFeatureMutation, { data, loading, error }] = useAddObjectiveFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddObjectiveFeatureMutation(baseOptions?: Apollo.MutationHookOptions<AddObjectiveFeatureMutation, AddObjectiveFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddObjectiveFeatureMutation, AddObjectiveFeatureMutationVariables>(AddObjectiveFeatureDocument, options);
      }
export type AddObjectiveFeatureMutationHookResult = ReturnType<typeof useAddObjectiveFeatureMutation>;
export type AddObjectiveFeatureMutationResult = Apollo.MutationResult<AddObjectiveFeatureMutation>;
export type AddObjectiveFeatureMutationOptions = Apollo.BaseMutationOptions<AddObjectiveFeatureMutation, AddObjectiveFeatureMutationVariables>;
export const AddObjectiveUpdateDocument = gql`
    mutation addObjectiveUpdate($input: AddObjectiveUpdateInput!, $updatesCursor: String) {
  addObjectiveUpdate(input: $input) {
    id
    updates(first: 3, after: $updatesCursor) {
      ...UpdatesConnectionData
    }
  }
}
    ${UpdatesConnectionDataFragmentDoc}`;
export type AddObjectiveUpdateMutationFn = Apollo.MutationFunction<AddObjectiveUpdateMutation, AddObjectiveUpdateMutationVariables>;

/**
 * __useAddObjectiveUpdateMutation__
 *
 * To run a mutation, you first call `useAddObjectiveUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddObjectiveUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addObjectiveUpdateMutation, { data, loading, error }] = useAddObjectiveUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updatesCursor: // value for 'updatesCursor'
 *   },
 * });
 */
export function useAddObjectiveUpdateMutation(baseOptions?: Apollo.MutationHookOptions<AddObjectiveUpdateMutation, AddObjectiveUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddObjectiveUpdateMutation, AddObjectiveUpdateMutationVariables>(AddObjectiveUpdateDocument, options);
      }
export type AddObjectiveUpdateMutationHookResult = ReturnType<typeof useAddObjectiveUpdateMutation>;
export type AddObjectiveUpdateMutationResult = Apollo.MutationResult<AddObjectiveUpdateMutation>;
export type AddObjectiveUpdateMutationOptions = Apollo.BaseMutationOptions<AddObjectiveUpdateMutation, AddObjectiveUpdateMutationVariables>;
export const AddTeamFeatureDocument = gql`
    mutation addTeamFeature($input: AddTeamFeatureInput!) {
  addTeamFeature(input: $input) {
    ...TeamDataWithTasks
  }
}
    ${TeamDataWithTasksFragmentDoc}`;
export type AddTeamFeatureMutationFn = Apollo.MutationFunction<AddTeamFeatureMutation, AddTeamFeatureMutationVariables>;

/**
 * __useAddTeamFeatureMutation__
 *
 * To run a mutation, you first call `useAddTeamFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamFeatureMutation, { data, loading, error }] = useAddTeamFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamFeatureMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamFeatureMutation, AddTeamFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamFeatureMutation, AddTeamFeatureMutationVariables>(AddTeamFeatureDocument, options);
      }
export type AddTeamFeatureMutationHookResult = ReturnType<typeof useAddTeamFeatureMutation>;
export type AddTeamFeatureMutationResult = Apollo.MutationResult<AddTeamFeatureMutation>;
export type AddTeamFeatureMutationOptions = Apollo.BaseMutationOptions<AddTeamFeatureMutation, AddTeamFeatureMutationVariables>;
export const CancelWorkspaceSubscriptionDocument = gql`
    mutation cancelWorkspaceSubscription($input: CancelWorkspaceSubscriptionInput!) {
  cancelWorkspaceSubscription(input: $input) {
    ...WorkspaceSubscriptionData
  }
}
    ${WorkspaceSubscriptionDataFragmentDoc}`;
export type CancelWorkspaceSubscriptionMutationFn = Apollo.MutationFunction<CancelWorkspaceSubscriptionMutation, CancelWorkspaceSubscriptionMutationVariables>;

/**
 * __useCancelWorkspaceSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelWorkspaceSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWorkspaceSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWorkspaceSubscriptionMutation, { data, loading, error }] = useCancelWorkspaceSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWorkspaceSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CancelWorkspaceSubscriptionMutation, CancelWorkspaceSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelWorkspaceSubscriptionMutation, CancelWorkspaceSubscriptionMutationVariables>(CancelWorkspaceSubscriptionDocument, options);
      }
export type CancelWorkspaceSubscriptionMutationHookResult = ReturnType<typeof useCancelWorkspaceSubscriptionMutation>;
export type CancelWorkspaceSubscriptionMutationResult = Apollo.MutationResult<CancelWorkspaceSubscriptionMutation>;
export type CancelWorkspaceSubscriptionMutationOptions = Apollo.BaseMutationOptions<CancelWorkspaceSubscriptionMutation, CancelWorkspaceSubscriptionMutationVariables>;
export const BulkCreateFeaturesDocument = gql`
    mutation bulkCreateFeatures($input: BulkCreateFeaturesInput!) {
  bulkCreateFeatures(input: $input) {
    id
  }
}
    `;
export type BulkCreateFeaturesMutationFn = Apollo.MutationFunction<BulkCreateFeaturesMutation, BulkCreateFeaturesMutationVariables>;

/**
 * __useBulkCreateFeaturesMutation__
 *
 * To run a mutation, you first call `useBulkCreateFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateFeaturesMutation, { data, loading, error }] = useBulkCreateFeaturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateFeaturesMutation, BulkCreateFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateFeaturesMutation, BulkCreateFeaturesMutationVariables>(BulkCreateFeaturesDocument, options);
      }
export type BulkCreateFeaturesMutationHookResult = ReturnType<typeof useBulkCreateFeaturesMutation>;
export type BulkCreateFeaturesMutationResult = Apollo.MutationResult<BulkCreateFeaturesMutation>;
export type BulkCreateFeaturesMutationOptions = Apollo.BaseMutationOptions<BulkCreateFeaturesMutation, BulkCreateFeaturesMutationVariables>;
export const CreateContactDocument = gql`
    mutation createContact($input: CreateContactInput!) {
  createContact(input: $input) {
    ...ContactData
  }
}
    ${ContactDataFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const CreateFeatureDocument = gql`
    mutation createFeature($input: CreateFeatureInput!) {
  createFeature(input: $input) {
    ...TaskListing
  }
}
    ${TaskListingFragmentDoc}`;
export type CreateFeatureMutationFn = Apollo.MutationFunction<CreateFeatureMutation, CreateFeatureMutationVariables>;

/**
 * __useCreateFeatureMutation__
 *
 * To run a mutation, you first call `useCreateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureMutation, { data, loading, error }] = useCreateFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureMutation, CreateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureMutation, CreateFeatureMutationVariables>(CreateFeatureDocument, options);
      }
export type CreateFeatureMutationHookResult = ReturnType<typeof useCreateFeatureMutation>;
export type CreateFeatureMutationResult = Apollo.MutationResult<CreateFeatureMutation>;
export type CreateFeatureMutationOptions = Apollo.BaseMutationOptions<CreateFeatureMutation, CreateFeatureMutationVariables>;
export const CreateFeedbackInsightForIdeaDocument = gql`
    mutation createFeedbackInsightForIdea($input: CreateFeedbackInsightForIdeaInput!, $insightsCursor: String) {
  createFeedbackInsightForIdea(input: $input) {
    ...IdeaWithInsights
  }
}
    ${IdeaWithInsightsFragmentDoc}`;
export type CreateFeedbackInsightForIdeaMutationFn = Apollo.MutationFunction<CreateFeedbackInsightForIdeaMutation, CreateFeedbackInsightForIdeaMutationVariables>;

/**
 * __useCreateFeedbackInsightForIdeaMutation__
 *
 * To run a mutation, you first call `useCreateFeedbackInsightForIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeedbackInsightForIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeedbackInsightForIdeaMutation, { data, loading, error }] = useCreateFeedbackInsightForIdeaMutation({
 *   variables: {
 *      input: // value for 'input'
 *      insightsCursor: // value for 'insightsCursor'
 *   },
 * });
 */
export function useCreateFeedbackInsightForIdeaMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeedbackInsightForIdeaMutation, CreateFeedbackInsightForIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeedbackInsightForIdeaMutation, CreateFeedbackInsightForIdeaMutationVariables>(CreateFeedbackInsightForIdeaDocument, options);
      }
export type CreateFeedbackInsightForIdeaMutationHookResult = ReturnType<typeof useCreateFeedbackInsightForIdeaMutation>;
export type CreateFeedbackInsightForIdeaMutationResult = Apollo.MutationResult<CreateFeedbackInsightForIdeaMutation>;
export type CreateFeedbackInsightForIdeaMutationOptions = Apollo.BaseMutationOptions<CreateFeedbackInsightForIdeaMutation, CreateFeedbackInsightForIdeaMutationVariables>;
export const CreateIdeaDocument = gql`
    mutation createIdea($input: CreateIdeaInput!) {
  createIdea(input: $input) {
    ...IdeaListing
  }
}
    ${IdeaListingFragmentDoc}`;
export type CreateIdeaMutationFn = Apollo.MutationFunction<CreateIdeaMutation, CreateIdeaMutationVariables>;

/**
 * __useCreateIdeaMutation__
 *
 * To run a mutation, you first call `useCreateIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdeaMutation, { data, loading, error }] = useCreateIdeaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdeaMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdeaMutation, CreateIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdeaMutation, CreateIdeaMutationVariables>(CreateIdeaDocument, options);
      }
export type CreateIdeaMutationHookResult = ReturnType<typeof useCreateIdeaMutation>;
export type CreateIdeaMutationResult = Apollo.MutationResult<CreateIdeaMutation>;
export type CreateIdeaMutationOptions = Apollo.BaseMutationOptions<CreateIdeaMutation, CreateIdeaMutationVariables>;
export const CreateKeyResultDocument = gql`
    mutation createKeyResult($input: CreateKeyResultInput!) {
  createKeyResult(input: $input) {
    ...ObjectiveDataWithTasks
  }
}
    ${ObjectiveDataWithTasksFragmentDoc}`;
export type CreateKeyResultMutationFn = Apollo.MutationFunction<CreateKeyResultMutation, CreateKeyResultMutationVariables>;

/**
 * __useCreateKeyResultMutation__
 *
 * To run a mutation, you first call `useCreateKeyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyResultMutation, { data, loading, error }] = useCreateKeyResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKeyResultMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyResultMutation, CreateKeyResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyResultMutation, CreateKeyResultMutationVariables>(CreateKeyResultDocument, options);
      }
export type CreateKeyResultMutationHookResult = ReturnType<typeof useCreateKeyResultMutation>;
export type CreateKeyResultMutationResult = Apollo.MutationResult<CreateKeyResultMutation>;
export type CreateKeyResultMutationOptions = Apollo.BaseMutationOptions<CreateKeyResultMutation, CreateKeyResultMutationVariables>;
export const CreateMilestoneDocument = gql`
    mutation createMilestone($input: CreateMilestoneInput!) {
  createMilestone(input: $input) {
    ...MilestoneListing
  }
}
    ${MilestoneListingFragmentDoc}`;
export type CreateMilestoneMutationFn = Apollo.MutationFunction<CreateMilestoneMutation, CreateMilestoneMutationVariables>;

/**
 * __useCreateMilestoneMutation__
 *
 * To run a mutation, you first call `useCreateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMilestoneMutation, { data, loading, error }] = useCreateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<CreateMilestoneMutation, CreateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMilestoneMutation, CreateMilestoneMutationVariables>(CreateMilestoneDocument, options);
      }
export type CreateMilestoneMutationHookResult = ReturnType<typeof useCreateMilestoneMutation>;
export type CreateMilestoneMutationResult = Apollo.MutationResult<CreateMilestoneMutation>;
export type CreateMilestoneMutationOptions = Apollo.BaseMutationOptions<CreateMilestoneMutation, CreateMilestoneMutationVariables>;
export const CreateObjectiveDocument = gql`
    mutation createObjective($input: CreateObjectiveInput!) {
  createObjective(input: $input) {
    ...ObjectiveData
  }
}
    ${ObjectiveDataFragmentDoc}`;
export type CreateObjectiveMutationFn = Apollo.MutationFunction<CreateObjectiveMutation, CreateObjectiveMutationVariables>;

/**
 * __useCreateObjectiveMutation__
 *
 * To run a mutation, you first call `useCreateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createObjectiveMutation, { data, loading, error }] = useCreateObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<CreateObjectiveMutation, CreateObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateObjectiveMutation, CreateObjectiveMutationVariables>(CreateObjectiveDocument, options);
      }
export type CreateObjectiveMutationHookResult = ReturnType<typeof useCreateObjectiveMutation>;
export type CreateObjectiveMutationResult = Apollo.MutationResult<CreateObjectiveMutation>;
export type CreateObjectiveMutationOptions = Apollo.BaseMutationOptions<CreateObjectiveMutation, CreateObjectiveMutationVariables>;
export const CreatePlatformDocument = gql`
    mutation createPlatform($input: CreatePlatformInput!) {
  createPlatform(input: $input) {
    id
    slug
    platforms {
      ...PlatformData
    }
  }
}
    ${PlatformDataFragmentDoc}`;
export type CreatePlatformMutationFn = Apollo.MutationFunction<CreatePlatformMutation, CreatePlatformMutationVariables>;

/**
 * __useCreatePlatformMutation__
 *
 * To run a mutation, you first call `useCreatePlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlatformMutation, { data, loading, error }] = useCreatePlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlatformMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlatformMutation, CreatePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlatformMutation, CreatePlatformMutationVariables>(CreatePlatformDocument, options);
      }
export type CreatePlatformMutationHookResult = ReturnType<typeof useCreatePlatformMutation>;
export type CreatePlatformMutationResult = Apollo.MutationResult<CreatePlatformMutation>;
export type CreatePlatformMutationOptions = Apollo.BaseMutationOptions<CreatePlatformMutation, CreatePlatformMutationVariables>;
export const CreateProductDocument = gql`
    mutation createProduct($input: CreateProductInput!) {
  createProduct(input: $input) {
    id
    name
  }
}
    `;
export type CreateProductMutationFn = Apollo.MutationFunction<CreateProductMutation, CreateProductMutationVariables>;

/**
 * __useCreateProductMutation__
 *
 * To run a mutation, you first call `useCreateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductMutation, { data, loading, error }] = useCreateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductMutation, CreateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductMutation, CreateProductMutationVariables>(CreateProductDocument, options);
      }
export type CreateProductMutationHookResult = ReturnType<typeof useCreateProductMutation>;
export type CreateProductMutationResult = Apollo.MutationResult<CreateProductMutation>;
export type CreateProductMutationOptions = Apollo.BaseMutationOptions<CreateProductMutation, CreateProductMutationVariables>;
export const CreateStatusDocument = gql`
    mutation createStatus($input: CreateStatusInput!) {
  createStatus(input: $input) {
    id
    slug
    statuses {
      ...StatusLabel
    }
  }
}
    ${StatusLabelFragmentDoc}`;
export type CreateStatusMutationFn = Apollo.MutationFunction<CreateStatusMutation, CreateStatusMutationVariables>;

/**
 * __useCreateStatusMutation__
 *
 * To run a mutation, you first call `useCreateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStatusMutation, { data, loading, error }] = useCreateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateStatusMutation, CreateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStatusMutation, CreateStatusMutationVariables>(CreateStatusDocument, options);
      }
export type CreateStatusMutationHookResult = ReturnType<typeof useCreateStatusMutation>;
export type CreateStatusMutationResult = Apollo.MutationResult<CreateStatusMutation>;
export type CreateStatusMutationOptions = Apollo.BaseMutationOptions<CreateStatusMutation, CreateStatusMutationVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    ...TeamData
  }
}
    ${TeamDataFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const CreateWorkspaceDocument = gql`
    mutation createWorkspace($input: CreateWorkspaceInput!) {
  createWorkspace(input: $input) {
    id
    name
    slug
  }
}
    `;
export type CreateWorkspaceMutationFn = Apollo.MutationFunction<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;

/**
 * __useCreateWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkspaceMutation, { data, loading, error }] = useCreateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>(CreateWorkspaceDocument, options);
      }
export type CreateWorkspaceMutationHookResult = ReturnType<typeof useCreateWorkspaceMutation>;
export type CreateWorkspaceMutationResult = Apollo.MutationResult<CreateWorkspaceMutation>;
export type CreateWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateWorkspaceMutation, CreateWorkspaceMutationVariables>;
export const DeleteConnectedJiraResourceDocument = gql`
    mutation deleteConnectedJiraResource($input: DeleteConnectedJiraResourceInput!) {
  deleteConnectedJiraResource(input: $input) {
    ...WorkspaceWithIntegrations
  }
}
    ${WorkspaceWithIntegrationsFragmentDoc}`;
export type DeleteConnectedJiraResourceMutationFn = Apollo.MutationFunction<DeleteConnectedJiraResourceMutation, DeleteConnectedJiraResourceMutationVariables>;

/**
 * __useDeleteConnectedJiraResourceMutation__
 *
 * To run a mutation, you first call `useDeleteConnectedJiraResourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConnectedJiraResourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConnectedJiraResourceMutation, { data, loading, error }] = useDeleteConnectedJiraResourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConnectedJiraResourceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConnectedJiraResourceMutation, DeleteConnectedJiraResourceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConnectedJiraResourceMutation, DeleteConnectedJiraResourceMutationVariables>(DeleteConnectedJiraResourceDocument, options);
      }
export type DeleteConnectedJiraResourceMutationHookResult = ReturnType<typeof useDeleteConnectedJiraResourceMutation>;
export type DeleteConnectedJiraResourceMutationResult = Apollo.MutationResult<DeleteConnectedJiraResourceMutation>;
export type DeleteConnectedJiraResourceMutationOptions = Apollo.BaseMutationOptions<DeleteConnectedJiraResourceMutation, DeleteConnectedJiraResourceMutationVariables>;
export const DeleteDeliveryItemDocument = gql`
    mutation deleteDeliveryItem($input: DeleteDeliveryItemInput!) {
  deleteDeliveryItem(input: $input) {
    id
    deliveryItems {
      ...DeliveryItemData
    }
  }
}
    ${DeliveryItemDataFragmentDoc}`;
export type DeleteDeliveryItemMutationFn = Apollo.MutationFunction<DeleteDeliveryItemMutation, DeleteDeliveryItemMutationVariables>;

/**
 * __useDeleteDeliveryItemMutation__
 *
 * To run a mutation, you first call `useDeleteDeliveryItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDeliveryItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDeliveryItemMutation, { data, loading, error }] = useDeleteDeliveryItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDeliveryItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDeliveryItemMutation, DeleteDeliveryItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDeliveryItemMutation, DeleteDeliveryItemMutationVariables>(DeleteDeliveryItemDocument, options);
      }
export type DeleteDeliveryItemMutationHookResult = ReturnType<typeof useDeleteDeliveryItemMutation>;
export type DeleteDeliveryItemMutationResult = Apollo.MutationResult<DeleteDeliveryItemMutation>;
export type DeleteDeliveryItemMutationOptions = Apollo.BaseMutationOptions<DeleteDeliveryItemMutation, DeleteDeliveryItemMutationVariables>;
export const DeleteFeaturesDocument = gql`
    mutation deleteFeatures($input: DeleteFeaturesInput!) {
  deleteFeatures(input: $input) {
    deletedIds
  }
}
    `;
export type DeleteFeaturesMutationFn = Apollo.MutationFunction<DeleteFeaturesMutation, DeleteFeaturesMutationVariables>;

/**
 * __useDeleteFeaturesMutation__
 *
 * To run a mutation, you first call `useDeleteFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeaturesMutation, { data, loading, error }] = useDeleteFeaturesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeaturesMutation, DeleteFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeaturesMutation, DeleteFeaturesMutationVariables>(DeleteFeaturesDocument, options);
      }
export type DeleteFeaturesMutationHookResult = ReturnType<typeof useDeleteFeaturesMutation>;
export type DeleteFeaturesMutationResult = Apollo.MutationResult<DeleteFeaturesMutation>;
export type DeleteFeaturesMutationOptions = Apollo.BaseMutationOptions<DeleteFeaturesMutation, DeleteFeaturesMutationVariables>;
export const DeleteIdeaInsightDocument = gql`
    mutation deleteIdeaInsight($input: DeleteIdeaInsightInput!, $insightsCursor: String) {
  deleteIdeaInsight(input: $input) {
    ...IdeaWithInsights
  }
}
    ${IdeaWithInsightsFragmentDoc}`;
export type DeleteIdeaInsightMutationFn = Apollo.MutationFunction<DeleteIdeaInsightMutation, DeleteIdeaInsightMutationVariables>;

/**
 * __useDeleteIdeaInsightMutation__
 *
 * To run a mutation, you first call `useDeleteIdeaInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdeaInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdeaInsightMutation, { data, loading, error }] = useDeleteIdeaInsightMutation({
 *   variables: {
 *      input: // value for 'input'
 *      insightsCursor: // value for 'insightsCursor'
 *   },
 * });
 */
export function useDeleteIdeaInsightMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdeaInsightMutation, DeleteIdeaInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdeaInsightMutation, DeleteIdeaInsightMutationVariables>(DeleteIdeaInsightDocument, options);
      }
export type DeleteIdeaInsightMutationHookResult = ReturnType<typeof useDeleteIdeaInsightMutation>;
export type DeleteIdeaInsightMutationResult = Apollo.MutationResult<DeleteIdeaInsightMutation>;
export type DeleteIdeaInsightMutationOptions = Apollo.BaseMutationOptions<DeleteIdeaInsightMutation, DeleteIdeaInsightMutationVariables>;
export const DeleteIdeasDocument = gql`
    mutation deleteIdeas($input: DeleteIdeasInput!) {
  deleteIdeas(input: $input) {
    deletedIds
  }
}
    `;
export type DeleteIdeasMutationFn = Apollo.MutationFunction<DeleteIdeasMutation, DeleteIdeasMutationVariables>;

/**
 * __useDeleteIdeasMutation__
 *
 * To run a mutation, you first call `useDeleteIdeasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdeasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdeasMutation, { data, loading, error }] = useDeleteIdeasMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteIdeasMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdeasMutation, DeleteIdeasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdeasMutation, DeleteIdeasMutationVariables>(DeleteIdeasDocument, options);
      }
export type DeleteIdeasMutationHookResult = ReturnType<typeof useDeleteIdeasMutation>;
export type DeleteIdeasMutationResult = Apollo.MutationResult<DeleteIdeasMutation>;
export type DeleteIdeasMutationOptions = Apollo.BaseMutationOptions<DeleteIdeasMutation, DeleteIdeasMutationVariables>;
export const DeleteInvitationDocument = gql`
    mutation deleteInvitation($input: DeleteInvitationInput!) {
  deleteInvitation(input: $input) {
    id
    name
    slug
    invitations {
      email
      updatedAt
    }
  }
}
    `;
export type DeleteInvitationMutationFn = Apollo.MutationFunction<DeleteInvitationMutation, DeleteInvitationMutationVariables>;

/**
 * __useDeleteInvitationMutation__
 *
 * To run a mutation, you first call `useDeleteInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvitationMutation, { data, loading, error }] = useDeleteInvitationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvitationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteInvitationMutation, DeleteInvitationMutationVariables>(DeleteInvitationDocument, options);
      }
export type DeleteInvitationMutationHookResult = ReturnType<typeof useDeleteInvitationMutation>;
export type DeleteInvitationMutationResult = Apollo.MutationResult<DeleteInvitationMutation>;
export type DeleteInvitationMutationOptions = Apollo.BaseMutationOptions<DeleteInvitationMutation, DeleteInvitationMutationVariables>;
export const DeleteKeyResultDocument = gql`
    mutation deleteKeyResult($input: DeleteKeyResultInput!) {
  deleteKeyResult(input: $input) {
    objective {
      id
      keyResults {
        ...KeyResultListing
      }
    }
  }
}
    ${KeyResultListingFragmentDoc}`;
export type DeleteKeyResultMutationFn = Apollo.MutationFunction<DeleteKeyResultMutation, DeleteKeyResultMutationVariables>;

/**
 * __useDeleteKeyResultMutation__
 *
 * To run a mutation, you first call `useDeleteKeyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKeyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKeyResultMutation, { data, loading, error }] = useDeleteKeyResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteKeyResultMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKeyResultMutation, DeleteKeyResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKeyResultMutation, DeleteKeyResultMutationVariables>(DeleteKeyResultDocument, options);
      }
export type DeleteKeyResultMutationHookResult = ReturnType<typeof useDeleteKeyResultMutation>;
export type DeleteKeyResultMutationResult = Apollo.MutationResult<DeleteKeyResultMutation>;
export type DeleteKeyResultMutationOptions = Apollo.BaseMutationOptions<DeleteKeyResultMutation, DeleteKeyResultMutationVariables>;
export const DeleteKeyResultValueDocument = gql`
    mutation deleteKeyResultValue($input: DeleteKeyResultValueInput!) {
  deleteKeyResultValue(input: $input) {
    ...KeyResultDataAllValues
  }
}
    ${KeyResultDataAllValuesFragmentDoc}`;
export type DeleteKeyResultValueMutationFn = Apollo.MutationFunction<DeleteKeyResultValueMutation, DeleteKeyResultValueMutationVariables>;

/**
 * __useDeleteKeyResultValueMutation__
 *
 * To run a mutation, you first call `useDeleteKeyResultValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKeyResultValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKeyResultValueMutation, { data, loading, error }] = useDeleteKeyResultValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteKeyResultValueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKeyResultValueMutation, DeleteKeyResultValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKeyResultValueMutation, DeleteKeyResultValueMutationVariables>(DeleteKeyResultValueDocument, options);
      }
export type DeleteKeyResultValueMutationHookResult = ReturnType<typeof useDeleteKeyResultValueMutation>;
export type DeleteKeyResultValueMutationResult = Apollo.MutationResult<DeleteKeyResultValueMutation>;
export type DeleteKeyResultValueMutationOptions = Apollo.BaseMutationOptions<DeleteKeyResultValueMutation, DeleteKeyResultValueMutationVariables>;
export const DeleteMemberDocument = gql`
    mutation deleteMember($input: DeleteMemberInput!) {
  deleteMember(input: $input) {
    id
    name
    slug
    members {
      ...WorkspaceMember
    }
  }
}
    ${WorkspaceMemberFragmentDoc}`;
export type DeleteMemberMutationFn = Apollo.MutationFunction<DeleteMemberMutation, DeleteMemberMutationVariables>;

/**
 * __useDeleteMemberMutation__
 *
 * To run a mutation, you first call `useDeleteMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemberMutation, { data, loading, error }] = useDeleteMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMemberMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemberMutation, DeleteMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemberMutation, DeleteMemberMutationVariables>(DeleteMemberDocument, options);
      }
export type DeleteMemberMutationHookResult = ReturnType<typeof useDeleteMemberMutation>;
export type DeleteMemberMutationResult = Apollo.MutationResult<DeleteMemberMutation>;
export type DeleteMemberMutationOptions = Apollo.BaseMutationOptions<DeleteMemberMutation, DeleteMemberMutationVariables>;
export const DeleteMilestoneDocument = gql`
    mutation deleteMilestone($input: DeleteMilestoneInput!) {
  deleteMilestone(input: $input) {
    id
    slug
    milestones {
      ...MilestoneListing
    }
  }
}
    ${MilestoneListingFragmentDoc}`;
export type DeleteMilestoneMutationFn = Apollo.MutationFunction<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>;

/**
 * __useDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMilestoneMutation, { data, loading, error }] = useDeleteMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>(DeleteMilestoneDocument, options);
      }
export type DeleteMilestoneMutationHookResult = ReturnType<typeof useDeleteMilestoneMutation>;
export type DeleteMilestoneMutationResult = Apollo.MutationResult<DeleteMilestoneMutation>;
export type DeleteMilestoneMutationOptions = Apollo.BaseMutationOptions<DeleteMilestoneMutation, DeleteMilestoneMutationVariables>;
export const DeleteObjectiveDocument = gql`
    mutation deleteObjective($input: DeleteObjectiveInput!) {
  deleteObjective(input: $input) {
    id
    name
    slug
    objectives {
      ...ObjectiveData
    }
  }
}
    ${ObjectiveDataFragmentDoc}`;
export type DeleteObjectiveMutationFn = Apollo.MutationFunction<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>;

/**
 * __useDeleteObjectiveMutation__
 *
 * To run a mutation, you first call `useDeleteObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteObjectiveMutation, { data, loading, error }] = useDeleteObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>(DeleteObjectiveDocument, options);
      }
export type DeleteObjectiveMutationHookResult = ReturnType<typeof useDeleteObjectiveMutation>;
export type DeleteObjectiveMutationResult = Apollo.MutationResult<DeleteObjectiveMutation>;
export type DeleteObjectiveMutationOptions = Apollo.BaseMutationOptions<DeleteObjectiveMutation, DeleteObjectiveMutationVariables>;
export const DeletePlatformDocument = gql`
    mutation deletePlatform($input: DeletePlatformInput!) {
  deletePlatform(input: $input) {
    id
    name
    slug
    platforms {
      ...PlatformData
    }
  }
}
    ${PlatformDataFragmentDoc}`;
export type DeletePlatformMutationFn = Apollo.MutationFunction<DeletePlatformMutation, DeletePlatformMutationVariables>;

/**
 * __useDeletePlatformMutation__
 *
 * To run a mutation, you first call `useDeletePlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlatformMutation, { data, loading, error }] = useDeletePlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlatformMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlatformMutation, DeletePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlatformMutation, DeletePlatformMutationVariables>(DeletePlatformDocument, options);
      }
export type DeletePlatformMutationHookResult = ReturnType<typeof useDeletePlatformMutation>;
export type DeletePlatformMutationResult = Apollo.MutationResult<DeletePlatformMutation>;
export type DeletePlatformMutationOptions = Apollo.BaseMutationOptions<DeletePlatformMutation, DeletePlatformMutationVariables>;
export const DeleteProductDocument = gql`
    mutation deleteProduct($input: DeleteProductInput!) {
  deleteProduct(input: $input) {
    id
    slug
    products {
      ...ProductListing
    }
  }
}
    ${ProductListingFragmentDoc}`;
export type DeleteProductMutationFn = Apollo.MutationFunction<DeleteProductMutation, DeleteProductMutationVariables>;

/**
 * __useDeleteProductMutation__
 *
 * To run a mutation, you first call `useDeleteProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProductMutation, { data, loading, error }] = useDeleteProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProductMutation, DeleteProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProductMutation, DeleteProductMutationVariables>(DeleteProductDocument, options);
      }
export type DeleteProductMutationHookResult = ReturnType<typeof useDeleteProductMutation>;
export type DeleteProductMutationResult = Apollo.MutationResult<DeleteProductMutation>;
export type DeleteProductMutationOptions = Apollo.BaseMutationOptions<DeleteProductMutation, DeleteProductMutationVariables>;
export const DeleteStatusDocument = gql`
    mutation deleteStatus($input: DeleteStatusInput!) {
  deleteStatus(input: $input) {
    id
    slug
    statuses {
      ...StatusLabel
    }
  }
}
    ${StatusLabelFragmentDoc}`;
export type DeleteStatusMutationFn = Apollo.MutationFunction<DeleteStatusMutation, DeleteStatusMutationVariables>;

/**
 * __useDeleteStatusMutation__
 *
 * To run a mutation, you first call `useDeleteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStatusMutation, { data, loading, error }] = useDeleteStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStatusMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStatusMutation, DeleteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStatusMutation, DeleteStatusMutationVariables>(DeleteStatusDocument, options);
      }
export type DeleteStatusMutationHookResult = ReturnType<typeof useDeleteStatusMutation>;
export type DeleteStatusMutationResult = Apollo.MutationResult<DeleteStatusMutation>;
export type DeleteStatusMutationOptions = Apollo.BaseMutationOptions<DeleteStatusMutation, DeleteStatusMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($input: DeleteTeamInput!) {
  deleteTeam(input: $input) {
    id
    name
    slug
    teams {
      ...TeamData
    }
  }
}
    ${TeamDataFragmentDoc}`;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($input: ForgotPasswordInput!) {
  forgotPassword(input: $input) {
    success
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const InviteMembersDocument = gql`
    mutation inviteMembers($input: InviteMembersInput!) {
  inviteMembers(input: $input) {
    id
    name
    slug
    members {
      ...WorkspaceMember
    }
  }
}
    ${WorkspaceMemberFragmentDoc}`;
export type InviteMembersMutationFn = Apollo.MutationFunction<InviteMembersMutation, InviteMembersMutationVariables>;

/**
 * __useInviteMembersMutation__
 *
 * To run a mutation, you first call `useInviteMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMembersMutation, { data, loading, error }] = useInviteMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInviteMembersMutation(baseOptions?: Apollo.MutationHookOptions<InviteMembersMutation, InviteMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMembersMutation, InviteMembersMutationVariables>(InviteMembersDocument, options);
      }
export type InviteMembersMutationHookResult = ReturnType<typeof useInviteMembersMutation>;
export type InviteMembersMutationResult = Apollo.MutationResult<InviteMembersMutation>;
export type InviteMembersMutationOptions = Apollo.BaseMutationOptions<InviteMembersMutation, InviteMembersMutationVariables>;
export const LinkJiraProjectDocument = gql`
    mutation linkJiraProject($input: ConnectJiraProjectInput!) {
  connectJiraProject(input: $input) {
    ...WorkspaceWithIntegrations
  }
}
    ${WorkspaceWithIntegrationsFragmentDoc}`;
export type LinkJiraProjectMutationFn = Apollo.MutationFunction<LinkJiraProjectMutation, LinkJiraProjectMutationVariables>;

/**
 * __useLinkJiraProjectMutation__
 *
 * To run a mutation, you first call `useLinkJiraProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkJiraProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkJiraProjectMutation, { data, loading, error }] = useLinkJiraProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkJiraProjectMutation(baseOptions?: Apollo.MutationHookOptions<LinkJiraProjectMutation, LinkJiraProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkJiraProjectMutation, LinkJiraProjectMutationVariables>(LinkJiraProjectDocument, options);
      }
export type LinkJiraProjectMutationHookResult = ReturnType<typeof useLinkJiraProjectMutation>;
export type LinkJiraProjectMutationResult = Apollo.MutationResult<LinkJiraProjectMutation>;
export type LinkJiraProjectMutationOptions = Apollo.BaseMutationOptions<LinkJiraProjectMutation, LinkJiraProjectMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    user {
      id
      name
      workspaces {
        slug
        name
      }
    }
    token
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MarkNotificationsReadDocument = gql`
    mutation markNotificationsRead($input: MarkNotificationsReadInput!) {
  markNotificationsRead(input: $input) {
    id
    slug
    notifications {
      ...NotificationData
    }
  }
}
    ${NotificationDataFragmentDoc}`;
export type MarkNotificationsReadMutationFn = Apollo.MutationFunction<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;

/**
 * __useMarkNotificationsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsReadMutation, { data, loading, error }] = useMarkNotificationsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>(MarkNotificationsReadDocument, options);
      }
export type MarkNotificationsReadMutationHookResult = ReturnType<typeof useMarkNotificationsReadMutation>;
export type MarkNotificationsReadMutationResult = Apollo.MutationResult<MarkNotificationsReadMutation>;
export type MarkNotificationsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;
export const MarkNotificationsSeenDocument = gql`
    mutation markNotificationsSeen($input: MarkNotificationsSeenInput!) {
  markNotificationsSeen(input: $input) {
    id
    slug
    notifications {
      ...NotificationData
    }
  }
}
    ${NotificationDataFragmentDoc}`;
export type MarkNotificationsSeenMutationFn = Apollo.MutationFunction<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>;

/**
 * __useMarkNotificationsSeenMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsSeenMutation, { data, loading, error }] = useMarkNotificationsSeenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkNotificationsSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>(MarkNotificationsSeenDocument, options);
      }
export type MarkNotificationsSeenMutationHookResult = ReturnType<typeof useMarkNotificationsSeenMutation>;
export type MarkNotificationsSeenMutationResult = Apollo.MutationResult<MarkNotificationsSeenMutation>;
export type MarkNotificationsSeenMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsSeenMutation, MarkNotificationsSeenMutationVariables>;
export const RemoveDependencyDocument = gql`
    mutation removeDependency($input: RemoveDependencyInput!) {
  removeDependency(input: $input) {
    ...TaskListingWithDescription
  }
}
    ${TaskListingWithDescriptionFragmentDoc}`;
export type RemoveDependencyMutationFn = Apollo.MutationFunction<RemoveDependencyMutation, RemoveDependencyMutationVariables>;

/**
 * __useRemoveDependencyMutation__
 *
 * To run a mutation, you first call `useRemoveDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDependencyMutation, { data, loading, error }] = useRemoveDependencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDependencyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveDependencyMutation, RemoveDependencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveDependencyMutation, RemoveDependencyMutationVariables>(RemoveDependencyDocument, options);
      }
export type RemoveDependencyMutationHookResult = ReturnType<typeof useRemoveDependencyMutation>;
export type RemoveDependencyMutationResult = Apollo.MutationResult<RemoveDependencyMutation>;
export type RemoveDependencyMutationOptions = Apollo.BaseMutationOptions<RemoveDependencyMutation, RemoveDependencyMutationVariables>;
export const RemoveObjectiveFeatureDocument = gql`
    mutation removeObjectiveFeature($input: RemoveObjectiveFeatureInput!) {
  removeObjectiveFeature(input: $input) {
    ...ObjectiveDataWithTasks
  }
}
    ${ObjectiveDataWithTasksFragmentDoc}`;
export type RemoveObjectiveFeatureMutationFn = Apollo.MutationFunction<RemoveObjectiveFeatureMutation, RemoveObjectiveFeatureMutationVariables>;

/**
 * __useRemoveObjectiveFeatureMutation__
 *
 * To run a mutation, you first call `useRemoveObjectiveFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveObjectiveFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeObjectiveFeatureMutation, { data, loading, error }] = useRemoveObjectiveFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveObjectiveFeatureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveObjectiveFeatureMutation, RemoveObjectiveFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveObjectiveFeatureMutation, RemoveObjectiveFeatureMutationVariables>(RemoveObjectiveFeatureDocument, options);
      }
export type RemoveObjectiveFeatureMutationHookResult = ReturnType<typeof useRemoveObjectiveFeatureMutation>;
export type RemoveObjectiveFeatureMutationResult = Apollo.MutationResult<RemoveObjectiveFeatureMutation>;
export type RemoveObjectiveFeatureMutationOptions = Apollo.BaseMutationOptions<RemoveObjectiveFeatureMutation, RemoveObjectiveFeatureMutationVariables>;
export const RemoveTeamFeatureDocument = gql`
    mutation removeTeamFeature($input: RemoveTeamFeatureInput!) {
  removeTeamFeature(input: $input) {
    ...TeamDataWithTasks
  }
}
    ${TeamDataWithTasksFragmentDoc}`;
export type RemoveTeamFeatureMutationFn = Apollo.MutationFunction<RemoveTeamFeatureMutation, RemoveTeamFeatureMutationVariables>;

/**
 * __useRemoveTeamFeatureMutation__
 *
 * To run a mutation, you first call `useRemoveTeamFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamFeatureMutation, { data, loading, error }] = useRemoveTeamFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamFeatureMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamFeatureMutation, RemoveTeamFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamFeatureMutation, RemoveTeamFeatureMutationVariables>(RemoveTeamFeatureDocument, options);
      }
export type RemoveTeamFeatureMutationHookResult = ReturnType<typeof useRemoveTeamFeatureMutation>;
export type RemoveTeamFeatureMutationResult = Apollo.MutationResult<RemoveTeamFeatureMutation>;
export type RemoveTeamFeatureMutationOptions = Apollo.BaseMutationOptions<RemoveTeamFeatureMutation, RemoveTeamFeatureMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input) {
    user {
      id
      name
      workspaces {
        slug
        name
      }
    }
    token
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetFeatureFollowingDocument = gql`
    mutation setFeatureFollowing($input: SetFeatureFollowingInput!) {
  setFeatureFollowing(input: $input) {
    id
    followers {
      ...UserData
    }
  }
}
    ${UserDataFragmentDoc}`;
export type SetFeatureFollowingMutationFn = Apollo.MutationFunction<SetFeatureFollowingMutation, SetFeatureFollowingMutationVariables>;

/**
 * __useSetFeatureFollowingMutation__
 *
 * To run a mutation, you first call `useSetFeatureFollowingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeatureFollowingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeatureFollowingMutation, { data, loading, error }] = useSetFeatureFollowingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFeatureFollowingMutation(baseOptions?: Apollo.MutationHookOptions<SetFeatureFollowingMutation, SetFeatureFollowingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFeatureFollowingMutation, SetFeatureFollowingMutationVariables>(SetFeatureFollowingDocument, options);
      }
export type SetFeatureFollowingMutationHookResult = ReturnType<typeof useSetFeatureFollowingMutation>;
export type SetFeatureFollowingMutationResult = Apollo.MutationResult<SetFeatureFollowingMutation>;
export type SetFeatureFollowingMutationOptions = Apollo.BaseMutationOptions<SetFeatureFollowingMutation, SetFeatureFollowingMutationVariables>;
export const SetFeaturesStatusDocument = gql`
    mutation setFeaturesStatus($input: SetFeaturesStatusInput!) {
  setFeaturesStatus(input: $input) {
    features {
      id
      name
      status {
        id
        name
        color
        position
        stage
      }
    }
  }
}
    `;
export type SetFeaturesStatusMutationFn = Apollo.MutationFunction<SetFeaturesStatusMutation, SetFeaturesStatusMutationVariables>;

/**
 * __useSetFeaturesStatusMutation__
 *
 * To run a mutation, you first call `useSetFeaturesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeaturesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeaturesStatusMutation, { data, loading, error }] = useSetFeaturesStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFeaturesStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetFeaturesStatusMutation, SetFeaturesStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFeaturesStatusMutation, SetFeaturesStatusMutationVariables>(SetFeaturesStatusDocument, options);
      }
export type SetFeaturesStatusMutationHookResult = ReturnType<typeof useSetFeaturesStatusMutation>;
export type SetFeaturesStatusMutationResult = Apollo.MutationResult<SetFeaturesStatusMutation>;
export type SetFeaturesStatusMutationOptions = Apollo.BaseMutationOptions<SetFeaturesStatusMutation, SetFeaturesStatusMutationVariables>;
export const SetFeaturesTimeFrameDocument = gql`
    mutation setFeaturesTimeFrame($input: SetFeaturesTimeFrameInput!) {
  setFeaturesTimeFrame(input: $input) {
    features {
      id
      start
      end
      granularity
    }
  }
}
    `;
export type SetFeaturesTimeFrameMutationFn = Apollo.MutationFunction<SetFeaturesTimeFrameMutation, SetFeaturesTimeFrameMutationVariables>;

/**
 * __useSetFeaturesTimeFrameMutation__
 *
 * To run a mutation, you first call `useSetFeaturesTimeFrameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeaturesTimeFrameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeaturesTimeFrameMutation, { data, loading, error }] = useSetFeaturesTimeFrameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFeaturesTimeFrameMutation(baseOptions?: Apollo.MutationHookOptions<SetFeaturesTimeFrameMutation, SetFeaturesTimeFrameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFeaturesTimeFrameMutation, SetFeaturesTimeFrameMutationVariables>(SetFeaturesTimeFrameDocument, options);
      }
export type SetFeaturesTimeFrameMutationHookResult = ReturnType<typeof useSetFeaturesTimeFrameMutation>;
export type SetFeaturesTimeFrameMutationResult = Apollo.MutationResult<SetFeaturesTimeFrameMutation>;
export type SetFeaturesTimeFrameMutationOptions = Apollo.BaseMutationOptions<SetFeaturesTimeFrameMutation, SetFeaturesTimeFrameMutationVariables>;
export const SetIdeaEndorsingDocument = gql`
    mutation setIdeaEndorsing($input: SetIdeaEndorsingInput!) {
  setIdeaEndorsing(input: $input) {
    id
    endorsers {
      ...UserData
    }
  }
}
    ${UserDataFragmentDoc}`;
export type SetIdeaEndorsingMutationFn = Apollo.MutationFunction<SetIdeaEndorsingMutation, SetIdeaEndorsingMutationVariables>;

/**
 * __useSetIdeaEndorsingMutation__
 *
 * To run a mutation, you first call `useSetIdeaEndorsingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIdeaEndorsingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIdeaEndorsingMutation, { data, loading, error }] = useSetIdeaEndorsingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIdeaEndorsingMutation(baseOptions?: Apollo.MutationHookOptions<SetIdeaEndorsingMutation, SetIdeaEndorsingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIdeaEndorsingMutation, SetIdeaEndorsingMutationVariables>(SetIdeaEndorsingDocument, options);
      }
export type SetIdeaEndorsingMutationHookResult = ReturnType<typeof useSetIdeaEndorsingMutation>;
export type SetIdeaEndorsingMutationResult = Apollo.MutationResult<SetIdeaEndorsingMutation>;
export type SetIdeaEndorsingMutationOptions = Apollo.BaseMutationOptions<SetIdeaEndorsingMutation, SetIdeaEndorsingMutationVariables>;
export const SetIdeaFollowingDocument = gql`
    mutation setIdeaFollowing($input: SetIdeaFollowingInput!) {
  setIdeaFollowing(input: $input) {
    id
    followers {
      ...UserData
    }
  }
}
    ${UserDataFragmentDoc}`;
export type SetIdeaFollowingMutationFn = Apollo.MutationFunction<SetIdeaFollowingMutation, SetIdeaFollowingMutationVariables>;

/**
 * __useSetIdeaFollowingMutation__
 *
 * To run a mutation, you first call `useSetIdeaFollowingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIdeaFollowingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIdeaFollowingMutation, { data, loading, error }] = useSetIdeaFollowingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIdeaFollowingMutation(baseOptions?: Apollo.MutationHookOptions<SetIdeaFollowingMutation, SetIdeaFollowingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIdeaFollowingMutation, SetIdeaFollowingMutationVariables>(SetIdeaFollowingDocument, options);
      }
export type SetIdeaFollowingMutationHookResult = ReturnType<typeof useSetIdeaFollowingMutation>;
export type SetIdeaFollowingMutationResult = Apollo.MutationResult<SetIdeaFollowingMutation>;
export type SetIdeaFollowingMutationOptions = Apollo.BaseMutationOptions<SetIdeaFollowingMutation, SetIdeaFollowingMutationVariables>;
export const SetIdeasStatusDocument = gql`
    mutation setIdeasStatus($input: SetIdeasStatusInput!) {
  setIdeasStatus(input: $input) {
    ideas {
      id
      status {
        ...StatusLabel
      }
    }
  }
}
    ${StatusLabelFragmentDoc}`;
export type SetIdeasStatusMutationFn = Apollo.MutationFunction<SetIdeasStatusMutation, SetIdeasStatusMutationVariables>;

/**
 * __useSetIdeasStatusMutation__
 *
 * To run a mutation, you first call `useSetIdeasStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIdeasStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIdeasStatusMutation, { data, loading, error }] = useSetIdeasStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIdeasStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetIdeasStatusMutation, SetIdeasStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIdeasStatusMutation, SetIdeasStatusMutationVariables>(SetIdeasStatusDocument, options);
      }
export type SetIdeasStatusMutationHookResult = ReturnType<typeof useSetIdeasStatusMutation>;
export type SetIdeasStatusMutationResult = Apollo.MutationResult<SetIdeasStatusMutation>;
export type SetIdeasStatusMutationOptions = Apollo.BaseMutationOptions<SetIdeasStatusMutation, SetIdeasStatusMutationVariables>;
export const SetKeyResultsStatusDocument = gql`
    mutation setKeyResultsStatus($input: SetKeyResultsStatusInput!) {
  setKeyResultsStatus(input: $input) {
    keyResults {
      id
      status {
        ...StatusLabel
      }
    }
  }
}
    ${StatusLabelFragmentDoc}`;
export type SetKeyResultsStatusMutationFn = Apollo.MutationFunction<SetKeyResultsStatusMutation, SetKeyResultsStatusMutationVariables>;

/**
 * __useSetKeyResultsStatusMutation__
 *
 * To run a mutation, you first call `useSetKeyResultsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetKeyResultsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setKeyResultsStatusMutation, { data, loading, error }] = useSetKeyResultsStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetKeyResultsStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetKeyResultsStatusMutation, SetKeyResultsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetKeyResultsStatusMutation, SetKeyResultsStatusMutationVariables>(SetKeyResultsStatusDocument, options);
      }
export type SetKeyResultsStatusMutationHookResult = ReturnType<typeof useSetKeyResultsStatusMutation>;
export type SetKeyResultsStatusMutationResult = Apollo.MutationResult<SetKeyResultsStatusMutation>;
export type SetKeyResultsStatusMutationOptions = Apollo.BaseMutationOptions<SetKeyResultsStatusMutation, SetKeyResultsStatusMutationVariables>;
export const SetObjectivesStatusDocument = gql`
    mutation setObjectivesStatus($input: SetObjectivesStatusInput!) {
  setObjectivesStatus(input: $input) {
    objectives {
      id
      status {
        ...StatusLabel
      }
    }
  }
}
    ${StatusLabelFragmentDoc}`;
export type SetObjectivesStatusMutationFn = Apollo.MutationFunction<SetObjectivesStatusMutation, SetObjectivesStatusMutationVariables>;

/**
 * __useSetObjectivesStatusMutation__
 *
 * To run a mutation, you first call `useSetObjectivesStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetObjectivesStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setObjectivesStatusMutation, { data, loading, error }] = useSetObjectivesStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetObjectivesStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetObjectivesStatusMutation, SetObjectivesStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetObjectivesStatusMutation, SetObjectivesStatusMutationVariables>(SetObjectivesStatusDocument, options);
      }
export type SetObjectivesStatusMutationHookResult = ReturnType<typeof useSetObjectivesStatusMutation>;
export type SetObjectivesStatusMutationResult = Apollo.MutationResult<SetObjectivesStatusMutation>;
export type SetObjectivesStatusMutationOptions = Apollo.BaseMutationOptions<SetObjectivesStatusMutation, SetObjectivesStatusMutationVariables>;
export const SetObjectivesTimeFrameDocument = gql`
    mutation setObjectivesTimeFrame($input: SetObjectivesTimeFrameInput!) {
  setObjectivesTimeFrame(input: $input) {
    objectives {
      id
      start
      end
      granularity
    }
  }
}
    `;
export type SetObjectivesTimeFrameMutationFn = Apollo.MutationFunction<SetObjectivesTimeFrameMutation, SetObjectivesTimeFrameMutationVariables>;

/**
 * __useSetObjectivesTimeFrameMutation__
 *
 * To run a mutation, you first call `useSetObjectivesTimeFrameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetObjectivesTimeFrameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setObjectivesTimeFrameMutation, { data, loading, error }] = useSetObjectivesTimeFrameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetObjectivesTimeFrameMutation(baseOptions?: Apollo.MutationHookOptions<SetObjectivesTimeFrameMutation, SetObjectivesTimeFrameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetObjectivesTimeFrameMutation, SetObjectivesTimeFrameMutationVariables>(SetObjectivesTimeFrameDocument, options);
      }
export type SetObjectivesTimeFrameMutationHookResult = ReturnType<typeof useSetObjectivesTimeFrameMutation>;
export type SetObjectivesTimeFrameMutationResult = Apollo.MutationResult<SetObjectivesTimeFrameMutation>;
export type SetObjectivesTimeFrameMutationOptions = Apollo.BaseMutationOptions<SetObjectivesTimeFrameMutation, SetObjectivesTimeFrameMutationVariables>;
export const SignupDocument = gql`
    mutation signup($input: SignupInput!) {
  signup(input: $input) {
    verification
    token
    user {
      id
      name
      workspaces {
        slug
        name
      }
    }
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const UnlinkJiraProjectDocument = gql`
    mutation unlinkJiraProject($input: DeleteConnectedJiraProjectInput!) {
  deleteConnectedJiraProject(input: $input) {
    ...WorkspaceWithIntegrations
  }
}
    ${WorkspaceWithIntegrationsFragmentDoc}`;
export type UnlinkJiraProjectMutationFn = Apollo.MutationFunction<UnlinkJiraProjectMutation, UnlinkJiraProjectMutationVariables>;

/**
 * __useUnlinkJiraProjectMutation__
 *
 * To run a mutation, you first call `useUnlinkJiraProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkJiraProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkJiraProjectMutation, { data, loading, error }] = useUnlinkJiraProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkJiraProjectMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkJiraProjectMutation, UnlinkJiraProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkJiraProjectMutation, UnlinkJiraProjectMutationVariables>(UnlinkJiraProjectDocument, options);
      }
export type UnlinkJiraProjectMutationHookResult = ReturnType<typeof useUnlinkJiraProjectMutation>;
export type UnlinkJiraProjectMutationResult = Apollo.MutationResult<UnlinkJiraProjectMutation>;
export type UnlinkJiraProjectMutationOptions = Apollo.BaseMutationOptions<UnlinkJiraProjectMutation, UnlinkJiraProjectMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation updateAccount($input: UpdateAccountInput!) {
  updateAccount(input: $input) {
    id
    avatarUrl
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const UpdateFeatureDocument = gql`
    mutation updateFeature($input: UpdateFeatureInput!) {
  updateFeature(input: $input) {
    id
    name
    description
    formulaValues
    position
    platforms {
      ...PlatformData
    }
    status {
      ...StatusLabel
    }
    objectives {
      ...ObjectiveData
    }
    teams {
      id
      name
      color
      position
    }
  }
}
    ${PlatformDataFragmentDoc}
${StatusLabelFragmentDoc}
${ObjectiveDataFragmentDoc}`;
export type UpdateFeatureMutationFn = Apollo.MutationFunction<UpdateFeatureMutation, UpdateFeatureMutationVariables>;

/**
 * __useUpdateFeatureMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureMutation, { data, loading, error }] = useUpdateFeatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFeatureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureMutation, UpdateFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureMutation, UpdateFeatureMutationVariables>(UpdateFeatureDocument, options);
      }
export type UpdateFeatureMutationHookResult = ReturnType<typeof useUpdateFeatureMutation>;
export type UpdateFeatureMutationResult = Apollo.MutationResult<UpdateFeatureMutation>;
export type UpdateFeatureMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureMutation, UpdateFeatureMutationVariables>;
export const UpdateIdeaDocument = gql`
    mutation updateIdea($input: UpdateIdeaInput!) {
  updateIdea(input: $input) {
    ...IdeaListing
  }
}
    ${IdeaListingFragmentDoc}`;
export type UpdateIdeaMutationFn = Apollo.MutationFunction<UpdateIdeaMutation, UpdateIdeaMutationVariables>;

/**
 * __useUpdateIdeaMutation__
 *
 * To run a mutation, you first call `useUpdateIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdeaMutation, { data, loading, error }] = useUpdateIdeaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdeaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdeaMutation, UpdateIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdeaMutation, UpdateIdeaMutationVariables>(UpdateIdeaDocument, options);
      }
export type UpdateIdeaMutationHookResult = ReturnType<typeof useUpdateIdeaMutation>;
export type UpdateIdeaMutationResult = Apollo.MutationResult<UpdateIdeaMutation>;
export type UpdateIdeaMutationOptions = Apollo.BaseMutationOptions<UpdateIdeaMutation, UpdateIdeaMutationVariables>;
export const UpdateIdeaInsightDocument = gql`
    mutation updateIdeaInsight($input: UpdateIdeaInsightInput!) {
  updateIdeaInsight(input: $input) {
    ...InsightData
  }
}
    ${InsightDataFragmentDoc}`;
export type UpdateIdeaInsightMutationFn = Apollo.MutationFunction<UpdateIdeaInsightMutation, UpdateIdeaInsightMutationVariables>;

/**
 * __useUpdateIdeaInsightMutation__
 *
 * To run a mutation, you first call `useUpdateIdeaInsightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdeaInsightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdeaInsightMutation, { data, loading, error }] = useUpdateIdeaInsightMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdeaInsightMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdeaInsightMutation, UpdateIdeaInsightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdeaInsightMutation, UpdateIdeaInsightMutationVariables>(UpdateIdeaInsightDocument, options);
      }
export type UpdateIdeaInsightMutationHookResult = ReturnType<typeof useUpdateIdeaInsightMutation>;
export type UpdateIdeaInsightMutationResult = Apollo.MutationResult<UpdateIdeaInsightMutation>;
export type UpdateIdeaInsightMutationOptions = Apollo.BaseMutationOptions<UpdateIdeaInsightMutation, UpdateIdeaInsightMutationVariables>;
export const UpdateJiraProjectDocument = gql`
    mutation updateJiraProject($input: UpdateJiraProjectInput!) {
  updateJiraProject(input: $input) {
    ...WorkspaceWithIntegrations
  }
}
    ${WorkspaceWithIntegrationsFragmentDoc}`;
export type UpdateJiraProjectMutationFn = Apollo.MutationFunction<UpdateJiraProjectMutation, UpdateJiraProjectMutationVariables>;

/**
 * __useUpdateJiraProjectMutation__
 *
 * To run a mutation, you first call `useUpdateJiraProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJiraProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJiraProjectMutation, { data, loading, error }] = useUpdateJiraProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateJiraProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJiraProjectMutation, UpdateJiraProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJiraProjectMutation, UpdateJiraProjectMutationVariables>(UpdateJiraProjectDocument, options);
      }
export type UpdateJiraProjectMutationHookResult = ReturnType<typeof useUpdateJiraProjectMutation>;
export type UpdateJiraProjectMutationResult = Apollo.MutationResult<UpdateJiraProjectMutation>;
export type UpdateJiraProjectMutationOptions = Apollo.BaseMutationOptions<UpdateJiraProjectMutation, UpdateJiraProjectMutationVariables>;
export const UpdateKeyResultDocument = gql`
    mutation updateKeyResult($input: UpdateKeyResultInput!) {
  updateKeyResult(input: $input) {
    keyResult {
      ...KeyResultListing
    }
  }
}
    ${KeyResultListingFragmentDoc}`;
export type UpdateKeyResultMutationFn = Apollo.MutationFunction<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>;

/**
 * __useUpdateKeyResultMutation__
 *
 * To run a mutation, you first call `useUpdateKeyResultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyResultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyResultMutation, { data, loading, error }] = useUpdateKeyResultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyResultMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>(UpdateKeyResultDocument, options);
      }
export type UpdateKeyResultMutationHookResult = ReturnType<typeof useUpdateKeyResultMutation>;
export type UpdateKeyResultMutationResult = Apollo.MutationResult<UpdateKeyResultMutation>;
export type UpdateKeyResultMutationOptions = Apollo.BaseMutationOptions<UpdateKeyResultMutation, UpdateKeyResultMutationVariables>;
export const UpdateKeyResultValueDocument = gql`
    mutation updateKeyResultValue($input: UpdateKeyResultValueInput!) {
  updateKeyResultValue(input: $input) {
    keyResult {
      ...KeyResultListing
    }
  }
}
    ${KeyResultListingFragmentDoc}`;
export type UpdateKeyResultValueMutationFn = Apollo.MutationFunction<UpdateKeyResultValueMutation, UpdateKeyResultValueMutationVariables>;

/**
 * __useUpdateKeyResultValueMutation__
 *
 * To run a mutation, you first call `useUpdateKeyResultValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyResultValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyResultValueMutation, { data, loading, error }] = useUpdateKeyResultValueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyResultValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyResultValueMutation, UpdateKeyResultValueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyResultValueMutation, UpdateKeyResultValueMutationVariables>(UpdateKeyResultValueDocument, options);
      }
export type UpdateKeyResultValueMutationHookResult = ReturnType<typeof useUpdateKeyResultValueMutation>;
export type UpdateKeyResultValueMutationResult = Apollo.MutationResult<UpdateKeyResultValueMutation>;
export type UpdateKeyResultValueMutationOptions = Apollo.BaseMutationOptions<UpdateKeyResultValueMutation, UpdateKeyResultValueMutationVariables>;
export const UpdateKeyResultValueByIdDocument = gql`
    mutation updateKeyResultValueById($input: UpdateKeyResultValueByIdInput!) {
  updateKeyResultValueById(input: $input) {
    ...KeyResultDataAllValues
  }
}
    ${KeyResultDataAllValuesFragmentDoc}`;
export type UpdateKeyResultValueByIdMutationFn = Apollo.MutationFunction<UpdateKeyResultValueByIdMutation, UpdateKeyResultValueByIdMutationVariables>;

/**
 * __useUpdateKeyResultValueByIdMutation__
 *
 * To run a mutation, you first call `useUpdateKeyResultValueByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyResultValueByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyResultValueByIdMutation, { data, loading, error }] = useUpdateKeyResultValueByIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyResultValueByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyResultValueByIdMutation, UpdateKeyResultValueByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyResultValueByIdMutation, UpdateKeyResultValueByIdMutationVariables>(UpdateKeyResultValueByIdDocument, options);
      }
export type UpdateKeyResultValueByIdMutationHookResult = ReturnType<typeof useUpdateKeyResultValueByIdMutation>;
export type UpdateKeyResultValueByIdMutationResult = Apollo.MutationResult<UpdateKeyResultValueByIdMutation>;
export type UpdateKeyResultValueByIdMutationOptions = Apollo.BaseMutationOptions<UpdateKeyResultValueByIdMutation, UpdateKeyResultValueByIdMutationVariables>;
export const UpdateMemberEmailNotificationsDocument = gql`
    mutation updateMemberEmailNotifications($input: UpdateMemberEmailNotificationsInput!) {
  updateMemberEmailNotifications(input: $input) {
    ...MeData
  }
}
    ${MeDataFragmentDoc}`;
export type UpdateMemberEmailNotificationsMutationFn = Apollo.MutationFunction<UpdateMemberEmailNotificationsMutation, UpdateMemberEmailNotificationsMutationVariables>;

/**
 * __useUpdateMemberEmailNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateMemberEmailNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberEmailNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberEmailNotificationsMutation, { data, loading, error }] = useUpdateMemberEmailNotificationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberEmailNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberEmailNotificationsMutation, UpdateMemberEmailNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberEmailNotificationsMutation, UpdateMemberEmailNotificationsMutationVariables>(UpdateMemberEmailNotificationsDocument, options);
      }
export type UpdateMemberEmailNotificationsMutationHookResult = ReturnType<typeof useUpdateMemberEmailNotificationsMutation>;
export type UpdateMemberEmailNotificationsMutationResult = Apollo.MutationResult<UpdateMemberEmailNotificationsMutation>;
export type UpdateMemberEmailNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateMemberEmailNotificationsMutation, UpdateMemberEmailNotificationsMutationVariables>;
export const UpdateMemberRoleDocument = gql`
    mutation updateMemberRole($input: UpdateMemberRoleInput!) {
  updateMemberRole(input: $input) {
    id
    name
    slug
    members {
      ...WorkspaceMember
    }
  }
}
    ${WorkspaceMemberFragmentDoc}`;
export type UpdateMemberRoleMutationFn = Apollo.MutationFunction<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;

/**
 * __useUpdateMemberRoleMutation__
 *
 * To run a mutation, you first call `useUpdateMemberRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberRoleMutation, { data, loading, error }] = useUpdateMemberRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemberRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>(UpdateMemberRoleDocument, options);
      }
export type UpdateMemberRoleMutationHookResult = ReturnType<typeof useUpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationResult = Apollo.MutationResult<UpdateMemberRoleMutation>;
export type UpdateMemberRoleMutationOptions = Apollo.BaseMutationOptions<UpdateMemberRoleMutation, UpdateMemberRoleMutationVariables>;
export const UpdateMilestoneDocument = gql`
    mutation updateMilestone($input: UpdateMilestoneInput!) {
  updateMilestone(input: $input) {
    ...MilestoneListingWithDescription
  }
}
    ${MilestoneListingWithDescriptionFragmentDoc}`;
export type UpdateMilestoneMutationFn = Apollo.MutationFunction<UpdateMilestoneMutation, UpdateMilestoneMutationVariables>;

/**
 * __useUpdateMilestoneMutation__
 *
 * To run a mutation, you first call `useUpdateMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMilestoneMutation, { data, loading, error }] = useUpdateMilestoneMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMilestoneMutation, UpdateMilestoneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMilestoneMutation, UpdateMilestoneMutationVariables>(UpdateMilestoneDocument, options);
      }
export type UpdateMilestoneMutationHookResult = ReturnType<typeof useUpdateMilestoneMutation>;
export type UpdateMilestoneMutationResult = Apollo.MutationResult<UpdateMilestoneMutation>;
export type UpdateMilestoneMutationOptions = Apollo.BaseMutationOptions<UpdateMilestoneMutation, UpdateMilestoneMutationVariables>;
export const UpdateObjectiveDocument = gql`
    mutation updateObjective($input: UpdateObjectiveInput!) {
  updateObjective(input: $input) {
    ...ObjectiveData
  }
}
    ${ObjectiveDataFragmentDoc}`;
export type UpdateObjectiveMutationFn = Apollo.MutationFunction<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>;

/**
 * __useUpdateObjectiveMutation__
 *
 * To run a mutation, you first call `useUpdateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateObjectiveMutation, { data, loading, error }] = useUpdateObjectiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>(UpdateObjectiveDocument, options);
      }
export type UpdateObjectiveMutationHookResult = ReturnType<typeof useUpdateObjectiveMutation>;
export type UpdateObjectiveMutationResult = Apollo.MutationResult<UpdateObjectiveMutation>;
export type UpdateObjectiveMutationOptions = Apollo.BaseMutationOptions<UpdateObjectiveMutation, UpdateObjectiveMutationVariables>;
export const UpdatePlatformDocument = gql`
    mutation updatePlatform($input: UpdatePlatformInput!) {
  updatePlatform(input: $input) {
    ...PlatformData
  }
}
    ${PlatformDataFragmentDoc}`;
export type UpdatePlatformMutationFn = Apollo.MutationFunction<UpdatePlatformMutation, UpdatePlatformMutationVariables>;

/**
 * __useUpdatePlatformMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformMutation, { data, loading, error }] = useUpdatePlatformMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformMutation, UpdatePlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformMutation, UpdatePlatformMutationVariables>(UpdatePlatformDocument, options);
      }
export type UpdatePlatformMutationHookResult = ReturnType<typeof useUpdatePlatformMutation>;
export type UpdatePlatformMutationResult = Apollo.MutationResult<UpdatePlatformMutation>;
export type UpdatePlatformMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformMutation, UpdatePlatformMutationVariables>;
export const UpdateProductDocument = gql`
    mutation updateProduct($input: UpdateProductInput!) {
  updateProduct(input: $input) {
    ...ProductListingWithDescription
  }
}
    ${ProductListingWithDescriptionFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateStatusDocument = gql`
    mutation updateStatus($input: UpdateStatusInput!) {
  updateStatus(input: $input) {
    ...StatusLabel
  }
}
    ${StatusLabelFragmentDoc}`;
export type UpdateStatusMutationFn = Apollo.MutationFunction<UpdateStatusMutation, UpdateStatusMutationVariables>;

/**
 * __useUpdateStatusMutation__
 *
 * To run a mutation, you first call `useUpdateStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusMutation, { data, loading, error }] = useUpdateStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusMutation, UpdateStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusMutation, UpdateStatusMutationVariables>(UpdateStatusDocument, options);
      }
export type UpdateStatusMutationHookResult = ReturnType<typeof useUpdateStatusMutation>;
export type UpdateStatusMutationResult = Apollo.MutationResult<UpdateStatusMutation>;
export type UpdateStatusMutationOptions = Apollo.BaseMutationOptions<UpdateStatusMutation, UpdateStatusMutationVariables>;
export const UpdateStatusPositionsDocument = gql`
    mutation updateStatusPositions($input: UpdateStatusPositionsInput!) {
  updateStatusPositions(input: $input) {
    ...StatusLabel
  }
}
    ${StatusLabelFragmentDoc}`;
export type UpdateStatusPositionsMutationFn = Apollo.MutationFunction<UpdateStatusPositionsMutation, UpdateStatusPositionsMutationVariables>;

/**
 * __useUpdateStatusPositionsMutation__
 *
 * To run a mutation, you first call `useUpdateStatusPositionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStatusPositionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStatusPositionsMutation, { data, loading, error }] = useUpdateStatusPositionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStatusPositionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStatusPositionsMutation, UpdateStatusPositionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStatusPositionsMutation, UpdateStatusPositionsMutationVariables>(UpdateStatusPositionsDocument, options);
      }
export type UpdateStatusPositionsMutationHookResult = ReturnType<typeof useUpdateStatusPositionsMutation>;
export type UpdateStatusPositionsMutationResult = Apollo.MutationResult<UpdateStatusPositionsMutation>;
export type UpdateStatusPositionsMutationOptions = Apollo.BaseMutationOptions<UpdateStatusPositionsMutation, UpdateStatusPositionsMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    ...TeamDataWithDescription
  }
}
    ${TeamDataWithDescriptionFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const UpdateWorkspaceDocument = gql`
    mutation updateWorkspace($input: UpdateWorkspaceInput!) {
  updateWorkspace(input: $input) {
    ...WorkspaceListing
  }
}
    ${WorkspaceListingFragmentDoc}`;
export type UpdateWorkspaceMutationFn = Apollo.MutationFunction<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;

/**
 * __useUpdateWorkspaceMutation__
 *
 * To run a mutation, you first call `useUpdateWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkspaceMutation, { data, loading, error }] = useUpdateWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>(UpdateWorkspaceDocument, options);
      }
export type UpdateWorkspaceMutationHookResult = ReturnType<typeof useUpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationResult = Apollo.MutationResult<UpdateWorkspaceMutation>;
export type UpdateWorkspaceMutationOptions = Apollo.BaseMutationOptions<UpdateWorkspaceMutation, UpdateWorkspaceMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation verifyEmail($input: VerifyEmailInput!) {
  verifyEmail(input: $input) {
    verification
    token
    user {
      ...MeData
    }
  }
}
    ${MeDataFragmentDoc}`;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, options);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const GetAddFeatureOptionsDocument = gql`
    query getAddFeatureOptions($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      id
      name
    }
    statuses {
      ...StatusLabel
      id
      position
    }
  }
}
    ${StatusLabelFragmentDoc}`;

/**
 * __useGetAddFeatureOptionsQuery__
 *
 * To run a query within a React component, call `useGetAddFeatureOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddFeatureOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddFeatureOptionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAddFeatureOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>(GetAddFeatureOptionsDocument, options);
      }
export function useGetAddFeatureOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>(GetAddFeatureOptionsDocument, options);
        }
export function useGetAddFeatureOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>(GetAddFeatureOptionsDocument, options);
        }
export type GetAddFeatureOptionsQueryHookResult = ReturnType<typeof useGetAddFeatureOptionsQuery>;
export type GetAddFeatureOptionsLazyQueryHookResult = ReturnType<typeof useGetAddFeatureOptionsLazyQuery>;
export type GetAddFeatureOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAddFeatureOptionsSuspenseQuery>;
export type GetAddFeatureOptionsQueryResult = Apollo.QueryResult<GetAddFeatureOptionsQuery, GetAddFeatureOptionsQueryVariables>;
export function refetchGetAddFeatureOptionsQuery(variables: GetAddFeatureOptionsQueryVariables) {
      return { query: GetAddFeatureOptionsDocument, variables: variables }
    }
export const GetAllFeaturesDocument = gql`
    query getAllFeatures($workspaceId: Hashid!, $orderBy: [WorkspaceTasksOrderByOrderByClause!], $hasDate: Boolean) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      ...ProductListing
    }
    tasks(orderBy: $orderBy, hasDate: $hasDate) {
      ...TaskListing
    }
  }
}
    ${ProductListingFragmentDoc}
${TaskListingFragmentDoc}`;

/**
 * __useGetAllFeaturesQuery__
 *
 * To run a query within a React component, call `useGetAllFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFeaturesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      orderBy: // value for 'orderBy'
 *      hasDate: // value for 'hasDate'
 *   },
 * });
 */
export function useGetAllFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>(GetAllFeaturesDocument, options);
      }
export function useGetAllFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>(GetAllFeaturesDocument, options);
        }
export function useGetAllFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>(GetAllFeaturesDocument, options);
        }
export type GetAllFeaturesQueryHookResult = ReturnType<typeof useGetAllFeaturesQuery>;
export type GetAllFeaturesLazyQueryHookResult = ReturnType<typeof useGetAllFeaturesLazyQuery>;
export type GetAllFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetAllFeaturesSuspenseQuery>;
export type GetAllFeaturesQueryResult = Apollo.QueryResult<GetAllFeaturesQuery, GetAllFeaturesQueryVariables>;
export function refetchGetAllFeaturesQuery(variables: GetAllFeaturesQueryVariables) {
      return { query: GetAllFeaturesDocument, variables: variables }
    }
export const GetAllFeaturesAndMilestonesDocument = gql`
    query getAllFeaturesAndMilestones($workspaceId: Hashid!, $orderBy: [WorkspaceTasksOrderByOrderByClause!], $hasDate: Boolean) {
  workspace(id: $workspaceId) {
    id
    slug
    tasks(orderBy: $orderBy, hasDate: $hasDate) {
      ...TaskListing
      dragStart @client
      dragEnd @client
      dragVertical @client
    }
    milestones {
      ...MilestoneListing
    }
  }
}
    ${TaskListingFragmentDoc}
${MilestoneListingFragmentDoc}`;

/**
 * __useGetAllFeaturesAndMilestonesQuery__
 *
 * To run a query within a React component, call `useGetAllFeaturesAndMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFeaturesAndMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFeaturesAndMilestonesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      orderBy: // value for 'orderBy'
 *      hasDate: // value for 'hasDate'
 *   },
 * });
 */
export function useGetAllFeaturesAndMilestonesQuery(baseOptions: Apollo.QueryHookOptions<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>(GetAllFeaturesAndMilestonesDocument, options);
      }
export function useGetAllFeaturesAndMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>(GetAllFeaturesAndMilestonesDocument, options);
        }
export function useGetAllFeaturesAndMilestonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>(GetAllFeaturesAndMilestonesDocument, options);
        }
export type GetAllFeaturesAndMilestonesQueryHookResult = ReturnType<typeof useGetAllFeaturesAndMilestonesQuery>;
export type GetAllFeaturesAndMilestonesLazyQueryHookResult = ReturnType<typeof useGetAllFeaturesAndMilestonesLazyQuery>;
export type GetAllFeaturesAndMilestonesSuspenseQueryHookResult = ReturnType<typeof useGetAllFeaturesAndMilestonesSuspenseQuery>;
export type GetAllFeaturesAndMilestonesQueryResult = Apollo.QueryResult<GetAllFeaturesAndMilestonesQuery, GetAllFeaturesAndMilestonesQueryVariables>;
export function refetchGetAllFeaturesAndMilestonesQuery(variables: GetAllFeaturesAndMilestonesQueryVariables) {
      return { query: GetAllFeaturesAndMilestonesDocument, variables: variables }
    }
export const GetAllIdeasDocument = gql`
    query getAllIdeas($workspaceId: Hashid!, $orderBy: [WorkspaceIdeasOrderByOrderByClause!], $hasDate: Boolean) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      ...ProductListing
    }
    ideas(orderBy: $orderBy, hasDate: $hasDate) {
      ...IdeaListing
    }
  }
}
    ${ProductListingFragmentDoc}
${IdeaListingFragmentDoc}`;

/**
 * __useGetAllIdeasQuery__
 *
 * To run a query within a React component, call `useGetAllIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllIdeasQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      orderBy: // value for 'orderBy'
 *      hasDate: // value for 'hasDate'
 *   },
 * });
 */
export function useGetAllIdeasQuery(baseOptions: Apollo.QueryHookOptions<GetAllIdeasQuery, GetAllIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllIdeasQuery, GetAllIdeasQueryVariables>(GetAllIdeasDocument, options);
      }
export function useGetAllIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllIdeasQuery, GetAllIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllIdeasQuery, GetAllIdeasQueryVariables>(GetAllIdeasDocument, options);
        }
export function useGetAllIdeasSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllIdeasQuery, GetAllIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllIdeasQuery, GetAllIdeasQueryVariables>(GetAllIdeasDocument, options);
        }
export type GetAllIdeasQueryHookResult = ReturnType<typeof useGetAllIdeasQuery>;
export type GetAllIdeasLazyQueryHookResult = ReturnType<typeof useGetAllIdeasLazyQuery>;
export type GetAllIdeasSuspenseQueryHookResult = ReturnType<typeof useGetAllIdeasSuspenseQuery>;
export type GetAllIdeasQueryResult = Apollo.QueryResult<GetAllIdeasQuery, GetAllIdeasQueryVariables>;
export function refetchGetAllIdeasQuery(variables: GetAllIdeasQueryVariables) {
      return { query: GetAllIdeasDocument, variables: variables }
    }
export const GetAllMilestonesDocument = gql`
    query getAllMilestones($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    milestones {
      ...MilestoneListing
    }
  }
}
    ${MilestoneListingFragmentDoc}`;

/**
 * __useGetAllMilestonesQuery__
 *
 * To run a query within a React component, call `useGetAllMilestonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMilestonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMilestonesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAllMilestonesQuery(baseOptions: Apollo.QueryHookOptions<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>(GetAllMilestonesDocument, options);
      }
export function useGetAllMilestonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>(GetAllMilestonesDocument, options);
        }
export function useGetAllMilestonesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>(GetAllMilestonesDocument, options);
        }
export type GetAllMilestonesQueryHookResult = ReturnType<typeof useGetAllMilestonesQuery>;
export type GetAllMilestonesLazyQueryHookResult = ReturnType<typeof useGetAllMilestonesLazyQuery>;
export type GetAllMilestonesSuspenseQueryHookResult = ReturnType<typeof useGetAllMilestonesSuspenseQuery>;
export type GetAllMilestonesQueryResult = Apollo.QueryResult<GetAllMilestonesQuery, GetAllMilestonesQueryVariables>;
export function refetchGetAllMilestonesQuery(variables: GetAllMilestonesQueryVariables) {
      return { query: GetAllMilestonesDocument, variables: variables }
    }
export const GetAllProductsDocument = gql`
    query getAllProducts($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      ...ProductListing
    }
  }
}
    ${ProductListingFragmentDoc}`;

/**
 * __useGetAllProductsQuery__
 *
 * To run a query within a React component, call `useGetAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllProductsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetAllProductsQuery(baseOptions: Apollo.QueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
      }
export function useGetAllProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export function useGetAllProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllProductsQuery, GetAllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllProductsQuery, GetAllProductsQueryVariables>(GetAllProductsDocument, options);
        }
export type GetAllProductsQueryHookResult = ReturnType<typeof useGetAllProductsQuery>;
export type GetAllProductsLazyQueryHookResult = ReturnType<typeof useGetAllProductsLazyQuery>;
export type GetAllProductsSuspenseQueryHookResult = ReturnType<typeof useGetAllProductsSuspenseQuery>;
export type GetAllProductsQueryResult = Apollo.QueryResult<GetAllProductsQuery, GetAllProductsQueryVariables>;
export function refetchGetAllProductsQuery(variables: GetAllProductsQueryVariables) {
      return { query: GetAllProductsDocument, variables: variables }
    }
export const GetFeatureDocument = gql`
    query getFeature($workspaceId: Hashid!, $featureId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    task(id: $featureId) {
      ...TaskListingWithDescription
    }
  }
}
    ${TaskListingWithDescriptionFragmentDoc}`;

/**
 * __useGetFeatureQuery__
 *
 * To run a query within a React component, call `useGetFeatureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useGetFeatureQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureQuery, GetFeatureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureQuery, GetFeatureQueryVariables>(GetFeatureDocument, options);
      }
export function useGetFeatureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureQuery, GetFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureQuery, GetFeatureQueryVariables>(GetFeatureDocument, options);
        }
export function useGetFeatureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureQuery, GetFeatureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureQuery, GetFeatureQueryVariables>(GetFeatureDocument, options);
        }
export type GetFeatureQueryHookResult = ReturnType<typeof useGetFeatureQuery>;
export type GetFeatureLazyQueryHookResult = ReturnType<typeof useGetFeatureLazyQuery>;
export type GetFeatureSuspenseQueryHookResult = ReturnType<typeof useGetFeatureSuspenseQuery>;
export type GetFeatureQueryResult = Apollo.QueryResult<GetFeatureQuery, GetFeatureQueryVariables>;
export function refetchGetFeatureQuery(variables: GetFeatureQueryVariables) {
      return { query: GetFeatureDocument, variables: variables }
    }
export const GetFeatureActivityDocument = gql`
    query getFeatureActivity($workspaceId: Hashid!, $featureId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    task(id: $featureId) {
      ...TaskWithActivity
    }
  }
}
    ${TaskWithActivityFragmentDoc}`;

/**
 * __useGetFeatureActivityQuery__
 *
 * To run a query within a React component, call `useGetFeatureActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureActivityQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useGetFeatureActivityQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>(GetFeatureActivityDocument, options);
      }
export function useGetFeatureActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>(GetFeatureActivityDocument, options);
        }
export function useGetFeatureActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>(GetFeatureActivityDocument, options);
        }
export type GetFeatureActivityQueryHookResult = ReturnType<typeof useGetFeatureActivityQuery>;
export type GetFeatureActivityLazyQueryHookResult = ReturnType<typeof useGetFeatureActivityLazyQuery>;
export type GetFeatureActivitySuspenseQueryHookResult = ReturnType<typeof useGetFeatureActivitySuspenseQuery>;
export type GetFeatureActivityQueryResult = Apollo.QueryResult<GetFeatureActivityQuery, GetFeatureActivityQueryVariables>;
export function refetchGetFeatureActivityQuery(variables: GetFeatureActivityQueryVariables) {
      return { query: GetFeatureActivityDocument, variables: variables }
    }
export const GetFeatureDeliveryItemsDocument = gql`
    query getFeatureDeliveryItems($workspaceId: Hashid!, $featureId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    task(id: $featureId) {
      id
      deliveryItems {
        ...DeliveryItemData
      }
    }
  }
}
    ${DeliveryItemDataFragmentDoc}`;

/**
 * __useGetFeatureDeliveryItemsQuery__
 *
 * To run a query within a React component, call `useGetFeatureDeliveryItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureDeliveryItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureDeliveryItemsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      featureId: // value for 'featureId'
 *   },
 * });
 */
export function useGetFeatureDeliveryItemsQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>(GetFeatureDeliveryItemsDocument, options);
      }
export function useGetFeatureDeliveryItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>(GetFeatureDeliveryItemsDocument, options);
        }
export function useGetFeatureDeliveryItemsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>(GetFeatureDeliveryItemsDocument, options);
        }
export type GetFeatureDeliveryItemsQueryHookResult = ReturnType<typeof useGetFeatureDeliveryItemsQuery>;
export type GetFeatureDeliveryItemsLazyQueryHookResult = ReturnType<typeof useGetFeatureDeliveryItemsLazyQuery>;
export type GetFeatureDeliveryItemsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureDeliveryItemsSuspenseQuery>;
export type GetFeatureDeliveryItemsQueryResult = Apollo.QueryResult<GetFeatureDeliveryItemsQuery, GetFeatureDeliveryItemsQueryVariables>;
export function refetchGetFeatureDeliveryItemsQuery(variables: GetFeatureDeliveryItemsQueryVariables) {
      return { query: GetFeatureDeliveryItemsDocument, variables: variables }
    }
export const GetFeatureFilterOptionsDocument = gql`
    query getFeatureFilterOptions($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      ...ProductListing
    }
    statuses {
      ...StatusLabel
    }
    platforms {
      ...PlatformData
    }
    objectives {
      ...ObjectiveData
    }
    teams {
      ...TeamData
    }
  }
}
    ${ProductListingFragmentDoc}
${StatusLabelFragmentDoc}
${PlatformDataFragmentDoc}
${ObjectiveDataFragmentDoc}
${TeamDataFragmentDoc}`;

/**
 * __useGetFeatureFilterOptionsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFilterOptionsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetFeatureFilterOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>(GetFeatureFilterOptionsDocument, options);
      }
export function useGetFeatureFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>(GetFeatureFilterOptionsDocument, options);
        }
export function useGetFeatureFilterOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>(GetFeatureFilterOptionsDocument, options);
        }
export type GetFeatureFilterOptionsQueryHookResult = ReturnType<typeof useGetFeatureFilterOptionsQuery>;
export type GetFeatureFilterOptionsLazyQueryHookResult = ReturnType<typeof useGetFeatureFilterOptionsLazyQuery>;
export type GetFeatureFilterOptionsSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFilterOptionsSuspenseQuery>;
export type GetFeatureFilterOptionsQueryResult = Apollo.QueryResult<GetFeatureFilterOptionsQuery, GetFeatureFilterOptionsQueryVariables>;
export function refetchGetFeatureFilterOptionsQuery(variables: GetFeatureFilterOptionsQueryVariables) {
      return { query: GetFeatureFilterOptionsDocument, variables: variables }
    }
export const GetFeatureUpdatesDocument = gql`
    query getFeatureUpdates($workspaceId: Hashid!, $featureId: Hashid!, $updatesCursor: String) {
  workspace(id: $workspaceId) {
    id
    slug
    task(id: $featureId) {
      ...TaskWithUpdatesData
    }
  }
}
    ${TaskWithUpdatesDataFragmentDoc}`;

/**
 * __useGetFeatureUpdatesQuery__
 *
 * To run a query within a React component, call `useGetFeatureUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureUpdatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      featureId: // value for 'featureId'
 *      updatesCursor: // value for 'updatesCursor'
 *   },
 * });
 */
export function useGetFeatureUpdatesQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>(GetFeatureUpdatesDocument, options);
      }
export function useGetFeatureUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>(GetFeatureUpdatesDocument, options);
        }
export function useGetFeatureUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>(GetFeatureUpdatesDocument, options);
        }
export type GetFeatureUpdatesQueryHookResult = ReturnType<typeof useGetFeatureUpdatesQuery>;
export type GetFeatureUpdatesLazyQueryHookResult = ReturnType<typeof useGetFeatureUpdatesLazyQuery>;
export type GetFeatureUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetFeatureUpdatesSuspenseQuery>;
export type GetFeatureUpdatesQueryResult = Apollo.QueryResult<GetFeatureUpdatesQuery, GetFeatureUpdatesQueryVariables>;
export function refetchGetFeatureUpdatesQuery(variables: GetFeatureUpdatesQueryVariables) {
      return { query: GetFeatureUpdatesDocument, variables: variables }
    }
export const GetFeaturesDocument = gql`
    query getFeatures($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      ...ProductListingWithTasks
    }
  }
}
    ${ProductListingWithTasksFragmentDoc}`;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetFeaturesQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
      }
export function useGetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export function useGetFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>;
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>;
export type GetFeaturesSuspenseQueryHookResult = ReturnType<typeof useGetFeaturesSuspenseQuery>;
export type GetFeaturesQueryResult = Apollo.QueryResult<GetFeaturesQuery, GetFeaturesQueryVariables>;
export function refetchGetFeaturesQuery(variables: GetFeaturesQueryVariables) {
      return { query: GetFeaturesDocument, variables: variables }
    }
export const GetIdeaDocument = gql`
    query getIdea($workspaceId: Hashid!, $ideaId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    idea(id: $ideaId) {
      ...IdeaDetail
    }
  }
}
    ${IdeaDetailFragmentDoc}`;

/**
 * __useGetIdeaQuery__
 *
 * To run a query within a React component, call `useGetIdeaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdeaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdeaQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useGetIdeaQuery(baseOptions: Apollo.QueryHookOptions<GetIdeaQuery, GetIdeaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdeaQuery, GetIdeaQueryVariables>(GetIdeaDocument, options);
      }
export function useGetIdeaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdeaQuery, GetIdeaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdeaQuery, GetIdeaQueryVariables>(GetIdeaDocument, options);
        }
export function useGetIdeaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIdeaQuery, GetIdeaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdeaQuery, GetIdeaQueryVariables>(GetIdeaDocument, options);
        }
export type GetIdeaQueryHookResult = ReturnType<typeof useGetIdeaQuery>;
export type GetIdeaLazyQueryHookResult = ReturnType<typeof useGetIdeaLazyQuery>;
export type GetIdeaSuspenseQueryHookResult = ReturnType<typeof useGetIdeaSuspenseQuery>;
export type GetIdeaQueryResult = Apollo.QueryResult<GetIdeaQuery, GetIdeaQueryVariables>;
export function refetchGetIdeaQuery(variables: GetIdeaQueryVariables) {
      return { query: GetIdeaDocument, variables: variables }
    }
export const GetIdeaActivityDocument = gql`
    query getIdeaActivity($workspaceId: Hashid!, $ideaId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    idea(id: $ideaId) {
      ...IdeaWithActivity
    }
  }
}
    ${IdeaWithActivityFragmentDoc}`;

/**
 * __useGetIdeaActivityQuery__
 *
 * To run a query within a React component, call `useGetIdeaActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdeaActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdeaActivityQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useGetIdeaActivityQuery(baseOptions: Apollo.QueryHookOptions<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>(GetIdeaActivityDocument, options);
      }
export function useGetIdeaActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>(GetIdeaActivityDocument, options);
        }
export function useGetIdeaActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>(GetIdeaActivityDocument, options);
        }
export type GetIdeaActivityQueryHookResult = ReturnType<typeof useGetIdeaActivityQuery>;
export type GetIdeaActivityLazyQueryHookResult = ReturnType<typeof useGetIdeaActivityLazyQuery>;
export type GetIdeaActivitySuspenseQueryHookResult = ReturnType<typeof useGetIdeaActivitySuspenseQuery>;
export type GetIdeaActivityQueryResult = Apollo.QueryResult<GetIdeaActivityQuery, GetIdeaActivityQueryVariables>;
export function refetchGetIdeaActivityQuery(variables: GetIdeaActivityQueryVariables) {
      return { query: GetIdeaActivityDocument, variables: variables }
    }
export const GetIdeaInsightsDocument = gql`
    query getIdeaInsights($workspaceId: Hashid!, $ideaId: Hashid!, $insightsCursor: String) {
  workspace(id: $workspaceId) {
    id
    slug
    idea(id: $ideaId) {
      ...IdeaWithInsights
    }
  }
}
    ${IdeaWithInsightsFragmentDoc}`;

/**
 * __useGetIdeaInsightsQuery__
 *
 * To run a query within a React component, call `useGetIdeaInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdeaInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdeaInsightsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      ideaId: // value for 'ideaId'
 *      insightsCursor: // value for 'insightsCursor'
 *   },
 * });
 */
export function useGetIdeaInsightsQuery(baseOptions: Apollo.QueryHookOptions<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>(GetIdeaInsightsDocument, options);
      }
export function useGetIdeaInsightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>(GetIdeaInsightsDocument, options);
        }
export function useGetIdeaInsightsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>(GetIdeaInsightsDocument, options);
        }
export type GetIdeaInsightsQueryHookResult = ReturnType<typeof useGetIdeaInsightsQuery>;
export type GetIdeaInsightsLazyQueryHookResult = ReturnType<typeof useGetIdeaInsightsLazyQuery>;
export type GetIdeaInsightsSuspenseQueryHookResult = ReturnType<typeof useGetIdeaInsightsSuspenseQuery>;
export type GetIdeaInsightsQueryResult = Apollo.QueryResult<GetIdeaInsightsQuery, GetIdeaInsightsQueryVariables>;
export function refetchGetIdeaInsightsQuery(variables: GetIdeaInsightsQueryVariables) {
      return { query: GetIdeaInsightsDocument, variables: variables }
    }
export const GetKeyResultDocument = gql`
    query getKeyResult($workspaceId: Hashid!, $keyResultId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    keyResult(id: $keyResultId) {
      ...KeyResultDataAllValues
    }
  }
}
    ${KeyResultDataAllValuesFragmentDoc}`;

/**
 * __useGetKeyResultQuery__
 *
 * To run a query within a React component, call `useGetKeyResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKeyResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKeyResultQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      keyResultId: // value for 'keyResultId'
 *   },
 * });
 */
export function useGetKeyResultQuery(baseOptions: Apollo.QueryHookOptions<GetKeyResultQuery, GetKeyResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKeyResultQuery, GetKeyResultQueryVariables>(GetKeyResultDocument, options);
      }
export function useGetKeyResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKeyResultQuery, GetKeyResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKeyResultQuery, GetKeyResultQueryVariables>(GetKeyResultDocument, options);
        }
export function useGetKeyResultSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKeyResultQuery, GetKeyResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKeyResultQuery, GetKeyResultQueryVariables>(GetKeyResultDocument, options);
        }
export type GetKeyResultQueryHookResult = ReturnType<typeof useGetKeyResultQuery>;
export type GetKeyResultLazyQueryHookResult = ReturnType<typeof useGetKeyResultLazyQuery>;
export type GetKeyResultSuspenseQueryHookResult = ReturnType<typeof useGetKeyResultSuspenseQuery>;
export type GetKeyResultQueryResult = Apollo.QueryResult<GetKeyResultQuery, GetKeyResultQueryVariables>;
export function refetchGetKeyResultQuery(variables: GetKeyResultQueryVariables) {
      return { query: GetKeyResultDocument, variables: variables }
    }
export const GetMeDocument = gql`
    query getMe {
  me {
    ...MeData
  }
}
    ${MeDataFragmentDoc}`;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export function useGetMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeSuspenseQueryHookResult = ReturnType<typeof useGetMeSuspenseQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export function refetchGetMeQuery(variables?: GetMeQueryVariables) {
      return { query: GetMeDocument, variables: variables }
    }
export const GetMeAvatarUploadUrlDocument = gql`
    query getMeAvatarUploadUrl {
  me {
    id
    avatarUploadUrl
  }
}
    `;

/**
 * __useGetMeAvatarUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetMeAvatarUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeAvatarUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeAvatarUploadUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeAvatarUploadUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>(GetMeAvatarUploadUrlDocument, options);
      }
export function useGetMeAvatarUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>(GetMeAvatarUploadUrlDocument, options);
        }
export function useGetMeAvatarUploadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>(GetMeAvatarUploadUrlDocument, options);
        }
export type GetMeAvatarUploadUrlQueryHookResult = ReturnType<typeof useGetMeAvatarUploadUrlQuery>;
export type GetMeAvatarUploadUrlLazyQueryHookResult = ReturnType<typeof useGetMeAvatarUploadUrlLazyQuery>;
export type GetMeAvatarUploadUrlSuspenseQueryHookResult = ReturnType<typeof useGetMeAvatarUploadUrlSuspenseQuery>;
export type GetMeAvatarUploadUrlQueryResult = Apollo.QueryResult<GetMeAvatarUploadUrlQuery, GetMeAvatarUploadUrlQueryVariables>;
export function refetchGetMeAvatarUploadUrlQuery(variables?: GetMeAvatarUploadUrlQueryVariables) {
      return { query: GetMeAvatarUploadUrlDocument, variables: variables }
    }
export const GetMilestoneDocument = gql`
    query getMilestone($workspaceId: Hashid!, $milestoneId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    milestone(id: $milestoneId) {
      ...MilestoneListingWithDescription
    }
  }
}
    ${MilestoneListingWithDescriptionFragmentDoc}`;

/**
 * __useGetMilestoneQuery__
 *
 * To run a query within a React component, call `useGetMilestoneQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMilestoneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMilestoneQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useGetMilestoneQuery(baseOptions: Apollo.QueryHookOptions<GetMilestoneQuery, GetMilestoneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMilestoneQuery, GetMilestoneQueryVariables>(GetMilestoneDocument, options);
      }
export function useGetMilestoneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMilestoneQuery, GetMilestoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMilestoneQuery, GetMilestoneQueryVariables>(GetMilestoneDocument, options);
        }
export function useGetMilestoneSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMilestoneQuery, GetMilestoneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMilestoneQuery, GetMilestoneQueryVariables>(GetMilestoneDocument, options);
        }
export type GetMilestoneQueryHookResult = ReturnType<typeof useGetMilestoneQuery>;
export type GetMilestoneLazyQueryHookResult = ReturnType<typeof useGetMilestoneLazyQuery>;
export type GetMilestoneSuspenseQueryHookResult = ReturnType<typeof useGetMilestoneSuspenseQuery>;
export type GetMilestoneQueryResult = Apollo.QueryResult<GetMilestoneQuery, GetMilestoneQueryVariables>;
export function refetchGetMilestoneQuery(variables: GetMilestoneQueryVariables) {
      return { query: GetMilestoneDocument, variables: variables }
    }
export const GetNotificationsDocument = gql`
    query getNotifications($workspaceId: Hashid!) {
  me {
    id
    workspace(id: $workspaceId) {
      id
      slug
      notifications {
        ...NotificationData
      }
    }
  }
}
    ${NotificationDataFragmentDoc}`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export function useGetNotificationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function refetchGetNotificationsQuery(variables: GetNotificationsQueryVariables) {
      return { query: GetNotificationsDocument, variables: variables }
    }
export const GetObjectiveDocument = gql`
    query getObjective($workspaceId: Hashid!, $objectiveId: Hashid!, $updatesCursor: String) {
  workspace(id: $workspaceId) {
    id
    slug
    objective(id: $objectiveId) {
      ...ObjectiveDataFull
    }
  }
}
    ${ObjectiveDataFullFragmentDoc}`;

/**
 * __useGetObjectiveQuery__
 *
 * To run a query within a React component, call `useGetObjectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectiveQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      objectiveId: // value for 'objectiveId'
 *      updatesCursor: // value for 'updatesCursor'
 *   },
 * });
 */
export function useGetObjectiveQuery(baseOptions: Apollo.QueryHookOptions<GetObjectiveQuery, GetObjectiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectiveQuery, GetObjectiveQueryVariables>(GetObjectiveDocument, options);
      }
export function useGetObjectiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectiveQuery, GetObjectiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectiveQuery, GetObjectiveQueryVariables>(GetObjectiveDocument, options);
        }
export function useGetObjectiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectiveQuery, GetObjectiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectiveQuery, GetObjectiveQueryVariables>(GetObjectiveDocument, options);
        }
export type GetObjectiveQueryHookResult = ReturnType<typeof useGetObjectiveQuery>;
export type GetObjectiveLazyQueryHookResult = ReturnType<typeof useGetObjectiveLazyQuery>;
export type GetObjectiveSuspenseQueryHookResult = ReturnType<typeof useGetObjectiveSuspenseQuery>;
export type GetObjectiveQueryResult = Apollo.QueryResult<GetObjectiveQuery, GetObjectiveQueryVariables>;
export function refetchGetObjectiveQuery(variables: GetObjectiveQueryVariables) {
      return { query: GetObjectiveDocument, variables: variables }
    }
export const GetObjectiveUpdatesDocument = gql`
    query getObjectiveUpdates($workspaceId: Hashid!, $objectiveId: Hashid!, $updatesCursor: String) {
  workspace(id: $workspaceId) {
    id
    slug
    objective(id: $objectiveId) {
      id
      updates(first: 3, after: $updatesCursor) {
        ...UpdatesConnectionData
      }
    }
  }
}
    ${UpdatesConnectionDataFragmentDoc}`;

/**
 * __useGetObjectiveUpdatesQuery__
 *
 * To run a query within a React component, call `useGetObjectiveUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetObjectiveUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetObjectiveUpdatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      objectiveId: // value for 'objectiveId'
 *      updatesCursor: // value for 'updatesCursor'
 *   },
 * });
 */
export function useGetObjectiveUpdatesQuery(baseOptions: Apollo.QueryHookOptions<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>(GetObjectiveUpdatesDocument, options);
      }
export function useGetObjectiveUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>(GetObjectiveUpdatesDocument, options);
        }
export function useGetObjectiveUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>(GetObjectiveUpdatesDocument, options);
        }
export type GetObjectiveUpdatesQueryHookResult = ReturnType<typeof useGetObjectiveUpdatesQuery>;
export type GetObjectiveUpdatesLazyQueryHookResult = ReturnType<typeof useGetObjectiveUpdatesLazyQuery>;
export type GetObjectiveUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetObjectiveUpdatesSuspenseQuery>;
export type GetObjectiveUpdatesQueryResult = Apollo.QueryResult<GetObjectiveUpdatesQuery, GetObjectiveUpdatesQueryVariables>;
export function refetchGetObjectiveUpdatesQuery(variables: GetObjectiveUpdatesQueryVariables) {
      return { query: GetObjectiveUpdatesDocument, variables: variables }
    }
export const GetProductDocument = gql`
    query getProduct($workspaceId: Hashid!, $productId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    product(id: $productId) {
      ...ProductListingWithDescription
    }
  }
}
    ${ProductListingWithDescriptionFragmentDoc}`;

/**
 * __useGetProductQuery__
 *
 * To run a query within a React component, call `useGetProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetProductQuery(baseOptions: Apollo.QueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
      }
export function useGetProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export function useGetProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProductQuery, GetProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductQuery, GetProductQueryVariables>(GetProductDocument, options);
        }
export type GetProductQueryHookResult = ReturnType<typeof useGetProductQuery>;
export type GetProductLazyQueryHookResult = ReturnType<typeof useGetProductLazyQuery>;
export type GetProductSuspenseQueryHookResult = ReturnType<typeof useGetProductSuspenseQuery>;
export type GetProductQueryResult = Apollo.QueryResult<GetProductQuery, GetProductQueryVariables>;
export function refetchGetProductQuery(variables: GetProductQueryVariables) {
      return { query: GetProductDocument, variables: variables }
    }
export const GetTeamDocument = gql`
    query getTeam($workspaceId: Hashid!, $teamId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    team(id: $teamId) {
      ...TeamDataWithTasks
    }
  }
}
    ${TeamDataWithTasksFragmentDoc}`;

/**
 * __useGetTeamQuery__
 *
 * To run a query within a React component, call `useGetTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamQuery(baseOptions: Apollo.QueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
      }
export function useGetTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export function useGetTeamSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamQuery, GetTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamQuery, GetTeamQueryVariables>(GetTeamDocument, options);
        }
export type GetTeamQueryHookResult = ReturnType<typeof useGetTeamQuery>;
export type GetTeamLazyQueryHookResult = ReturnType<typeof useGetTeamLazyQuery>;
export type GetTeamSuspenseQueryHookResult = ReturnType<typeof useGetTeamSuspenseQuery>;
export type GetTeamQueryResult = Apollo.QueryResult<GetTeamQuery, GetTeamQueryVariables>;
export function refetchGetTeamQuery(variables: GetTeamQueryVariables) {
      return { query: GetTeamDocument, variables: variables }
    }
export const GetWorkspaceDocument = gql`
    query getWorkspace($slug: ID!) {
  workspace(slug: $slug) {
    ...WorkspaceListing
  }
}
    ${WorkspaceListingFragmentDoc}`;

/**
 * __useGetWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
      }
export function useGetWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
        }
export function useGetWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceQuery, GetWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceQuery, GetWorkspaceQueryVariables>(GetWorkspaceDocument, options);
        }
export type GetWorkspaceQueryHookResult = ReturnType<typeof useGetWorkspaceQuery>;
export type GetWorkspaceLazyQueryHookResult = ReturnType<typeof useGetWorkspaceLazyQuery>;
export type GetWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSuspenseQuery>;
export type GetWorkspaceQueryResult = Apollo.QueryResult<GetWorkspaceQuery, GetWorkspaceQueryVariables>;
export function refetchGetWorkspaceQuery(variables: GetWorkspaceQueryVariables) {
      return { query: GetWorkspaceDocument, variables: variables }
    }
export const GetWorkspaceContactsDocument = gql`
    query getWorkspaceContacts($slug: ID!) {
  workspace(slug: $slug) {
    ...WorkspaceWithContacts
  }
}
    ${WorkspaceWithContactsFragmentDoc}`;

/**
 * __useGetWorkspaceContactsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceContactsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetWorkspaceContactsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>(GetWorkspaceContactsDocument, options);
      }
export function useGetWorkspaceContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>(GetWorkspaceContactsDocument, options);
        }
export function useGetWorkspaceContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>(GetWorkspaceContactsDocument, options);
        }
export type GetWorkspaceContactsQueryHookResult = ReturnType<typeof useGetWorkspaceContactsQuery>;
export type GetWorkspaceContactsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceContactsLazyQuery>;
export type GetWorkspaceContactsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceContactsSuspenseQuery>;
export type GetWorkspaceContactsQueryResult = Apollo.QueryResult<GetWorkspaceContactsQuery, GetWorkspaceContactsQueryVariables>;
export function refetchGetWorkspaceContactsQuery(variables: GetWorkspaceContactsQueryVariables) {
      return { query: GetWorkspaceContactsDocument, variables: variables }
    }
export const GetWorkspaceIdeaFieldsDocument = gql`
    query getWorkspaceIdeaFields($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    ideaFields {
      ...FieldData
    }
  }
}
    ${FieldDataFragmentDoc}`;

/**
 * __useGetWorkspaceIdeaFieldsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIdeaFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIdeaFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIdeaFieldsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceIdeaFieldsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>(GetWorkspaceIdeaFieldsDocument, options);
      }
export function useGetWorkspaceIdeaFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>(GetWorkspaceIdeaFieldsDocument, options);
        }
export function useGetWorkspaceIdeaFieldsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>(GetWorkspaceIdeaFieldsDocument, options);
        }
export type GetWorkspaceIdeaFieldsQueryHookResult = ReturnType<typeof useGetWorkspaceIdeaFieldsQuery>;
export type GetWorkspaceIdeaFieldsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceIdeaFieldsLazyQuery>;
export type GetWorkspaceIdeaFieldsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceIdeaFieldsSuspenseQuery>;
export type GetWorkspaceIdeaFieldsQueryResult = Apollo.QueryResult<GetWorkspaceIdeaFieldsQuery, GetWorkspaceIdeaFieldsQueryVariables>;
export function refetchGetWorkspaceIdeaFieldsQuery(variables: GetWorkspaceIdeaFieldsQueryVariables) {
      return { query: GetWorkspaceIdeaFieldsDocument, variables: variables }
    }
export const GetWorkspaceIntegrationsDocument = gql`
    query getWorkspaceIntegrations($slug: ID!) {
  workspace(slug: $slug) {
    ...WorkspaceWithIntegrations
  }
}
    ${WorkspaceWithIntegrationsFragmentDoc}`;

/**
 * __useGetWorkspaceIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIntegrationsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetWorkspaceIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>(GetWorkspaceIntegrationsDocument, options);
      }
export function useGetWorkspaceIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>(GetWorkspaceIntegrationsDocument, options);
        }
export function useGetWorkspaceIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>(GetWorkspaceIntegrationsDocument, options);
        }
export type GetWorkspaceIntegrationsQueryHookResult = ReturnType<typeof useGetWorkspaceIntegrationsQuery>;
export type GetWorkspaceIntegrationsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceIntegrationsLazyQuery>;
export type GetWorkspaceIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceIntegrationsSuspenseQuery>;
export type GetWorkspaceIntegrationsQueryResult = Apollo.QueryResult<GetWorkspaceIntegrationsQuery, GetWorkspaceIntegrationsQueryVariables>;
export function refetchGetWorkspaceIntegrationsQuery(variables: GetWorkspaceIntegrationsQueryVariables) {
      return { query: GetWorkspaceIntegrationsDocument, variables: variables }
    }
export const GetWorkspaceIntegrationsWithStatusesDocument = gql`
    query getWorkspaceIntegrationsWithStatuses($slug: ID!) {
  workspace(slug: $slug) {
    ...WorkspaceWithIntegrationsStatuses
  }
}
    ${WorkspaceWithIntegrationsStatusesFragmentDoc}`;

/**
 * __useGetWorkspaceIntegrationsWithStatusesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceIntegrationsWithStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceIntegrationsWithStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceIntegrationsWithStatusesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetWorkspaceIntegrationsWithStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>(GetWorkspaceIntegrationsWithStatusesDocument, options);
      }
export function useGetWorkspaceIntegrationsWithStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>(GetWorkspaceIntegrationsWithStatusesDocument, options);
        }
export function useGetWorkspaceIntegrationsWithStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>(GetWorkspaceIntegrationsWithStatusesDocument, options);
        }
export type GetWorkspaceIntegrationsWithStatusesQueryHookResult = ReturnType<typeof useGetWorkspaceIntegrationsWithStatusesQuery>;
export type GetWorkspaceIntegrationsWithStatusesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceIntegrationsWithStatusesLazyQuery>;
export type GetWorkspaceIntegrationsWithStatusesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceIntegrationsWithStatusesSuspenseQuery>;
export type GetWorkspaceIntegrationsWithStatusesQueryResult = Apollo.QueryResult<GetWorkspaceIntegrationsWithStatusesQuery, GetWorkspaceIntegrationsWithStatusesQueryVariables>;
export function refetchGetWorkspaceIntegrationsWithStatusesQuery(variables: GetWorkspaceIntegrationsWithStatusesQueryVariables) {
      return { query: GetWorkspaceIntegrationsWithStatusesDocument, variables: variables }
    }
export const GetWorkspaceMembersDocument = gql`
    query getWorkspaceMembers($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    members {
      ...WorkspaceMember
    }
    invitations {
      email
      updatedAt
    }
  }
}
    ${WorkspaceMemberFragmentDoc}`;

/**
 * __useGetWorkspaceMembersQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceMembersQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceMembersQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>(GetWorkspaceMembersDocument, options);
      }
export function useGetWorkspaceMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>(GetWorkspaceMembersDocument, options);
        }
export function useGetWorkspaceMembersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>(GetWorkspaceMembersDocument, options);
        }
export type GetWorkspaceMembersQueryHookResult = ReturnType<typeof useGetWorkspaceMembersQuery>;
export type GetWorkspaceMembersLazyQueryHookResult = ReturnType<typeof useGetWorkspaceMembersLazyQuery>;
export type GetWorkspaceMembersSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceMembersSuspenseQuery>;
export type GetWorkspaceMembersQueryResult = Apollo.QueryResult<GetWorkspaceMembersQuery, GetWorkspaceMembersQueryVariables>;
export function refetchGetWorkspaceMembersQuery(variables: GetWorkspaceMembersQueryVariables) {
      return { query: GetWorkspaceMembersDocument, variables: variables }
    }
export const GetWorkspaceObjectivesDocument = gql`
    query getWorkspaceObjectives($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    objectives {
      ...ObjectiveDataWithKeyResults
    }
  }
}
    ${ObjectiveDataWithKeyResultsFragmentDoc}`;

/**
 * __useGetWorkspaceObjectivesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceObjectivesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceObjectivesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>(GetWorkspaceObjectivesDocument, options);
      }
export function useGetWorkspaceObjectivesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>(GetWorkspaceObjectivesDocument, options);
        }
export function useGetWorkspaceObjectivesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>(GetWorkspaceObjectivesDocument, options);
        }
export type GetWorkspaceObjectivesQueryHookResult = ReturnType<typeof useGetWorkspaceObjectivesQuery>;
export type GetWorkspaceObjectivesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceObjectivesLazyQuery>;
export type GetWorkspaceObjectivesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceObjectivesSuspenseQuery>;
export type GetWorkspaceObjectivesQueryResult = Apollo.QueryResult<GetWorkspaceObjectivesQuery, GetWorkspaceObjectivesQueryVariables>;
export function refetchGetWorkspaceObjectivesQuery(variables: GetWorkspaceObjectivesQueryVariables) {
      return { query: GetWorkspaceObjectivesDocument, variables: variables }
    }
export const GetWorkspacePlatformsDocument = gql`
    query getWorkspacePlatforms($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    platforms {
      ...PlatformData
    }
  }
}
    ${PlatformDataFragmentDoc}`;

/**
 * __useGetWorkspacePlatformsQuery__
 *
 * To run a query within a React component, call `useGetWorkspacePlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspacePlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspacePlatformsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspacePlatformsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>(GetWorkspacePlatformsDocument, options);
      }
export function useGetWorkspacePlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>(GetWorkspacePlatformsDocument, options);
        }
export function useGetWorkspacePlatformsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>(GetWorkspacePlatformsDocument, options);
        }
export type GetWorkspacePlatformsQueryHookResult = ReturnType<typeof useGetWorkspacePlatformsQuery>;
export type GetWorkspacePlatformsLazyQueryHookResult = ReturnType<typeof useGetWorkspacePlatformsLazyQuery>;
export type GetWorkspacePlatformsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspacePlatformsSuspenseQuery>;
export type GetWorkspacePlatformsQueryResult = Apollo.QueryResult<GetWorkspacePlatformsQuery, GetWorkspacePlatformsQueryVariables>;
export function refetchGetWorkspacePlatformsQuery(variables: GetWorkspacePlatformsQueryVariables) {
      return { query: GetWorkspacePlatformsDocument, variables: variables }
    }
export const GetWorkspaceProductsDocument = gql`
    query getWorkspaceProducts($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    products {
      ...ProductData
    }
  }
}
    ${ProductDataFragmentDoc}`;

/**
 * __useGetWorkspaceProductsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceProductsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceProductsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>(GetWorkspaceProductsDocument, options);
      }
export function useGetWorkspaceProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>(GetWorkspaceProductsDocument, options);
        }
export function useGetWorkspaceProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>(GetWorkspaceProductsDocument, options);
        }
export type GetWorkspaceProductsQueryHookResult = ReturnType<typeof useGetWorkspaceProductsQuery>;
export type GetWorkspaceProductsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceProductsLazyQuery>;
export type GetWorkspaceProductsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceProductsSuspenseQuery>;
export type GetWorkspaceProductsQueryResult = Apollo.QueryResult<GetWorkspaceProductsQuery, GetWorkspaceProductsQueryVariables>;
export function refetchGetWorkspaceProductsQuery(variables: GetWorkspaceProductsQueryVariables) {
      return { query: GetWorkspaceProductsDocument, variables: variables }
    }
export const GetWorkspaceSearchKeyDocument = gql`
    query getWorkspaceSearchKey($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    searchKey
  }
}
    `;

/**
 * __useGetWorkspaceSearchKeyQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSearchKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSearchKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSearchKeyQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSearchKeyQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>(GetWorkspaceSearchKeyDocument, options);
      }
export function useGetWorkspaceSearchKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>(GetWorkspaceSearchKeyDocument, options);
        }
export function useGetWorkspaceSearchKeySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>(GetWorkspaceSearchKeyDocument, options);
        }
export type GetWorkspaceSearchKeyQueryHookResult = ReturnType<typeof useGetWorkspaceSearchKeyQuery>;
export type GetWorkspaceSearchKeyLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSearchKeyLazyQuery>;
export type GetWorkspaceSearchKeySuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSearchKeySuspenseQuery>;
export type GetWorkspaceSearchKeyQueryResult = Apollo.QueryResult<GetWorkspaceSearchKeyQuery, GetWorkspaceSearchKeyQueryVariables>;
export function refetchGetWorkspaceSearchKeyQuery(variables: GetWorkspaceSearchKeyQueryVariables) {
      return { query: GetWorkspaceSearchKeyDocument, variables: variables }
    }
export const GetWorkspaceSegmentsDocument = gql`
    query getWorkspaceSegments($slug: ID!) {
  workspace(slug: $slug) {
    ...WorkspaceWithSegments
  }
}
    ${WorkspaceWithSegmentsFragmentDoc}`;

/**
 * __useGetWorkspaceSegmentsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSegmentsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetWorkspaceSegmentsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>(GetWorkspaceSegmentsDocument, options);
      }
export function useGetWorkspaceSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>(GetWorkspaceSegmentsDocument, options);
        }
export function useGetWorkspaceSegmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>(GetWorkspaceSegmentsDocument, options);
        }
export type GetWorkspaceSegmentsQueryHookResult = ReturnType<typeof useGetWorkspaceSegmentsQuery>;
export type GetWorkspaceSegmentsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSegmentsLazyQuery>;
export type GetWorkspaceSegmentsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSegmentsSuspenseQuery>;
export type GetWorkspaceSegmentsQueryResult = Apollo.QueryResult<GetWorkspaceSegmentsQuery, GetWorkspaceSegmentsQueryVariables>;
export function refetchGetWorkspaceSegmentsQuery(variables: GetWorkspaceSegmentsQueryVariables) {
      return { query: GetWorkspaceSegmentsDocument, variables: variables }
    }
export const GetWorkspaceStatusesDocument = gql`
    query getWorkspaceStatuses($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    statuses {
      ...StatusLabel
    }
  }
}
    ${StatusLabelFragmentDoc}`;

/**
 * __useGetWorkspaceStatusesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceStatusesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>(GetWorkspaceStatusesDocument, options);
      }
export function useGetWorkspaceStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>(GetWorkspaceStatusesDocument, options);
        }
export function useGetWorkspaceStatusesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>(GetWorkspaceStatusesDocument, options);
        }
export type GetWorkspaceStatusesQueryHookResult = ReturnType<typeof useGetWorkspaceStatusesQuery>;
export type GetWorkspaceStatusesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceStatusesLazyQuery>;
export type GetWorkspaceStatusesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceStatusesSuspenseQuery>;
export type GetWorkspaceStatusesQueryResult = Apollo.QueryResult<GetWorkspaceStatusesQuery, GetWorkspaceStatusesQueryVariables>;
export function refetchGetWorkspaceStatusesQuery(variables: GetWorkspaceStatusesQueryVariables) {
      return { query: GetWorkspaceStatusesDocument, variables: variables }
    }
export const GetWorkspaceSubscriptionDocument = gql`
    query getWorkspaceSubscription($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    ...WorkspaceSubscriptionData
  }
}
    ${WorkspaceSubscriptionDataFragmentDoc}`;

/**
 * __useGetWorkspaceSubscriptionQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceSubscriptionQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceSubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>(GetWorkspaceSubscriptionDocument, options);
      }
export function useGetWorkspaceSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>(GetWorkspaceSubscriptionDocument, options);
        }
export function useGetWorkspaceSubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>(GetWorkspaceSubscriptionDocument, options);
        }
export type GetWorkspaceSubscriptionQueryHookResult = ReturnType<typeof useGetWorkspaceSubscriptionQuery>;
export type GetWorkspaceSubscriptionLazyQueryHookResult = ReturnType<typeof useGetWorkspaceSubscriptionLazyQuery>;
export type GetWorkspaceSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceSubscriptionSuspenseQuery>;
export type GetWorkspaceSubscriptionQueryResult = Apollo.QueryResult<GetWorkspaceSubscriptionQuery, GetWorkspaceSubscriptionQueryVariables>;
export function refetchGetWorkspaceSubscriptionQuery(variables: GetWorkspaceSubscriptionQueryVariables) {
      return { query: GetWorkspaceSubscriptionDocument, variables: variables }
    }
export const GetWorkspaceTeamsDocument = gql`
    query getWorkspaceTeams($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    teams {
      ...TeamData
    }
  }
}
    ${TeamDataFragmentDoc}`;

/**
 * __useGetWorkspaceTeamsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceTeamsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceTeamsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>(GetWorkspaceTeamsDocument, options);
      }
export function useGetWorkspaceTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>(GetWorkspaceTeamsDocument, options);
        }
export function useGetWorkspaceTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>(GetWorkspaceTeamsDocument, options);
        }
export type GetWorkspaceTeamsQueryHookResult = ReturnType<typeof useGetWorkspaceTeamsQuery>;
export type GetWorkspaceTeamsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceTeamsLazyQuery>;
export type GetWorkspaceTeamsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceTeamsSuspenseQuery>;
export type GetWorkspaceTeamsQueryResult = Apollo.QueryResult<GetWorkspaceTeamsQuery, GetWorkspaceTeamsQueryVariables>;
export function refetchGetWorkspaceTeamsQuery(variables: GetWorkspaceTeamsQueryVariables) {
      return { query: GetWorkspaceTeamsDocument, variables: variables }
    }
export const GetWorkspaceUpdatesDocument = gql`
    query getWorkspaceUpdates($workspaceId: Hashid!) {
  workspace(id: $workspaceId) {
    id
    slug
    feed {
      ...UpdateDataWithTarget
    }
  }
}
    ${UpdateDataWithTargetFragmentDoc}`;

/**
 * __useGetWorkspaceUpdatesQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceUpdatesQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceUpdatesQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>(GetWorkspaceUpdatesDocument, options);
      }
export function useGetWorkspaceUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>(GetWorkspaceUpdatesDocument, options);
        }
export function useGetWorkspaceUpdatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>(GetWorkspaceUpdatesDocument, options);
        }
export type GetWorkspaceUpdatesQueryHookResult = ReturnType<typeof useGetWorkspaceUpdatesQuery>;
export type GetWorkspaceUpdatesLazyQueryHookResult = ReturnType<typeof useGetWorkspaceUpdatesLazyQuery>;
export type GetWorkspaceUpdatesSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceUpdatesSuspenseQuery>;
export type GetWorkspaceUpdatesQueryResult = Apollo.QueryResult<GetWorkspaceUpdatesQuery, GetWorkspaceUpdatesQueryVariables>;
export function refetchGetWorkspaceUpdatesQuery(variables: GetWorkspaceUpdatesQueryVariables) {
      return { query: GetWorkspaceUpdatesDocument, variables: variables }
    }
export const WorkspaceFeatureUpdatedDocument = gql`
    subscription workspaceFeatureUpdated($workspaceId: Hashid!) {
  workspaceFeatureUpdated(workspaceId: $workspaceId) {
    ...TaskListing
    description
    dependencies {
      id
      name
      status {
        ...StatusLabel
      }
    }
    dependentOn {
      id
      name
      status {
        ...StatusLabel
      }
    }
    followers {
      ...UserData
    }
  }
}
    ${TaskListingFragmentDoc}
${StatusLabelFragmentDoc}
${UserDataFragmentDoc}`;

/**
 * __useWorkspaceFeatureUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkspaceFeatureUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceFeatureUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceFeatureUpdatedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceFeatureUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkspaceFeatureUpdatedSubscription, WorkspaceFeatureUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkspaceFeatureUpdatedSubscription, WorkspaceFeatureUpdatedSubscriptionVariables>(WorkspaceFeatureUpdatedDocument, options);
      }
export type WorkspaceFeatureUpdatedSubscriptionHookResult = ReturnType<typeof useWorkspaceFeatureUpdatedSubscription>;
export type WorkspaceFeatureUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorkspaceFeatureUpdatedSubscription>;
export const WorkspaceIdeaUpdatedDocument = gql`
    subscription workspaceIdeaUpdated($workspaceId: Hashid!) {
  workspaceIdeaUpdated(workspaceId: $workspaceId) {
    ...IdeaDetail
  }
}
    ${IdeaDetailFragmentDoc}`;

/**
 * __useWorkspaceIdeaUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkspaceIdeaUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceIdeaUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceIdeaUpdatedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceIdeaUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkspaceIdeaUpdatedSubscription, WorkspaceIdeaUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkspaceIdeaUpdatedSubscription, WorkspaceIdeaUpdatedSubscriptionVariables>(WorkspaceIdeaUpdatedDocument, options);
      }
export type WorkspaceIdeaUpdatedSubscriptionHookResult = ReturnType<typeof useWorkspaceIdeaUpdatedSubscription>;
export type WorkspaceIdeaUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorkspaceIdeaUpdatedSubscription>;
export const WorkspaceUpdatedDocument = gql`
    subscription workspaceUpdated($workspaceId: Hashid!) {
  workspaceUpdated(workspaceId: $workspaceId) {
    ...WorkspaceListing
  }
}
    ${WorkspaceListingFragmentDoc}`;

/**
 * __useWorkspaceUpdatedSubscription__
 *
 * To run a query within a React component, call `useWorkspaceUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceUpdatedSubscription({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useWorkspaceUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<WorkspaceUpdatedSubscription, WorkspaceUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WorkspaceUpdatedSubscription, WorkspaceUpdatedSubscriptionVariables>(WorkspaceUpdatedDocument, options);
      }
export type WorkspaceUpdatedSubscriptionHookResult = ReturnType<typeof useWorkspaceUpdatedSubscription>;
export type WorkspaceUpdatedSubscriptionResult = Apollo.SubscriptionResult<WorkspaceUpdatedSubscription>;